const signUp = {
  HI: "Welcome to Healthnex",
  SIGN_UP_TO_JOIN_US: "Sign Up to Join Us",
  USER_PROFILE: "User Profile",
  LOGIN_CREDENTIALS: "Login Credentials",
  CONFIRM_PASSWORD: "Confirm Password",
  PLEASE_ENTER_YOUR_USERNAME: "Please enter your username",
  PLEASE_ENTER_YOUR_PASSWORD: "Please enter your password",
  PLEASE_CONFIRM_YOUR_PASSWORD: "Please confirm your password",
  PLEASE_ENTER_YOUR_EMAIL: "Please enter your email",
  PLEASE_ENTER_YOUR_PHONE:
    "Please enter your correct Australian phone number, eg. 0412345678",
  EG_PROFESSOR_OF_TRADITIONAL_CHINESE_MEDICINE:
    "Eg. Professional of Traditional Chinese Medicine",
  PLEASE_BRIEFLY_INTRODUCE_YOURSELF: "Please briefly introduce yourself",
  TRADITIONAL_CHINESE_MEDICINE_IS_A_DISCIPLINE_THAT_UTILIZES_NATURAL_PRINCIPLES_COMBINED_WITH_VARIOUS_PHYSIOLOGICAL_AND_PATHOLOGICAL_CHANGES_IN_THE_BODY:
    "EG: Traditional Chinese Medicine is a discipline that uses natural principles combined with various physiological and pathological changes in the body.",
  HERBAL_MEDICINE: "Herbal Medicine",
  SIGN_UP: "Submit & Sign Up",
  PURCHASE_AND_SIGN_UP: "Purchase and Sign Up",
  SIGN_UP_AS_PRACTITIONER: "Sign Up as Practitioner",
  USERNAME_ALLOW_U_TO_LOGIN_TO_HEALTHNEXT_PLS_DONT_START_WITH_NUMBER:
    "The username used to log in to Healthnex must not start with a number or shouldn't contains any spaces.",
  THIS_IS_A_VALID_USERNAME: "This username is available.",
  NO_CLINIC_NAME: "Unknown Clinic Name",
  IN_THIS_CLINIC_UR: "In this clinic, your are",
  MEMBER: "Clinic Member",
  IF_UR_MEMBER: "If you are a clinic member",
  IF_UR_OWNER: "If you are a clinic owner",
  WE_WILL_CREATE_THE_CLINIC_FOR_U:
    "All good! We will create this clinic for you.",
  OR_IF_NO_ANY_CLINIC_FROM_ABOVE:
    "The clinic you are looking for cannot be found?",
  THIS_BECUZ_THE_CLINIC_OWNER_MIGHT_NOT_CREATED_THE_CLINIC_IN_OUR_SYSTEM_YET:
    "This may be because the clinic owner has not yet created the clinic in our system.",
  PLS_CONTACT_THE_CLINIC_OWNER_TO_CREATE_THE_CLINIC_AND_INVITE_YOU_IN:
    "Please contact the clinic owner to create the clinic and invite you to join.",
  CONFIRM_PACKAGE: "Confirm Package",
  READ_AND_AGREE_TO_TERMS: "Read and Agree to Terms",
  SELECTED_PACKAGE: "Selected Package",
  SIGN_IN_MINI: "Sign In (Lite)",
  BYE: "Account has been logged out",
  U_DONT_HAVE_OWNED_CLINIC_PLS_GO_DESKTOP_VERSION_TO_CREATE_YOUR_OWN_CLINIC:
    "You don't have any owned clinics. Please go to desktop version to create your own clinic.",
  CLINIC_OWNER: "Clinic Owner",
  OWNER_DESCRIPTION:
    "If you are a clinic owner and would like to create a clinic on Healthnex to get started, please select this option.",
  MEMBER_DESCRIPTION:
    "If you are not a clinic owner and would like to join an existing clinic, or simply publish your personal website through Healthnex, please select this option.",
  PLEASE_INPUT_YOUR_CLINIC_ADDRESS: "Please input your clinic address",
  SELECT_ROLE: "Select Your Role",
  U_ARE: "If you are",
  SYSTEM_RECOMMEND_THE_BELOW_PACKAGE_WILL_BE_SUITABLE_FOR_YOU:
    "Healthnex has recommended a subscription plan that best suits your needs.",
  GET_X_MONTHS_FREE_NOW: "Get {{X}} months of free access now!",
  FREE_SUBSCRIPTION_OFFER_JOIN_NOW:
    "Enjoy full access to the subscription feature package at no cost for a limited time.",
  U_CAN_ALSO_JOIN_THE_EXISTING_CLINIC_AND_WORK_WITH_THEM_COOPERATIVE_IN_HEALTHNEX:
    "Alternatively, you may choose to join an existing clinic and collaborate within Healthnex.",
  ORIGINAL_PRICE: "Original Price",
  X_MONTHS_FREE_ACCESS: "{{X}} months free access",
  S_CLINIC: "'s Clinic",
  AGENT_INVITATION_TO_JOIN: "Invitation to Join from Agent",
  INVALID_AGENT_REF_KEY:
    "Invalid agent reference key, please contact your agent for further assistance.",
  VERIFYING_AGENT_REF_KEY: "Verifying agent reference key",
  PRESS_LEFT_AND_RIGHT_KEY_TO_SWITCH_CLINIC:
    "Press ← LEFT and RIGHT → key to switch clinic",
  PRESS_ENTER_KEY_TO_START_WORKING: "Press ⤶ ENTER key to start working",
  WELCOME_TO_HEATHNEXT_TO_START_PLS_TELL_ME_WHICH_ROLE_YOU_WANT_TO_PLACE:
    "Welcome to Healthnex 👋\nBefore we begin, tell us who you are.",
  UPLOAD_UR_PROFILE_PICTURE_HERE:
    "Upload a photo of yourself so others can recognize you more easily!",
  INCORRECT_PREV_PASSWORD: "Incorrect previous password, please re-enter it",
  PLEASE_LOGIN_USING_DESKTOP_VERSION_ENJOY_FULL_SERVICES:
    "Registration successful.Please log in to the Healthnex desktop version to access all features. Alternatively, you may continue with the mobile lite version to use basic functionality.",
  INDIVIDUAL_BUSINESS: "Individual Practice",
  INDIVIDUAL_BUSINESS_DESCRIPTION:
    "If you operate as an individual practice, you can create your own clinic and you can also invite other staff to join in later.",
  PLEASE_INPUT_YOUR_BUSINESS_OR_HOME_ADDRESS:
    "Please enter your business address (if applicable) or home address.",
};

const navigation = {
  PRACTITIONER: "Practitioner",
  PRACTITIONER_PORTAL: "Practitioner Portal",
  HOME: "Home",
  ABOUT_US: "About Us",
  PARTNERS: "Partners",
  MEMBER_SERVICE: "Member Service",
  CPD_TRAINING: "CPD Activity",
  TRAINING_AND_COURSES: "Training and Courses",
  EVENT: "Event",
  NEWS: "Latest News",
  BECOMING_MEMBER: "Become a Member",
  LOGIN_SIGNUP: "Login/Sign Up",
  ONLINE_PAYMENT: "Online Payment",
  DOWNLOAD_CENTER: "Downloads",
  AGREE_TO_USE_VAI_CLINIC_TEXT:
    "By Signing in, you agree to use  Clinic in accordance with the ",
  SIGN_IN: "Sign In",
  SIGN_OUT: "Sign Out",
  USERNAME: "Username",
  PASSWORD: "Password",
  FORGET_PASSWORD: "Forgot Password?",
  AND: " and ",
  PLEASE_ENTER_YOUR_USERNAME: "Please enter your username",
  PLEASE_ENTER_YOUR_PASSWORD: "Please enter your password",
  CLINIC: "Clinic",
  PRACTITIONER_PROFILE: "Practitioner Website",
  CONTACT_US: "Contact Us",
  GO_BACK: "Go Back",
  ADD_PATIENT: "Add a Patient",
  SELECT_CLINIC_TO_WORK: "Select Clinic to Work",
  SELECT_CLINIC: "Select Clinic",
  PRESCRIPTION_MEDICAL_HISTORY: "Prescription & Medical Record",
  LANDING_PAGE_UPDATED: "The current page has been set as the entry page",
  CHANGE_THIS_PAGE_AS_THE_ENTRY_PAGE:
    "Once this page is set as the entry page, it will be the first page displayed each time you access the system.",
  ENTRY_PAGE: "Entry Page",
  URL_LINK: "URL Link",
  URL_COPIED_TO_CLIPBOARD: "URL Copied to Clipboard",
  EMAIL_COPIED_TO_CLIPBOARD: "Email copied to clipboard",
  FAILED_TO_COPY_TO_CLIPBOARD:
    "Failed to copy to clipboard, please copy manually or switch to https",
  PROFILE_PAGE_QR_CODE: "{{X}} Profile Page QR Code",
  E_DAYS: " day(s)",
  PENDING_CLINIC_REQUESTS: "Pending clinic requests found",
  ARE_YOU_SURE_TO_SIGN_OUT: "Are you sure to sign out now?",
  APPOINTMENT_MINI: "Appointment",
  PRESCRIPTION_MINI: "Patient & Prescription",
  SHOW_MORE: "Show More",
  SHOW_LESS: "Show Less",
  BACK_TO_PATIENT_INFO: "Back to Patient Info",
  ADD_POINT: "Add Point",
  X_HAS_BEEN_ADDED: "{{X}} has been added",
  ALL_HERBS_IN_X_HAS_ADDED: "All herbs in {{X}} has been added",
  UR_CLINIC_PACKAGE_PERMISSION_CHANGED: "Clinic working permission updated",
  UR_CLINIC_PACKAGE_PERMISSION_CHANGED_DESCRIPTION:
    "Your access permissions in the current clinic have been updated.",
  UR_CLINIC_ROLE_PERMISSION_CHANGED: "Your permissions in this clinic have changed",
  UR_CLINIC_ROLE_PERMISSION_CHANGED_DESCRIPTION:
    "Your role/permissions in the current clinic have changed. See the details below.",
  PERMISSION_DIFF_VS_BEFORE_HINT: "Showing how your permissions differ from before the change.",
  PERMISSION_CHANGE_AUTO_REFRESH_HINT: "This page will refresh automatically in 3 seconds",
  GOT_IT: "I Got it",
  CONFIGURE_U_WORKTIME:
    "Configure your working time, Healthnex will automatically generate timeslots based on your schedule working time for appointments",
  MANAGE_UR_APPOINTMENTS:
    "You can manage your appointments within the system. External patients may also book appointments via the Healthnex website or your personal profile page (if this feature is enabled).",
  PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION:
    "You can manage patient information and medical records for your clinic, and issue prescriptions for your patients.",
  AI_FUNCTION:
    "You can benefit from the AI assistant, such as translating information and summarizing your consultation process.",
  U_CAN_EASILY_CUSTOMISED_PUBLISH_YOUR_PERSONAL_WEBSITE_TO_THE_PUBLIC:
    "You can highly customize your personal website and publish it online to increase your visibility and reach a wider audience.  ",
  UR_CLINIC_HAS_REMOVED_PACKAGE_FROM_U:
    "Your clinic has removed your package. If this does not match your expectations, please contact the clinic owner.",
  IF_UNEXPECTED_PLS_CONTACT_THE_CLINIC_OWNER:
    "If this is unexpected, please contact the clinic owner.",
  NEW_VERSION_AVAILABLE: "New Version Available",
  NEW_VERSION_DESCRIPTION:
    "An improved version of Healthnex is available. Please click the button below to refresh the page to complete the upgrade.",
  REFRESH_AND_UPGRADE: "Refresh and Upgrade",
  SYSTEM_REDIRECTING: "System Redirecting",
  SWITCHING_CLINIC: "Switching Clinic",
  UPDATING_PROFILE: "Updating Profile",
  UPLOADING_AVATAR: "Upload Profile Image",
  UPDATING_PASSWORD: "Updating Password",
  CURRENT_PASSWORD: "Current Password",
  DASHBOARD: "Dashboard",
};

const prescription = {
  CLEAR_SEARCH: "Clear",
  PRESCRIPTION: "Medical Record",
  PATIENT_PRESCRIPTION: "Patient's Medical Record",
  DOCTOR_PRESCRIPTION: "Doctor Prescription",
  NO_PRESCRIPTION_FOUND: "No Prescription Found",
  NO_PREVIOUS_HISTORY: "No Previous Record",
  PRESCRIPTION_NOT_FOUND: "Prescription Not Found",
  "EDIT_NOW_HISTORY_#X": "Editing Medical Record #{{X}} Now",
  EDITING_NOW: "Editing Now",
  NO_ENGLISH_ENTRY: "No English Entry",
  NO_CHINESE_ENTRY: "No Chinese Entry",
  ENGLISH_CONTENT: "English Content",
  CHINESE_CONTENT: "Chinese Content",
  CASE_ID: "Case ID",
  DATE: "Date",
  CREATED_BY: "Created By",
  PAYMENT_STATUS: "Payment Status",
  ACTION: "Action",
  NOT_PAID: "Not Paid",
  PAID: "Paid",
  CARD_ONLINE: "Card Online",
  CARD_OFFLINE: "Card Offline",
  CASH: "Cash",
  HICAPS: "HICAPS",
  CONNECTING_TO_HICAPS_TERMINAL: "Connecting to HICAPS terminal...",
  HICAPS_TERMINAL_CONNECTED: "Connected to HICAPS terminal",
  HICAPS_TERMINAL_CONNECTION_FAILED: "Failed to connect to HICAPS terminal",
  RETRY: "Retry",
  RESUBMIT: "Resubmit",
  SUBMITTING: "Submitting...",
  HICAPS_TERMINAL_SERVER_NOT_CONFIGURED: "This clinic's HICAPS terminal has no server address configured — please contact an administrator.",
  HICAPS_CHARGE_NOT_SUBMITTED_TITLE: "Payment charged but not submitted",
  HICAPS_CHARGE_NOT_SUBMITTED_DESCRIPTION: "The HICAPS terminal already charged this amount, but saving it to the record failed. Resubmit to finish saving it — this will not charge the terminal again.",
  CONFIRM_REFUND_TITLE: "Refund via HICAPS?",
  CONFIRM_REFUND_DESCRIPTION: "This will reset the record back to unpaid. The following will be refunded:",
  CONFIRM_REFUND_ITEM_REBATE: "The health fund claim will be cancelled",
  CONFIRM_REFUND_ITEM_BALANCE: "The balance payment will be refunded",
  CONFIRM_REFUND: "Confirm Refund",
  CONFIRM_REFUND_SCOPE_FULL: "Full Refund",
  CONFIRM_REFUND_SCOPE_FULL_DESCRIPTION: "Cancel the health fund claim and refund the balance payment",
  CONFIRM_REFUND_SCOPE_BALANCE_ONLY: "Balance Only",
  CONFIRM_REFUND_SCOPE_BALANCE_ONLY_DESCRIPTION: "Only refund the balance payment — the health fund claim is left as is",
  REFUND_CLAIM_CANCEL_SUCCESS_PROCESSING_BALANCE: "Claim cancelled successfully. Now processing the balance refund...",
  HICAPS_PRICE_LOCK_WARNING: "Once Hicaps is selected, this record's pricing can no longer be edited afterward.",
  SELECT_PROVIDER: "Select a provider",
  SEARCH_PROVIDER_NAME: "Search by name",
  SELECT_MERCHANT: "Select a merchant",
  HEALTH_FUND_REBATE: "Health Fund Rebate",
  BALANCE_PAYMENT: "Balance Payment",
  PROCESSING_REBATE_PAYMENT: "Processing health fund rebate payment",
  PROCESSING_BALANCE_PAYMENT: "Processing balance payment",
  PROVIDER_USED_FOR_BOTH_STEPS: "This provider will be used for both the rebate and the balance payment",
  WAITING_FOR_PAYMENT: "Waiting for Payment",
  PLEASE_TAP_CARD_ON_TERMINAL: "Please ask the patient to tap, insert or swipe their card on the HICAPS terminal now",
  FINALIZING_PAYMENT: "Finalising the payment",
  SAVING_INSURANCE_RECORD: "Saving the rebate record",
  HICAPS_ZERO_AMOUNT_HINT: "HICAPS isn't available for a $0 amount",
  HICAPS_PAYMENT_LOCKED_TITLE: "Paid via HICAPS",
  HICAPS_PAYMENT_LOCKED_DESCRIPTION: "This record was paid through the HICAPS terminal, so pricing can no longer be edited. To make changes, request a refund first — once the refund is processed, this record will return to unpaid.",
  HICAPS_PAYMENT_LOCKED_DESCRIPTION_SHORT: "Paid via HICAPS — request a refund to edit pricing again",
  COMPLETE: "Complete",
  REFUND: "Refund",
  UNPAID: "Unpaid",
  MARK_AS_PAID: "Mark as paid",
  MARK_REBATE_AS_PAID: "Mark rebate as paid",
  MARK_REBATE_AS_PAID_WARNING: "This will update the rebate's HICAPS payment status to paid. Only use this if the HICAPS payment actually went through on the terminal but the system failed to show it as paid.",
  HICAPS_PAY_IN_FULL: "Pay in full via HICAPS",
  HICAPS_PAY_PARTIAL: "Split with another method",
  HICAPS_AMOUNT_TO_PAY: "Amount to pay via HICAPS",
  HICAPS_PARTIAL_AMOUNT_MUST_BE_LESS_THAN_BALANCE: "Must be more than $0 and less than the total balance",
  REMAINING_AMOUNT_X: "Remaining ${{X}} will be charged separately",
  CONNECT_HICAPS_TERMINAL: "Connect to HICAPS terminal",
  REFUND_STEP_REBATE: "Cancelling the rebate claim",
  REFUND_STEP_BALANCE: "Refunding the balance payment",
  REFUND_STEP_ROLLBACK: "Updating the record's payment status",
  REFUND_STEP_REBATE_ROLLBACK: "Updating the rebate's payment status",
  REFUND_STEP_REBATE_ROLLBACK_SHORT: "Rebate Status",
  REFUND_STEP_REBATE_SHORT: "Rebate Claim",
  REFUND_STEP_BALANCE_SHORT: "Balance Payment",
  REFUND_STEP_ROLLBACK_SHORT: "Payment Status",
  REFUND_SUCCESSFUL: "Refund successful",
  REFUND_FAILED: "Refund failed, please try again",
  PROCESSING_WITH_HICAPS_TERMINAL: "Processing with HICAPS terminal...",
  HICAPS_TRANSACTION_SUCCESSFUL: "HICAPS transaction successful",
  HICAPS_TRANSACTION_FAILED: "HICAPS transaction failed, please try again",
  HICAPS_REBATE_COMPLETED: "Rebate completed via HICAPS",
  FILTER_BY_DATE: "Filter By Date",
  SELECT_DEFAULT_DATE_RANGE: "Select Default Date Range",
  SELECT_CUSTOM_DATE_RANGE: "Select Custom Date Range",
  LAST_ONE_YEAR: "Last One Year",
  LAST_ONE_MONTH: "Last One Month",
  LAST_THREE_MONTHS: "Last Three Months",
  ROWS_PER_PAGE: "Rows Per Page",
  MORE_INFORMATION: "More Information",
  AGE: "Age",
  PRESCRIPTION_FORM: "Prescription Form",
  CREATE_CASE: "Create Case",
  CREATE_CASE_FAILED: "Failed to create case, please try again",
  SELECT_OPTIONS: "Select Options",
  CLICK_TO_RECORD: "Click to Record",
  PRESS_TO_RECORD: "Press to Record",
  TRANSLATE_TO_X: "Translate to {{X}}",
  COMPLAINTS_SYMPTOMS: "Complaints & Symptoms",
  PAST_DISEASE: "Past Disease",
  FAMILY_DISEASE_HISTORY: "Family Disease History",
  ALLERGY: "Allergy",
  ALLERGEN: "Allergen",
  CURRENT_MEDICINE_TAKEN: "Current Medicine Taken",
  SIGNS_DIAGNOSIS: "Signs and Diagnosis",
  ATTACHMENT: "Attachment",
  REMARKS: "Remarks",
  CLICK_DRAG_TO_UPLOAD: "Click or Drag to Upload",
  NO_ATTACHMENT_FOUND: "No Attachment Added",
  TREATMENT_PLAN: "Treatment Plan",
  PATIENT_ADVICES: "Patient Advices",
  PROCEED_TO_PAYMENT: "Proceed to Payment",
  PROCEED_TO_TREATMENT: "Proceed to Treatment",
  MEDICINE: "Medicine",
  PRESCRIBE_MEDICATION_TO_THE_PATIENT: "Prescribe Medicine to the Patient",
  PRESCRIBE_ACUPUNCTURE_TO_THE_PATIENT:
    "Provide Acupuncture Treatment to the Patient",
  PRESCRIBE_MASSAGE_TO_THE_PATIENT: "Provide Massage Treatment to the Patient",
  PRESCRIBE_REMEDIAL_MASSAGE_TO_THE_PATIENT:
    "Provide Remedial Massage Treatment to the Patient",
  SELECT: "Select",
  MODALITY: "Modality",
  MEDICINE_TREATMENT_NAME: "Medicine Treatment Name",
  PREVIOUS_STEP: "Previous Step",
  PATIENT_HERB_HISTORY: "Patient Herb History",
  APPLY: "Apply",
  HERB: "Herb",
  RAW: "Raw (g)",
  GRAN: "Gran (g)",
  TOTAL: "Total",
  FORMULA: "Formula",
  CLASSICAL: "Herb Formula",
  SINGLE_HERB: "Single Herb",
  TYPE: "Type",
  SELECT_HERBS: "Select Herbs",
  SEARCH_CLASSICAL_FORMULA: "Search Herb Formula",
  PLEASE_SEARCH_BY_NAME: "Please search by name",
  CANCEL_SEARCH: "Cancel Search",
  ADD_ALL_HERBS_IN_FORMULA: "Add All Herbs in Formula",
  X_HERBS_INCLUDED: "{{X}} Herbs Included",
  FILL_IN_THE_DOSAGE: "Fill in the Dosage",
  HERBS_ADDED: "Herbs Added",
  PLS_SELECT_HERB_FROM_HISTORY_OR_FORMULA:
    "Please select herb from history or formula",
  GRAMS_DAILY: "Grans",
  DAILY_TOTAL: "Daily Total",
  DAYS: "Days",
  TOTAL_GRANS: "Total Grans",
  TOTAL_RAW: "Total Raw",
  DAILY_GRANS: "Daily Grans",
  DAILY_RAW: "Daily Raw",
  DOSAGE_INSTRUCTION: "Treatment Instruction",
  DOSAGE: "Dosage",
  NO_OF_REPEATS: "Dosage Frequency (Days)",
  DOSAGE_DAYS: "Dosage Days",
  TO_BE_DISPENSED_AFTER: "To be dispensed after",
  WEEK: "Week",
  RAW_HERBS: "Raw Herbs",
  HERBS_EXTRACT: "Herbs Extract",
  HERBAL_MEDICATION: "Herbal Medicine",
  EXTERNAL: "External",
  HERB_BOIL_GUIDE: "Herb Boil Guide",
  SECOND_BOIL_REQUIRED: "Second Boil Required",
  FIRST_BOILS: "First Boils",
  NO_CUP_WATER: "No. of Cup Water",
  BOIL_TIME: "Boil Time",
  NO_CUPS_REMAINS: "No of Cups Remains",
  MIN_BOIL_TIME: "Minimum Boil Time (Mins)",
  PLEASE_ENTER_NUMBER: "Please enter number",
  SELECT_POINT: "Select Point",
  X_HISTORY: "{{X}} History",
  POINT: "Point",
  X_GROUP: "{{X}} Group",
  POINT_GROUPS: "Point Groups",
  ORDER: "Order",
  SINGLE_POINT: "Single Point",
  REVIEW_THE_POINTS: "Review the Points",
  PLS_SELECT_POINT_FROM_HISTORY_OR_GROUP:
    "Please select point from history or group",
  DROP_HERE: "Drop Here",
  X_INSTRUCTION: "{{X}} Instruction",
  DURATION: "Duration",
  PLS_ENTER_THE_DURATION: "Please enter the duration",
  PRECAUTION: "Precautions / Note / Medical Advice",
  FILL_IN_PRECAUTION: "Fill in the precautions / note / medical advice",
  MAS_TECHNIQUE: "Technique",
  PLS_ENTER_THE_PRECAUTION: "Please enter the precautions / note / medical advice",
  POINTS_ADDED: "Points Added",
  VIEW_COPIED_POINTS: "View Points Added from Previous Record",
  VIEW_COPIED_HERBS: "View Herbs Added from Previous Record",
  HERB_RAW_SHORT: "Raw",
  HERB_GRAN_SHORT: "Gran",
  PAYMENT: "Payment",
  FILL_IN_THE_PAYMENT_DETAILS: "Fill in the Payment Details",
  SUBTOTAL: "Subtotal",
  OTHER_FEE: "Other Fee",
  DIAGNOSIS_FEE: "Treatment Fee",
  DISCOUNT_FEE: "Discount",
  FEE: "Fee",
  TOTAL_AMOUNTS: "Total Amounts",
  CASH_OR_CARD_OFFLINE_AMOUNT: "Cash / Card Offline Amount",
  INITIAL_VISIT: "Initial Visit",
  FOLLOW_UP: "Follow-up",
  ADD_FEE: "Add Fee",
  FEE_LABEL: "Fee Name",
  PLEASE_ENTER_LABEL: "Please enter label",
  FEE_AMOUNT: "Fee Amount",
  PLEASE_ENTER_AMOUNT: "Please enter amount",
  FEE_LABEL_ALREADY_EXISTS: "A fee with this name already exists",
  FEE_AMOUNT_MUST_BE_POSITIVE: "Amount cannot be negative",
  MEDICAL_REBATE: "Medical Rebate",
  MEDICAL_FUNDS_OF_PATIENT: "Use Medical Funds of Patient",
  REBATE_AMOUNT: "Insurance Rebate Amount",
  ANY_DISCOUNT: "Any Discount",
  PENDING_PAYMENT_AMOUNT: "Pending Payment Amount",
  PAYMENT_METHOD: "Payment Method",
  DISCOUNT_AMOUNT: "Discount Amount",
  FINISH_PAYMENT: "Finish Payment",
  PLEASE_ENTER_YOUR_CARD_DETAILS_BELOW_TO_COMPLETE_YOUR_PURCHASE:
    "Please enter your card details below to complete your purchase",
  PAYMENT_FAILED_PLEASE_TRY_AGAIN: "Payment failed. Please try again",
  X_TRIES_LEFT: "{{X}} tries left",
  TOTAL_AMOUNT_CANNOT_BE_NEGATIVE: "Total amount cannot be negative",
  PAY_NOW: "Pay Now",
  YOUR_PAYMENT_HAS_BEEN_SUCCESSFULLY_PROCESSED:
    "Your payment has been successfully processed",
  SYSTEM_REDICTING: "System is redirecting...",
  SURCHARGE_WILL_BE_INCLUDED: "Surcharge Included",
  PROCESSING_PAYMENT: "Processing Payment",
  LAST_MODIFIED_AT: "Last Accessed At",
  PAY: "Pay",
  NEXT: "Next",
  PRINT_RECEIPT: "Download Receipt",
  SEND_RECEIPT_TO_PATIENT: "Send receipt to patient",
  SEND_TO_PATIENT_VIA_EMAIL_WITH_RECEIPT_ATTACHED:
    "Send the bill to the patient's email by email",
  PATIENT_EMAIL: "Patient email address",
  RECIPIENT_EMAIL: "Recipient email",
  EMAIL_SENT_TO_X: "Email sent to: {{X}}",
  SEND: "Send",
  SENDING_EMAIL: "Sending email",
  PRINT_MEDICAL_RECORD: "Download Medical Record",
  GENERATING: "Generating",
  NO_MEDICAL_HISTORY_FOUND: "No Medical Record Filled Out",
  NO_TREATMENTS_INCLUDED: "No Treatments Included",
  TREATMENT: "Treatment",
  TREATMENTS: "Treatments",
  VIEW_X_INSTRUCTION: "View {{X}} Instruction",
  X_SURCHARGE_AMOUNT: "{{X}} Surcharge Amount",
  DISCOUNT: "Discount",
  COLLAPSE_ALL: "Collapse All",
  EXPAND_ALL: "Expand All",
  VIEW_DOSAGE_INSTRUCTION: "View Dosage Instruction",
  NO_TREATMENTS_INCLUDED: "No Treatments Included",
  FINISH: "Summary",
  X_OPTIONS: "{{X}} Options",
  FULL_CONTENT_MODE: "Easy Mode",
  HAS_BEEN_ADDED: " has been added",
  ALL_HERBS_IN_FORMULA_HAS_ADDED: "All herbs in formula has been added",
  CLASSICAL_FORMULA: "Herb Formula",
  PLS_ENTER_NUMBER: "Please enter number",
  SEARCH_CLASSICAL_FORMULA_BY_NAME: "Search Formula by name",
  SEARCH_CLASSICAL_FORMULA_HERB_BY_NAME:
    "Search Classical Formula & Herb by name",
  SEARCH_HERB_BY_NAME: "Search Herb by name",
  REMOVE_TREATMENT: "Remove Treatment",
  ARE_YOU_SURE_TO_REMOVE: "Are you sure to remove",
  SECOND_BOILS: "Second Boils",
  MIN_BOILING: "Minutes of Boiling",
  X_POINTS_INCLUDED: "{{X}} Points Included",
  ADD_ALL_POINTS_IN_FORMULA: "Add all points in group",
  SEARCH_POINT_GROUPS_BY_NAME: "Search Point Groups by name",
  SEARCH_POINT_GROUPS_POINT_BY_NAME: "Search Point Groups & Points by name",
  SEARCH_POINT_BY_NAME: "Search Point by name",
  ALL_POINTS_IN_FORMULA_HAS_ADDED: "All points in group has been added",
  THIS_TREATMENT_HAS_NO_PRICE_OR_PRICE_ZERO:
    "This treatment has no price or price is zero",
  PAYMENT_CHANNEL_EXPIRED_PLS_RELOAD_PAGE:
    "Payment channel has expired, please reload the page",
  ENTER_FEE_AMOUNT: "Enter Fee Amount",
  NO_TREATMENT_INCLUDED_IN_THIS_PRESCRIPTION:
    "No Treatment included in this Prescription",
  PLEASE_SELECT_TREATMENT_TO_PROCEED:
    "Please select a modality to proceed treatment",
  ADD_TREATMENT: "Add Treatment",
  MORE: "More",
  HAS_REMOVED: " has been removed",
  ATTACHMENT_UPLOADED: "Attachment uploaded",
  REMOVE_ATTACHMENT: "Remove Attachment",
  ARE_YOU_SURE_TO_REMOVE_THIS_FILE: "Are you sure to remove this file?",
  ATTACHMENT_REMOVED: "Attachment removed",
  LAST_SIX_MONTHS: "Last 6 Months",
  INPUT_TOTAL_COST_HERE: "Input treatment cost here",
  EDIT_PATIENT_INFO: "Edit Patient Info",
  ARE_YOU_SURE_TO_CLEAR_ALL_CONTENT_IN_THIS_FIELD:
    "Are you sure to clear all content written below?",
  CLEAR_CONFIRM: "Clear Confirm",
  DUPLICATE_MEDICAL_HISTORY: "Copy Record",
  ARE_YOU_SURE_TO_DUPLICATE_THIS_MEDICAL_HISTORY:
    "You are tend to copy the selected medical record",
  YOU_WILL_GET_A_NEW_MEDICAL_HISTORY_WITH_PREFILLED_DATA_FROM_LAST_RECORD:
    "You will get a new medical record with prefilled data SAME as your selected medical record",
  ARE_YOU_SURE_TO_DELETE_MEDICAL_RECORD:
    "Are you sure to delete this medical record",
  PATIENT_HISTORY_COPIED: "Patient history copied",
  DELETE_SUCCESS: "Delete Success",
  ADD_ASSISTANT_EXAMINATION: "Add auxiliary examination",
  ADD_NOW: "Add now",
  RESULT_PREVIEW: "Preview",
  AUXILIARY_TEST: "Auxiliary test",
  TEST_NAME: "Test name",
  TEST_DATE: "Test date",
  ATTACHMENTS: "Attachments",
  SELECT_PHOTO_PDF: "Select photo/PDF",
  TAKE_PHOTO_OR_SELECT_FILE: "Take photo / Select file",
  EXAMINATION: "Physical Findings",
  EXAMINATION_DESCRIPTION: "Description",
  INSPECTION: "Inspection (TCM visual diagnosis)",
  TONGUE_PHOTO: "Tongue photo",
  FACIAL_PHOTO: "Facial photo",
  INQUIRY: "Inquiry (TCM questioning)",
  INQUIRY_RECORD: "Inquiry Record",
  PULSE: "Pulse diagnosis",
  LISTEN_SMELL: "Listening & smelling diagnosis",
  BODY_TEMP: "Body temperature",
  BLOOD_PRESSURE: "Blood pressure",
  PULSE_RATE: "Pulse rate",
  BREATH_RATE: "Breathing rate",
  PERSONAL_OTHER: "Personal habits & others",
  ANY_ALLERGY: "Any allergy",
  IS_PREGNANT: "Is pregnant?",
  ALLERGY_DRUGS: "Drug allergy",
  ALLERGY_TRIGGERS: "Allergy triggers",
  STD: "STD history",
  PROMISCUITY: "Promiscuity",
  SMOKING: "Smoking",
  ALCOHOL_ABUSE: "Alcohol abuse",
  ADD_HISTORY: "Add past medical record",
  NO_DISEASES: "No past medical record",
  FAMILY_DISEASES: "Family history of disease",
  SYMPTOMS: "Symptoms",
  NO_SYMPTOMS_ADDED: "No symptoms added",
  MAIN_SYMPTOM: "Main symptom",
  SYMPTOM_DESCRIPTION: "Symptom Description",
  ONSITE_TIME: "Onset time",
  TIME_UNIT: "Time unit",
  RECURRENCE_TIME: "Recurrence time",
  EXACERBATION_TIME: "Exacerbation time",
  FREQUENCY_OF_OCCURRENCE: "Frequency of occurrence",
  FREQUENCY: "Frequency",
  ADD_MAIN_SYMPTOMS: "Add main symptoms",
  PREDISPOSITION: "Predisposing factor",
  ASSOCIATED_SYMPTOMS: "Associated symptoms",
  ARE_YOU_SURE_TO_DELETE_THIS_SYMPTOM: "Are you sure to delete this symptom?",
  DURATION: "Duration",
  ADD_ASSISTANT_EXAMINATION: "Add auxiliary examination",
  ADD_PAST_DISEASE: "Add past disease",
  OTHERS: "Others",
  PROCEED_TO_DIAGNOSIS: "Proceed to Diagnosis",
  UPDATE_SUCCESS: "Save Success",
  PREVIOUS_TREATMENT: "Symptom Description",
  ASSISTANT_EXAMINATION: "Assistant Examination",
  CLICK_TO_ADD: "Click to search and add",
  CLICK_TO_SELECT: "Click to search and select",
  PREVIOUS_HISTORY: "Previous medical record",
  PAST_DISEASE_DESCRIPTION: "Description",
  ADD_EVALUATION: "Add evaluation",
  TCM_ICD_CODE: "TCM ICD code",
  DETERMINATION_TCM: "TCM diagnosis name",
  SYNDROME: "TCM syndrome name",
  EVALUATION: "Diagnosis",
  DISCIPLINE_TREATMENT_OPTIONS: "Treatment principles and methods",
  ARE_YOU_SURE_TO_DELETE_THIS_RECORD: "Are you sure to delete this record?",
  BPM: "Per Min",
  SYSTOLIC: "Systolic",
  DIASTOLIC: "Diastolic",
  ADD_NEW_INSURANCE: "Add Medical Fund",
  PLZ_INPUT_INSURANCE_NO: "Please enter the membership no.",
  PLZ_INPUT_COMPANY_NAME: "Please enter the insurance company name",
  RESULT: "Result",
  VIEW_HISTORY: "View Prev. History",
  COLLAPSE_HISTORY: "Collapse History",
  COLLAPSE_INSTRUCTION: "Collapse Instruction",
  SHOW_DOSAGE_INSTRUCTION: "Edit Dosage Instruction",
  IT_LOOKS_LIKE_PATIENT_HAS_NOT_BEEN_CONSENTED_WITH_AGREEMENT_WITH_US:
    "It looks like the patient has not been consented with agreement with us",
  PLEASE_ASK_PATIENT_TO_SCAN_THE_QR_BELOW_SIGN_THE_CONSENT_FORM:
    "Please have the patient scan the QR code below to complete the consent form before starting the prescription process.",
  PLEASE_ASK_PATIENT_TO_SCAN_THE_QR_BELOW_SIGN_THE_CONSENT_FORM_SHORT:
    "The patient can scan the QR code below to complete the consent form",
  SIGN_CONSENT_FORM: "Sign Patient Consent Form",
  SIGNATURE_DATE: "Signature Date",
  PATIENT_FIRST_VISIT_ON: "First visit on",
  APPLY_DATE: "Apply",
  // THIS_PATIENT_WAS_CREATED_FROM_IMPORT_U_CAN_ASK_PATIENT_TO_SIGN_CONSENT: "This patient was imported and has not signed the consent form, but you may still proceed with the medical record.",
  THIS_PATIENT_WAS_CREATED_FROM_IMPORT_U_CAN_ASK_PATIENT_TO_SIGN_CONSENT:
    "This patient has not signed the consent form, but you may still proceed with the medical record.",
  PLEASE_CLICK_BUTTON_BELOW_AND_ASK_PATIENT_TO_SIGN_THE_CONSENT_FORM:
    "Please click the button below and ask the patient to sign the consent form.",
  CLICK_HERE_TO_SIGN_CONSENT: "Click here to sign the consent form",
  SIGN_NOW: "Sign Now",
  DOWNLOAD_EMPTY_CONSENT_FORM: "Print Empty Consent",
  CONSENT_FORM_UPLOADED: "Patient consent form uploaded",
  VIEW_CONSENT_FORM: "View Patient's Consent",
  UPLOAD_CONSENT_FORM: "Upload Patient Consent",
  REUPLOAD_CONSENT_FORM: "Re-Upload Consent",
  UPLOADING: "Uploading",
  UPLOAD: "Upload",
  IMPORTANT: "Not belong to any clinic yet",
  X_TREATMENT_NAME: "{{X}} Treatment Name",
  RECENT_PRESCRIPTIONS: "Recent Prescriptions",
  EDITED_IN: "Edited in: ",
  PHOTOS_AND_VIDEOS: "Photos & Videos",
  GENERATING_CONSENT_FORM: "Generating Consent Form",
  CANCELLED: "Cancelled",
  MORE_INFO_PLS_CHECK_MEDICAL_HISTORY_USING_DESKTOP:
    "Some pricing details were modified in a version not supported by the Lite version. Please use the desktop version to view full details.",
  UPDATING_PRICE: "Updating Price... Please try again",
  EDIT_PRESCRIPTION: "Edit Prescription",
  DIAGNOSIS_DATE: "Diagnosis Date",
  EDIT_DIAGNOSIS_DATE: "Edit Diagnosis Date",
  CHANGE_DIAGNOSIS_DATE_TO: "Change diagnosis date to",
  PAID_AT: "Paid At",
  PRESCRIPTION_DATE_UPDATED: "Diagnosis date updated",
  PAIN_LEVEL: "Pain Level",
  PAIN_TYPE: "Pain Type",
  NO_INFO_RECORDED: "No information recorded.",
  RECORD_NO: "Record No.",
  SAVE_AND_NEXT: "Save & Next",
  GUIDED_HINT_CONSULT_NOTES: "Record the patient's presenting complaint in their own words.",
  GUIDED_HINT_PAIN_TYPE: "Select all pain characteristics reported by the patient.",
  GUIDED_HINT_PAIN_LEVEL: "Rate the patient's current pain from 0 (none) to 10 (worst).",
  GUIDED_HINT_PAIN_CONDITIONS: "Add any related conditions, grouped by body system.",
  GUIDED_HINT_TODAYS_TREATMENTS: "Today's treatments",
  GUIDED_MODALITY_TAB_DESC: "Select a treatment card above to edit it, or add another treatment. The tabs document the selected treatment.",
  GUIDED_MISSING: "Missing",
  GUIDED_TREATMENT_OVERVIEW: "Overview",
  GUIDED_TREATMENT_DETAILS: "Treatment Details",
  GUIDED_HINT_OVERVIEW: "Review today's treatments, or select one to document.",
  GUIDED_HINT_TREATMENT_DETAILS: "Select areas and points, choose techniques, and set the duration.",
  GUIDED_HINT_TREATMENT_NOTE: "Record the treatment note and plan.",
  GUIDED_HINT_PRECAUTION: "Record any precautions or contraindications.",
  GUIDED_TAB_HELPER: "Select a tab above to move between documentation sections.",
  GUIDED_TAB_TOOLTIP: "Open this section",
  GUIDED_HINT_CHECKOUT: "Review fees, add any charges, and confirm payment.",
  GUIDED_CONFIRM_PAYMENT: "Confirm Payment",
  BODY_MAP: "Mark the affected areas on the body map.",
  GUIDED_HINT_MEDICAL_SAFETY: "Record allergies and pregnancy status before treatment.",
  GUIDED_HINT_UPLOAD_PHOTOS: "Attach photos relevant to this consultation.",
  GUIDED_HINT_MODALITY: "Review or add the treatments provided in this visit.",
  GUIDED_HINT_TREATMENT_POINTS: "Search and select the points used in this treatment.",
  GUIDED_HINT_TECHNIQUES: "Select the treatment areas and the manual techniques applied to each.",
  GUIDED_HINT_DURATION: "Enter the treatment duration and related notes.",
  GUIDED_HINT_OUTCOME: "Record how the patient responded to the treatment.",
  GUIDED_HINT_RECOMMENDATION: "Document advice and the recommended follow-up.",
  GUIDED_HINT_PAYMENT_FEE: "Confirm the fee for each treatment provided.",
  GUIDED_HINT_PAYMENT_OTHER: "Add any additional charges and review the total.",
  GUIDED_HINT_BODY_MAP: "Mark the affected areas on the body map.",
  // Guided-only display labels. Classic keeps its own wording; these never
  // affect item keys, sections, anchors or any API payload.
  GUIDED_LABEL_CHIEF_COMPLAINT: "Inquiry Record",
  GUIDED_LABEL_PAIN_CHARACTER: "Pain Type",
  GUIDED_LABEL_PAIN_SEVERITY: "Pain Level",
  GUIDED_LABEL_RELATED_CONDITIONS: "Pain Conditions",
  GUIDED_LABEL_AFFECTED_AREAS: "Affected Areas",
  GUIDED_LABEL_MEDICAL_SAFETY: "Allergy / Pregnancy",
  GUIDED_LABEL_ALLERGY: "Allergy",
  GUIDED_LABEL_ASSESSMENT_PHOTOS: "Upload Photos",
  GUIDED_LABEL_TREATMENT_OVERVIEW: "Treatment Overview",
  GUIDED_LABEL_TREATMENT_AREA_TECHNIQUE: "Treatment Area & Technique",
  GUIDED_LABEL_TREATMENT_POINTS: "Treatment Points",
  GUIDED_LABEL_TREATMENT_DURATION: "Treatment Duration",
  GUIDED_LABEL_TREATMENT_NOTE_PLAN: "Treatment Note & Plan",
  GUIDED_LABEL_PRECAUTIONS_ADVICE: "Precautions & Advice",
  GUIDED_LABEL_TREATMENT_OUTCOME: "Treatment Outcome",
  GUIDED_LABEL_FOLLOW_UP_RECOMMENDATION: "Follow-up Recommendation",
  GUIDED_LABEL_PAYMENT: "Payment",
  GUIDED_DOC_TITLE: "Clinical Documentation",
  GUIDED_X_OF_Y_REQUIRED_COMPLETED: "{{X}} of {{Y}} Required Completed",
  GUIDED_REQUIRED_MISSING_SUMMARY: "Required ({{X}}) items missing: ",
  GUIDED_OPTIONAL_MISSING_SUMMARY: "Optional ({{X}}) items missing: ",
  GUIDED_STEP_1_SYMPTOMS: "Step 1: Symptoms",
  GUIDED_STEP_2_TREATMENT: "Step 2: Treatment",
  GUIDED_STEP_3_PAYMENT: "Step 3: Payment",
  GUIDED_GROUP_SYMPTOMS: "Symptoms",
  GUIDED_GROUP_ASSESSMENT: "Assessment",
  GUIDED_GROUP_TREATMENT: "Treatment",
  GUIDED_GROUP_PAYMENT: "Payment",
  GUIDED_X_REQUIRED_REMAINING: "{{X}} required remaining",
  GUIDED_GROUP_COMPLETE: "Complete",
  GUIDED_GROUP_NOT_STARTED: "Not started",
  GUIDED_SAVE_AND_CONTINUE_TO_PAYMENT: "Save & Continue to Payment",
  GUIDED_SAVE_AND_SKIP_OPTIONAL: "Save & Skip Optional",
  GUIDED_SKIP_TOOLTIP: "Move on without completing this section",
  BODY_MAP: "Body Map",
  GST: "GST",
  RECEIPT: "Receipt",
  CLINICAL_RECORD: "Clinical Record",
  EXPAND_RECORD_PREVIEW: "Expand Record Preview",
  COLLAPSE_RECORD_PREVIEW: "Collapse Record Preview",
  DOC_CHECKLIST: "Documentation",
  CLICK_TO_TOGGLE_IMG: "Click to toggle image",
  CLICK_TO_TOGGLE_X: "Click to toggle image to {{X}}",
  IMG_FRONT: "Front",
  IMG_BACK: "Back",
  DEFAULT_SCALE: "Reset Scale",
  LOADING_IMG: "Loading Image",
  THIS_IMAGE_HAS_DETECTED_TO_BE_OLD_CANVAS_NEW_CANVAS_WILL_BE_APPLY_IN_NEXT_UPDATE:
    "The current image has been identified as an outdated version. The system will automatically switch to the latest image during your next update. Please note that point positions differ between versions, and re-marking will be required after the update.",
  NO_IMAGE_FOUND: "No Image Found",
  SELECTABLE_POINTS: "Points",
  NO_OF_PACKS: "No. of Herb Packs",
  PER_DAY: "Day(s)",
  "DOSAGE.PER_DAY": "Per Day",
  "DOSAGE.SHOW_DAILY": "Show Daily Dosage",
  PACKS: "Packs",
  HEALTH_CONDITION_RECORD: "Health Condition Record",
  AS_MYSELF: "As Myself",
  ON_BEHALF_OF: "On Behalf Of",
  ON_BEHALF_OF_X: "On Behalf Of: {{X}}",
  ON_BEHALF_OF_OTHERS: "On Behalf of Others",
  UPLOAD_PAYMENT_DOC: "Upload Payment Doc",
  PAYMENT_FILES: "Payment Files",
  SELECTED_HISTORY: "Selected History Record",
  PATIENT_NOT_FOUND: "Patient not found in this clinic",
  NEW_PATIENT_RECORD: "Prescription for New Patient",
  VIEW_EDIT: "View / Edit",
  FIND: "Find",
  SEARCH_BY_PATIENT_NAME_MOBILE: "Search by Patient Name/Phone",
  NO_BOOKINGS_FOUND: "No related appointments found",
  FILL_IN_TREATMENT_NOTE_PLAN: "Fill in Treatment Note / Plan",
  TREATMENT_NOTE_PLAN: "Treatment Note / Plan",
  DOWNLOAD_SELECTED_MEDICAL_RECORDS: "Download Selected Records",
  DOWNLOAD_ALL_CURRENT_MEDICAL_RECORDS: "Download All Current Records",
  DOWNLOAD_ALL_CONSENT_FORMS: "Download All Historical Consent Forms",
  ARE_YOU_SURE_TO_DOWNLOAD_SELECTED_MEDICAL_RECORDS: "Are you sure you want to download the selected medical records?",
  ARE_YOU_SURE_TO_DOWNLOAD_ALL_MEDICAL_RECORDS: "Are you sure you want to download all medical records?",
  UNPAID_MEDICAL_RECORDS_WILL_NOT_BE_DOWNLOADED: "Medical records with unpaid invoices will not be included in the download.",
  DATE_RANGE: "Date Range",
  NUMBER_OF_RECORDS: "Number of Records",
  ENTER_TREATMENT_NAME: "Enter treatment name",
  QUICK_SELECT: "Quick Select",
  SELECT_FROM_BODY_PART: "Select from Body Map",
  ADD_EDIT_METHOD_FROM_BODY_PART: "Edit Techniques from Selected Body Parts",
  EDIT_METHOD: "Edit Technique",
  NO_BODY_PART_HAS_BEEN_SELECTED: "No body parts were selected in the previous step.",
  GO_AND_EDIT_BODY_PART: "Go to Body Map to Select",
  CLICK_POINT_ON_IMAGE_TO_SELECT_METHOD: "Tap a circle to add techniques to that body part.",
  BACK_TO_TREATMENT: "Back to Treatment Step",
  CLICK_BODY_PART_TO_SELECT_TECHNIQUE: "Click a body part on the image to select techniques",
};

const search = {
  SEARCH: "Search",
  SEARCH_PLACEHOLDER: "Search",
  SEARCH_RESULT: "Search Result",
  NO_SEARCH_RESULT: "No Search Result",
  SEARCHING: "Searching",
  SEARCH_PATIENT: "Search Patient by name/email/phone",
  SEARCH_FOR_PATIENT_IN_TOP_SEARCH_BAR_OR_NEW_PATIENT_HERE:
    "Search for a patient below by their patient name, or add a new patient using the button on the left.",
  SEARCH_PATIENT_BY_NAME: "Search patient by name/email/phone/insurance number",
  NO_PATIENT_FOUND: "No patient found",
  SEARCHING_PATIENT: "Searching for patient",
};

const info = {
  DOB: "Birth Date",
  DATE_OF_BIRTH: "Birth Date",
  SELECT_PATIENT: "Select Patient",
  X_PRESCRIPTION_INFO: "{{X}}'s Prescription",
  VIEW_DETAILS: "View Details",
  "MEDICAL_HISTORY_#X": "Medical Record #{{X}}",
  LAST_MODIFIED_BY_X_AT_Y: "Last modified by {{X}} at {{Y}}",
  NEW_MEDICAL_HISTORY: "New Medical Record",
  NOT_SAVED_YET: "Not Saved Yet",
  SAVE_HISTORY: "Save History",
  PATIENT_INFO: "Patient Info",
  PATIENT_ID: "Patient ID",
  GENDER: "Gender",
  MALE: "Male",
  FEMALE: "Female",
  MEDICAL_HISTORY: "Medical Record",
  APPOINTMENT: "Appointment",
  NO_HISTORY_FOUND: "No History Found",
  DESCRIPTION: "Personal Description",
  COMPLAINTS_SYMPTOMS: "Complaints/Symptoms",
  DIAGNOSIS: "Diagnosis",
  TREATMENT: "Treatment",
  ENGLISH_CONTENT_GOES_HERE: "English content goes here",
  CN_CONTENT_GOES_HERE: "Chinese content goes here",
  EDITING: "Editing",
  SIGNS_DIAGNOSIS: "Signs and Diagnosis",
  TREATMENT_STRATEGIES: "Treatment Strategies",
  ACUPUNCTURE_POINTS_DURATION_METHODS:
    "Acupuncture Points, Duration and Methods",
  ALLERGY: "ALLERGY",
  THERAPEUTICAL_MASSAGE: "Therapeutical Massage",
  GUA_SHA: "Gua Sha",
  OTHER: "Other",
  REMARKS: "Remarks",
  TRANSLATE_FROM_X: "Translated from {{X}}",
  TRANSLATE_TO_X: "Translate to {{X}}",
  TRANSLATE: "Translate",
  CHINESE: "Chinese",
  ENGLISH: "English",
  THAI: "Thai",
  VIETNAMESE: "Vietnamese",
  X_CONTENT_GOES_HERE: "{{X}} content goes here",
  NAME_X: "Name ({{X}})",
  TRANSLATION_CONFIRM: "Translation Confirm",
  TRANSLATED_CONTENT_WILL_BE_APPLIED_OVERWRITE_UR_EXISTING_CONTENT:
    "Translated content will be applied and overwrite your existing content.",
  TRANSLATE_FROM_X_TO_Y: "Translated from {{X}} to {{Y}}",
  ARE_YOU_SURE_TO_TRANSLATE: "Are you sure to translate",
  INFO_FILLED: "Information saved",
  NO_DATA_FOUND: "No Data Found",
  FULL_CONTENT_X: "Full Medical Record: {{X}}",
  "UPDATE_HISTORY_#X": "Update Medical Record #{{X}}",
  EDIT_DESCRIPTION: "Edit Personal Description",
  EDIT_PATIENT: "Edit Patient",
  BASIC_INFO: "Basic Info",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  CONTACT_DETAIL: "Contact Detail",
  RESIDENTIAL_ADDRESS: "Residential Address",
  EMERGENCY_CONTACT_DETAIL: "Emergency Contact Detail",
  RELATIONSHIP: "Relationship",
  PATIENT_DISCLOSE: "Patient Disclose",
  GUARDIAN_NAME: "Guardian Name",
  GUARDIAN: "Guardian",
  GUARDIAN_CONTACT_NUMBER: "Guardian Contact Number",
  GUARDIAN_MOBILE: "Guardian Mobile",
  REFERRED_BY: "Referred By",
  NO_INSURANCE: "No Medical Fund",
  EMERGENCY_CONTACT_PERSON: "Emergency Contact Person",
  EMERGENCY_CONTACT_NUMBER: "Emergency Contact Number",
  INSURANCE_INFO: "Medical Fund Info",
  MORE_DETAILS: "More Details",
  INSURANCE_X: "Medical Fund {{X}}",
  COMPANY_NAME: "Company Name",
  INSURANCE_NO: "Membership No.",
  EXPIRY_DATE: "Expiry Date",
  ADD_INSURANCE: "Add Medical Fund",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
  RESPONSE: "Response",
  SELECT_TEMPLATE: "Select Website Template",
  ADD_TEMPLATE: "Add Template",
  EDIT_TEMPLATE: "Edit Mode",
  PUBLISH_WEBSITE: "Publish Website",
  VIEW_PUBLISHED_WEB: "Preview Published Website",
  TEMPLATE: "Template",
  INSURANCE: "Medical Fund",
  EXPIRED_IN: "Expired in",
  EXIT_EDIT: "Exit Edit",
  X_VERSION: "{{X}} Version",
  MAKE_APPOINTMENT: "Make Appointment",
  AI_TRANSLATE: "AI Translate",
  EDIT_TITLE: "Edit Title",
  EDIT_NAME: "Edit Name",
  EDIT_INTRODUCTION: "Edit Brief Description",
  ADD_SKILL: "Add Top Skill",
  SKILL: "Skill",
  AI_ENQUIRY: "AI Inquiry",
  EDIT_AVATAR: "Edit Profile Image",
  ADD_AVATAR: "Add Profile Image",
  EDIT_CLINIC: "Edit Clinic",
  MY_STRENGTHS: "My Strengths",
  STANDARD_TREATMENT: "Treatment Features",
  ACADEMIC: "Academic",
  PATIENT_REVIEW: "Patient Review",
  CLINIC_INFO: "Clinic Info",
  EDIT_STRENGTHS: "Edit Strengths",
  EDIT_TREATMENT: "Edit Treatment",
  EDIT_PROFILE_TREATMENT: "Edit Treatment Profile",
  DR_X_ARTICLE: "{{X}}'s Article",
  COURSES: "Courses",
  ARTICLES: "Articles",
  EDIT_COURSE: "Edit Course",
  UPLOAD_REVIEW_BG: "Upload Review Background Image",
  EDIT_REVIEW: "Edit Patient Review",
  PATIENT: "Patient",
  TITLE: "Professional Title",
  SAVE_SUCCESS: "Save Success",
  CLINIC_NAME: "Clinic Name",
  PIN_TO_DISPLAY: "Pin to Display",
  DELETE: "Delete",
  SUBURB: "Suburb",
  POSTCODE: "Postcode",
  STATE: "State",
  ADD: "Add",
  MOVE_DOWN: "Move Down",
  MOVE_UP: "Move Up",
  SPECIALITY: "Speciality",
  PUBLISHED: "Published",
  HIDDEN: "Hidden",
  READ: "Read",
  ADD_ARTICLE: "Add Article",
  SAVE: "Save",
  PUBLISH: "Publish",
  RE_UPLOAD_BG: "Re-Upload Background Image",
  PATIENT_NAME: "Patient Name",
  PATIENT_DESCRIPTION: "Patient Description",
  REVIEW: "Review",
  REUPLOAD_PROFILE_IMAGE: "Re-Upload Profile Image",
  COURSE: "Course",
  COURSE_TITLE: "Course Title",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  START_TIME: "Start Time",
  DURATION: "Duration",
  COURSE_TYPE: "Course Type",
  OFFLINE_COURSE: "Offline Course",
  ONLINE_COURSE: "Online Course",
  MEETING_URL: "Course Link",
  LOCATION: "Location",
  STRENGTH: "Strength",
  EXIT_PREVIEW: "Exit Preview",
  MY_PROFILE: "My Profile",
  PURE_HARMONY: "Clean and Professional Template",
  HERB_ESSENCE: "Fresh and Sophisticated Template",
  IM_WORKED_AT: " I'm working at",
  START_WORKING: "Start Working",
  TOOLBAR: "Toolbar",
  COLLAPSE_TOOLBAR: "Collapse Toolbar",
  EDIT_URL: "Edit URL",
  SLUG: "Slug",
  EDIT_SLUG: "Edit Profile Page URL",
  PUBLISH_CONFIRM: "Publish Confirm",
  UNPUBLISH_CONFIRM: "Unpublish Confirm",
  ARE_YOU_SURE_TO_X_WEBSITE: "Are you sure to {{X}} website?",
  WEBSITE_WILL_BE_PUBLISHED_AND_VISIBLE_TO_PUBLIC_VIA_BELOW_LINK:
    "Website will be published and visible to public via below link",
  WEBSITE_WILL_BE_UNPUBLISHED_AND_HIDDEN_FROM_PUBLIC:
    "Website will be unpublished and hidden from public",
  U_CAN_STILL_PUBLISH_THE_WSBSITE_LATE_IF_U_WISH:
    "You can still publish the website later if you wish",
  PUBLISH_S: "publish",
  UNPUBLISH_S: "unpublish",
  UNPUBLISH_WEBSITE: "Unpublish Website",
  UNPUBLISHED: "Unpublished",
  SWITCH_YOUR_TEMPLATE_PUBLISHED: "Select a new webpage template to publish.",
  CLOSE_EDITOR: "Close Editor",
  CLOSED: "Closed",
  REMOVE_SUCCESS: "Remove Success",
  VIEW_ALL_X_CLINICS: "View All {{X}} Clinics",
  CONTINUE: "Continue",
  ONLY_WORKING_WEEKDAY: "Only Working Weekday",
  WORKING_TIME: "Working Time",
  WORKING_IN_WHOLE_WEEK: "Working all Week",
  MONDAY: "Mon",
  TUESDAY: "Tue",
  WEDNESDAY: "Wed",
  THURSDAY: "Thu",
  FRIDAY: "Fri",
  SATURDAY: "Sat",
  SUNDAY: "Sun",
  WORKING_TODAY: "Set as Working Day",
  END_TIME: "End Time",
  APPLY_WORKING_TIME_TO_ALL_DAYS: "Apply Working Hours to All Days",
  ONLY_WORK_IN_WEEKDAYS: "Only Work in Weekdays",
  WORK_IN_WHOLE_WEEK: "Work all Week",
  CURRENT_WORKING_TIME_APPLIED_TO_ALL_DAYS:
    "Current working time has been applied to all days",
  DR_X_COURSE: "{{X}}'s Courses",
  DR_X_VIDEO: "{{X}}'s Videos",
  DELETE_ARTICLE: "Delete Article",
  ARE_YOU_SURE_TO_DELETE_ARTICLE: "Are you sure to delete this Article?",
  THIS_ACTION_CANNOT_BE_UNDONE: "This action cannot be undone",
  SAVE_ARTICLE: "Save Article",
  SAVE_ARTICLE_AND_PUBLISH: "Save Article and Publish",
  PUBISH_ARTICLE: "Publish Article",
  UNPUBLISH_ARTICLE: "Unpublish Article",
  PUBLISH_ARTICLE: "Publish Article",
  ARE_YOU_SURE_TO_X_ARTICLE: "Are you sure not to {{X}} article?",
  VISITORS_WILL_NOT_BE_ABLE_TO_VIEW_THIS_ARTICLE:
    "Visitors will not be able to view this article",
  VISITORS_WILL_BE_ABLE_TO_VIEW_THIS_ARTICLE:
    "Visitors will be able to view this article",
  UNPUBLISH: "Unpublish",
  REMOVE_BG_IMAGE: "Remove Background Image",
  ARE_YOU_SURE_TO_REMOVE_BG_IMAGE:
    "Are you sure to remove the background image?",
  BG_UPLOAD: "Upload the background image",
  DEFAULT_BG_WILL_BE_APPLIED: "Defalut background image will be applied",
  U_ARE_PREPARED_TO_TRANSLATE_UR_WEBSITE_CONTENT:
    "You are prepared to translate your website content",
  WARNING: "Warning",
  IF_YOU_HAVE_INPUTTED_ANY_TEXT_INTO_THE_LANGUAGE_YOU_SELECTED_WILL_BE_OVERWRITTEN:
    "If you have inputted any text into the language you selected will be overwritten",
  I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_TRANSLATE_USING_AI:
    "I understand the action and agree to translate using AI",
  ALL_7_DAYS: "All 7 Days",
  ARTICLE_TITLE: "Article Title",
  NO_WORKING_DAYS: "No Working Days",
  WEBSITE_PUBLISHED: "Website published",
  WEBSITE_UNPUBLISHED: "Website unpublished",
  TEMPLATE_SWITCHED_AND_PUBLISHED: "Template updated and published",
  TRANSLATING_X_PLS_BE_PATIENT: "Translating {{X}}. Please wait...",
  SAVING_TRANSLATION: "Saving translation. Please wait...",
  TOGGLE_LANGUAGE: "Switch Language",
  TRANSLATE_UR_WEBSITE_USING_AI: "Translate your website using AI...",
  ARTICLE: "Article",
  VIEW_PATIENT_HISTORY: "View Patient History",
  PRESCRIPTION_INFO: "Medical Record Info",
  TRANSLATE_FROM: "Translated from",
  TRANSLATE_TO: "Translated to",
  SWAP: "Swap",
  NO_WORKING_TIME_AVAILABLE: "No Working Time Available",
  MY_COLLEAGUES: "My Colleagues",
  DAILY_SHARING: "Daily Sharing",
  EDIT_MY_COLLEAGUES: "Edit My Colleagues",
  ADD_NEW_SHARING: "Add New Daily Sharing",
  EDIT_DAILY_SHARING: "Edit Daily Sharing",
  ADD_IMAGE: "Add Image",
  COLLEAGUE_DESCRIPTION: "Colleague Description",
  REUPLOAD: "Re-Upload",
  COLLEAGUE: "Colleague",
  PAY_THE_BALANCE: "Pay the Balance",
  PAYMENT_SUCCESSFUL: "Payment Successful",
  DELETE_DAILY_SHARING: "Delete Daily Sharing",
  ARE_YOU_SURE_TO_DELETE_THIS_DAILY_SHARING:
    "Are you sure to delete this daily sharing?",
  EDIT_VIDEO: "Edit Video",
  ADD_VIDEO: "Add Video",
  VIDEO: "Expert Sharing",
  COVER_IMAGE: "Cover Image",
  VIDEO_TITLE: "Video Title",
  VIDEO_DESC: "Video Description",
  WATCH: "Watch",
  DELETE_VIDEO: "Delete Video",
  ARE_YOU_SURE_TO_DELETE_THIS_VIDEO:
    "Are you sure you want to delete this video?",
  USED_BY_PHONE: "Using by phone",
  DISCONNECT_YOUR_PHONE_TO_TYPE_IN: "Disconnect your phone to type in",
  DISCONNECT: "Disconnect",
  CONTENT: "Content",
};

const notification = {
  CLINIC_SWITCHED_TO_X: "Current clinic has been switched to {{X}}",
  ONLY_IMAGE_FILES_ALLOWED: "You can only upload image files here",
  HISTORY_SAVED: "Medical record saved",
  TRANSLATION_COMPLETED: "Translation completed",
  "UPDATE_HISTORY_#X": "Update History #{{X}}",
  ARTICLE_TITLE_CANNOT_BE_EMPTY: "Article title cannot be empty",
  ARTICLE_UPDATED: "Article updated",
  ARTICLE_CREATED: "Article created",
  ARTICLE_PUBLISHED: "Article published",
  ARTICLE_UNPUBLISHED: "Article unpublished",
  ARTICLE_DELETED: "Article deleted",
  PREVIEW_TEMPLATE: "Preview Mode",
  U_R_IN_PREVIEW_MODE: "You are in preview mode",
  U_R_IN_EDIT_MODE: "You are in edit mode",
  PROFILE_IMAGE_UPLOADED: "Profile image uploaded",
  SAVE_SUCCESS: "Save success",
  INCORRECT_USERNAME_OR_PASSWORD: "Incorrect username or password",
  CLINIC_X_SELECTED: "Clinic {{X}} selected for work",
  AUTHENTICATION_EXPIRED: "Authentication expired! Please try re-login again",
  MAKE_AN_APPOINTMENT: "Make an appointment",
  APPOINTMENT_TIME: "Appointment Time",
  PHONE: "Phone",
  EMAIL: "Email",
  FIRST_NAME_IS_REQUIRED: "First name is required",
  LAST_NAME_IS_REQUIRED: "Last name is required",
  PHONE_IS_REQUIRED: "Phone is required",
  INVALID_PHONE_NUMBER: "Invalid phone number",
  INVALID_PHONE_FORMAT_SMS_WARNING: "Current number may affect SMS reception. Please use 04XXXXXXXX format to ensure SMS delivery.",
  PLEASE_FIX_ERRORS: "Please fix the errors",
  BOOKING_CREATED: "Booking created",
  FIRSTNAMEEN_IS_REQUIRED: "First name (English) is required",
  LASTNAMEEN_IS_REQUIRED: "Last name (English) is required",
  INVALID_EMAIL: "Invalid email",
  EMAIL_IS_REQUIRED: "Email is required",
  ADDRESS_IS_REQUIRED: "Address is required",
  LESS_DETAILS: "Less Details",
  REMOVE: "Remove",
  COMPANY_NAME_IS_REQUIRED: "Company name is required",
  INSURANCE_NUMBER_IS_REQUIRED: "Insurance number is required",
  CONFIGURATION: "Preference Configuration",
  SELECT_SECTION_U_ARE_GOING_TO_CONFIGURE:
    "Select the section you are going to configure",
  BUSINESS: "Business",
  CONFIGURE_BUSINESS_TIME: "Configure Business Time / Services Type",
  LANGUAGE: "Language",
  CURRENT_LANGUAGE_X: "Current Language: {{X}}",
  PATIENT_CREATED: "Patient created",
  PATIENT_EDITED: "Patient detail updated",
  CHECK_IN_SUCCESS: "Check in success",
  WHETHER_TO_DISPLAY_THIS_SECTION: "Whether to Display this Section",
};

const appointment = {
  APPOINTMENT_INFO: "Appointment Info",
  APPOINTMENT_STATUS: "Appointment Status",
  CHECKED_IN: "Checked In",
  CHECK_IN: "Check In",
  PROCEED_TO_MEDICAL_HISTORY: "Proceed to Medical Record",
  APPOINTMENT_CLINIC: "Appointment Clinic",
  NAME: "Name",
  U_MIGHT_LOOKING_FOR_PATIENT: "👀 Are you looking for patient below?",
  NO_RELAVANT_PATIENT_IN_CLINIC: "👀 It looks like no related patients were found in this clinic.",
  PLS_ADD_PATIENT_FIRST: "Do you want to add him/her to your clinic?",
  SELECT_EXISTING_PATIENT_FROM_CLINIC_TO_CREATE_MEDICAL_HISTORY:
    "Select patient from clinic to proceed in creating medical record",
  CREATE_MEDICAL_HISTORY: "Create Medical Record",
  NONE_OF_PATIENT_ABOVE_IS_CORRECT: "None of the patient above?",
  PENDING_CHECK_IN: "Booking Confirmed",
  PENDING_CHECK_IN_WAITING: "Waiting in Clinic",
  ARE_YOU_SURE_TO_CHECK_IN_THIS_APPOINTMENT_FOR_X:
    "Are you sure to check in to this appointment for {{X}}?",
  AFTER_CHECKED_IN_YOU_CAN_PROCEED_MEDICAL_HISTORY_FOR_THIS_PATIENT:
    "After checked in, you can proceed to create medical record for this patient.",
  LOADING_APPOINTMENT: "Loading Appointment",
  TODAY: "Today",
  REMEDIAL_MASSAGE: "Remedial Massage",
  MASSAGE: "Massage",
  ACUPUNCTURE: "Acupuncture",
  CHINESE_MEDICINE: "Chinese Medicine",
  APPROXIMATE_DURATION: "Approximate Duration",
  DURATION_MINUTES: "{{m}} min",
  DURATION_HOURS: "{{h}}h",
  DURATION_HOURS_MINUTES: "{{h}}h {{m}}min",
  VIEW_IN_SCHEDULE: "View in Schedule",
  APPROX: "Approx",
  BUSINESS_TIME: "Business Time",
  WORKING_SERVICES: "Working Services",
  WORKING_DAYS: "Working Days",
  WORKING_TIME_PERIOD: "Working Time Period",
  RESET: "Reset Changes",
  BLOCK_TIME_SLOTS: "Block Time Slots",
  APPLY_BLOCK_TIMES_TO_ALL_DAYS: "Apply Block Times to All Days",
  LOADING_TIME_SLOTS: "Loading Time Slots",
  NO_AVAILABLE_TIME: "No Available Time",
  RESET_CLINIC: "Reset Working Time Changes",
  SAVE_CHANGES: "Save Changes",
  CLINIC_NOT_FOUND: "Clinic Not Found",
  SAVE_CLINIC_SUCCESS: "Business time saved",
  PLEASE_SELECT_WORKING_SERVICES: "Please select working services",
  START_TIME_CANNOT_BE_AFTER_END_TIME: "Start time cannot be after end time",
  END_TIME_CANNOT_BE_BEFORE_START_TIME: "End time cannot be before start time",
  SELECTED_WEEKDAY: "Selected Weekday",
  MINUTES: "min",
  CLEAR_ALL: "Clear All",
  SELECT_ALL: "Select All",
  COPY_PRODUCTS_TO_OTHER_CLINIC: "Copy Products to Another Clinic",
  COPY_PRODUCTS_FROM_OTHER_CLINIC: "Copy Products from Another Clinic",
  ASSIGN_PRACTITIONERS_TO_IMPORTED: "Assign Practitioners to Imported Products",
  SELECT_SOURCE_CLINIC: "Select source clinic",
  X_PRODUCTS_IMPORTED_FROM_Y: "{{X}} product(s) have been imported from {{Y}}",
  COPY_TO_THIS_CLINIC: "Copy to This Clinic",
  SELECT_PRODUCTS_TO_COPY: "Select products to copy",
  SELECT_TARGET_CLINIC: "Select target clinic",
  SELECTED_X_OF_Y: "Selected {{X}} of {{Y}}",
  PRODUCTS_COPIED_SUCCESS: "Products copied to the target clinic",
  X_PRODUCTS_COPIED_TO_Y: "Selected {{X}} product(s) have been copied to {{Y}}",
  GO_TO_CLINIC_PRODUCTS: "Go to Clinic's Products Page",
  HIDE_PREVIEW: "Hide Preview",
  X_PRODUCTS_IN_THIS_CLINIC: "{{X}} product(s) in this clinic",
  CLICK_ON_TIMESLOT_THAT_YOU_DONT_WANT_IT_BE_AVAILABLE_FOR_APPOINTMENT:
    "Click to block the timeslot that you don't want it to be available for appointment",
  SELECT_WORKING_DAY: "Select Working Day",
  DECREASE_DURATION: "Decrease Duration",
  INCREASE_DURATION: "Increase Duration",
  CURRENT_BLOCK_TIME_APPLIED_TO_ALL_DAYS:
    "Current block time has been applied to all days",
  SAVE_AS_NOT_WORKING: "Save as Not Working",
  SAVE_AS_WORKING: "Save as Working",
  CONFIRM_CLEAR_BLOCK_TIMES: "Are you sure to clear all block times?",
  CHANGING_DURATION_WILL_CLEAR_ALL_BLOCK_TIMES:
    "Changing duration will clear all block times",
  CHANGING_WORKING_TIME_WILL_CLEAR_TODAY_BLOCK_TIMES:
    "Changing working time will clear today's block times",
  BLOCK_TIMES_CLEARED: "Block times cleared",
  SAVING: "Saving",
  BLOCK_THIS_TIMESLOT: "Block this timeslot",
  ACTIVE_THIS_TIMESLOT: "Active this timeslot",
  UNSAVED_CHANGES: "Unsaved Changes",
  SCHEDULE_CONFLICT: "Schedule Conflict",
  ALREADY_WORKING_IN_OTHER_CLINICS_ON_THESE_DAYS: "You're already scheduled in other clinics on the following days:",
  CONFIRM_TO_REPLACE_AND_SAVE: "Confirming will replace these days in the other clinics, then save your changes here.",
  YOU_HAVE_UNSAVED_CHANGES_CONTINUE:
    "You have unsaved changes. Are you sure you want to switch clinics and discard them?",
  DISCARD_AND_SWITCH: "Discard and Switch",
  YOU_HAVE_NO_CONFIGURE_YOUR_WORKING_TIME_IN_THIS_CLINIC:
    "You have no configure your working time in this clinic",
  CONFIGURE_WORKING_TIME: "My Working Hrs & Services",
  MY_WORKING_CLINICS: "My Working Clinics",
  ALL: "All",
  FILTER: "Filter",
  STATUS: "Status",
  REJECT: "Reject",
  DATE_OF_BIRTH_IS_REQUIRED: "Date of birth is required",
  INVALID_DATE: "Invalid date",
  DATE_CANNOT_BE_IN_FUTURE: "Date cannot be in the future",
  PATIENT_UPDATED_WARNING: "Patient Information Alert",
  SYSTEM_HAS_DETECTED_THE_FOLLOWING_CHANGES_TO_THIS_PATIENT:
    "The system has detected that the current patient information does not match the information provided in this booking info",
  DO_U_WANT_TO_UPDATE_THIS_PATIENT_INFO:
    "Would you like to update the patient information?",
  CURRENT_INFO: "Current Information",
  UPDATED_INFO: "Updated Information",
  QUICK_UPDATE: "Quick Update",
  DATE_SCHEDULE: "Date Schedule",
  NO_APPOINTMENT_FOUND: "No Appointment Found",
  INCOMING_BOOKINGS_ONLY: "Incoming Appointments Only",
  SELECT_HOUR: "Select Hour",
  SELECT_MINUTE: "Select Minute",
  SELECT_APPOINTMENT_TIME: "Select Appointment Time",
  X_APPOINTMENTS_SCHEDULED_FOR_THIS_DATE:
    "{{X}} appointments scheduled for this day",
  X_APPOINTMENTS_SECHEDULED_FOR_TODAY: "{{X}} appointments scheduled for today",
  THIS_SAVED_PATIENT_INCLUDES_INVALID_PHONE_NUMBER_THIS_MIGHT_BE_A_PROBLEM_RECEIVING_SMS_LATER:
    "Invalid phone number were detected for the current patient, which may affect the delivery of future SMS notifications.",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_PATIENT_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "Tip: When the appointment time is approaching, a reminder SMS will be sent to the patient.",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "Tip: When the appointment time is approaching, a reminder SMS will be sent to you",
  BOOKED_PRACTITIONER: "Booked Practitioner",
  U_CAN_MANAGE_UR_CLINIC_PRODUCT_HERE: "Manage your clinic products here",
  THESE_PRODUCTS_WILL_BE_USED_IN_PATIENTS_BOOKING_FROM_PUBLIC:
    "These products will be available for patients when booking appointments via the public booking system",
  THIS_NOTE_WILL_BE_SAVED_TO_NEW_PATIENT_PROFILE: "This note will be saved to the new patient profile.",
};

const clinicManagement = {
  CLINIC_SETTINGS: "Clinic Settings",
  CLINIC_MANAGEMENT: "Clinic & Member Management",
  SEARCH_CLINIC_IN_SEARCH_BAR_TO_JOIN_IN_OR_CREATE_NEW_CLINIC:
    "Search Clinic in Search Bar to Join or Create New Clinic",
  NO_CLOSED_CLINICS: "No Closed Clinics",
  NO_PENDING_CLINICS: "No Pending Clinics",
  SEARCH_CLINIC: "Search Clinic",
  ADD_CLINIC: "Create New Clinic",
  CLINIC_INFO: "Clinic Info",
  OWNER: "Owner",
  INVITE_PRACTITIONERS: "Invite Practitioners",
  INVITED: "Invited",
  NO_PRACTITIONER_FOUND: "No Practitioner Found",
  SUBMIT_CLINIC_INFO: "Submit Clinic Info",
  UPDATE_CLINIC_INFO: "Update Clinic Info",
  RESUBMIT_CLINIC_INFO: "Resubmit Clinic Info",
  ADDRESS: "Address",
  OPEN: "Opening",
  PENDING: "Pending",
  MY_CLINIC: "My Clinic",
  EDIT_CLINIC_INFO: "Edit Clinic",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  ASSOCIATED_PRACTITIONERS: "Associated Practitioners",
  NO_PHONE_NUMBER: "No Phone Number",
  PRACTITIONER_INFO: "Practitioner Info",
  SERVICES: "Services",
  WORK_TIME: "Work Time",
  WORKING_DAY: "Working Day",
  NOT_AVAILABLE: "Not Available",
  MINS: " mins",
  X_PRACTITIONERS_ARE_NOW_ACTIVE: "{{X}} Practitioners are Now Active",
  X_PRACTITIONERS_FOUND: "{{X}} Practitioner(s) in Total",
  NO_ACTIVE_PRACTITIONERS: "No Practitioners Found",
  NO_INACTIVE_PRACTITIONERS: "No Inactive Practitioners",
  INVITE_PRACTITIONERS: "Invite Practitioners",
  INVITE: "Invite",
  WORKING_IN_CLINIC: "Working in Clinic",
  QUIT_PRACTITIONER: "Quit Practitioner",
  QUIT_FROM_CLINIC: "Quit from Clinic",
  QUIT_CLINIC_CONFIRM: "Quit Clinic Confirm",
  QUIT_CLINIC_REQUEST_SENT: "Quit Clinic Request Sent",
  ARE_YOU_SURE_TO_QUIT_CLINIC: "Are you sure to quit this clinic",
  YOU_WILL_NOT_BE_ABLE_TO_BE_BOOKED_BY_PATIENT_FOR_THIS_CLINIC_ANYMORE:
    "After approved, you will not be able to be booked by patient for this clinic anymore",
  PENDING_APPROVE_TO_QUIT: "Pending Approve to Quit",
  PENDING_APPROVE_TO_JOIN: "Pending Approve to Join",
  JOIN_CLINIC: "Join Clinic",
  X_NEW_MEMBER_REQUESTS: "{{X}} New Pending Requests",
  JOIN_CLINIC_CONFIRM: "Join Clinic Confirm",
  ARE_YOU_SURE_TO_JOIN_CLINIC: "Are you sure to join this clinic",
  YOUR_JOIN_REQUEST_HAS_BEEN_SENT: "Your join request has been sent",
  NEW_PRACITTIONERS: "New Practitioners",
  ACCEPT_CONFRIM: "Accept Confirm",
  ARE_YOU_SURE_TO_ACCEPT_PRACTITIONER_REQUEST:
    "Are you sure to accept this practitioner request",
  ARE_YOU_SURE_TO_REJECT_PRACTITIONER_REQUEST:
    "Are you sure to reject this practitioner request",
  VIEW_INFO: "View Info",
  NO_SERVICES_AVAILABLE: "No Services Available",
  SEARCH_PRACTITIONER_BY_NAME: "Search Clinic Practitioners by Name",
  X_PENDING_APPROVAL: "{{X}} Requets Pending Approval",
  APPROVE: "Approve",
  DECLINE: "Decline",
  ACCEPT: "Accept",
  CLEAR: "Clear",
  ACCEPT_CONFIRM: "Accept Confirm",
  REJECT_CONFIRM: "Reject Confirm",
  CLOSE_CLINIC: "Close Clinic",
  CONFIRM_TO_CLOSE_CLINIC: "Confirm to Close Clinic",
  THIS_CLINIC_WILL_BE_CLOSED_AND_ALL_ASSOCIATED_PRACTITIONERS_WILL_BE_REMOVED:
    "This clinic will be closed and all associated practitioners will be removed",
  I_UNDERSTAND_THE_CONSEQUENCES_OF_CLOSING_THIS_CLINIC:
    "I understand the consequences of closing this clinic",
  ME: "Me",
  ARE_YOU_SURE_TO_REMOVE_PRACTITIONER_FROM_CLINIC:
    "Are you sure to remove this practitioner from this clinic",
  THIS_PRACTITIONER_WILL_NOT_BE_ABLE_TO_VIEW_USE_INFO_FOR_THIS_CLINIC:
    "This practitioner will not be able to working in this clinic anymore",
  INVITE_CONFIRM: "Invite Confirm",
  ARE_YOU_SURE_TO_INVITE_X_TO_YOUR_CLINIC:
    "Are you sure to invite {{X}} to your clinic",
  CONTINUE: "Continue",
  PENDING_ACCEPT: "Pending Practitioner to Accept",
  NO_CLINIC_SELECTED: "No Clinic Selected",
  NO_WORKING_CLINIC_FOUND: "No Working Clinic Found",
  NEW_CLINIC_INVITATION: "Clinic Join Invitation",
  ADD_JOIN_CLINIC: "Add / Join New Clinic",
  OR_U_CAN: "OR U CAN",
  CONSULTATION_FEES: "Clinic Fees",
  THIS_CONSULTATION_FEES_WILL_BE_DISPLAYED_IN_YOUR_PERSONAL_PAGE:
    "Completed clinic fees (fee > $0.00) will be displayed in your personal page",
  ENTER_FEE_LABEL: "Enter Fee Label",
  ADD_OTHER_CONSULTATION_FEE: "Add Other Clinic Fee",
  ALL_PACKAGES: "All Packages",
  PACKAGE_FILTER: "Filter Clinic Users by Package",
  EXTEND_PACKAGE: "Extend Package",
  OOPS_THIS_PACKAGE_HAS_ALREADY_REACHED_ITS_CAPACITY:
    "🤔 The user's purchased pack for this package has reached its maximum capacity.",
  USER_PACK_PURCHASED: "User Pack Allocated / Purchased",
  THIS_PACKAGE_HAS_ALREADY_BEEN_ASSIGNED_TO_THIS_CLINIC_USER:
    "This clinic user has already been allocated to this package.",
  THIS_PACKAGE_HAS_ALREADY_REACHED_ITS_CAPACITY:
    "The user's purchased pack for this package has reached its maximum capacity.",
  EXPIRED_TODAY: "Soon to Expire",
  SOON_TO_EXPIRED: "Soon to Expire",
  EXTEND_NOW: "Extend Now",
  REMOVE_PACKAGE_FROM_USER: "Remove Package From this User",
  NO_PERMISSION_TO_ACCESS_CLINIC_FUNCTION:
    "In this case, the user will no longer be able to access the clinic function",
  NO_PERMISSION_ACCESS_FEATURE_OR_DATA:
    "You don't currently have permission to access this data or feature. If you have any questions about permissions, please contact your clinic administrator.",
  CURRENT_CLINIC_INVALID_MAY_HAVE_LEFT:
    "This clinic is no longer valid — you may have left this clinic.",
  CLINIC_WORK_PERMISSIONS_UPDATED:
    "We detected that your work permissions for this clinic have been updated.",
  VALID_PACKAGE: "Valid Package(s)",
  REPURCHASE_PACKAGE: "Re-Purchase Package",
  CLOSED_CLINIC: "Clinic Closed",
  THIS_CLINIC_HAS_BEEN_CLOSED: "This clinic has been closed",
  CLINIC_RELATED_TO_ME: "Clinic Related to Me",
  CANCEL_INVITATION_SUCCESS: "Cancel invitation success",
  AVG_DURATION: "Avg. Consultation Duration",
  VIEW_CLINIC: "View Clinic",
  NEW: "New",
  CLINIC_NO_PACKAGE_SUBSCRIBED: "Clinic do not have any active subscriptions.",
  PURCHASE_PACKAGE_AND_ASSIGN_TO_CLINIC_MEMBERS_TO_START_WORKING_AT_HEALTHNEX:
    "Once you purchase a plan and assign it to your clinic staff, you can immediately unlock the full Healthnex service experience!",
  PURCHASE_PACKAGE_TO_START_WORKING_AT_HEALTHNEX:
    "Once you purchase a plan, you can immediately unlock the full Healthnex service experience!",
  PURCHASE_PACKAGE_FOR_UR_CLINIC: "Get the right plan for your clinic",
  NO_SURE_WHAT_DO: "Not sure where to begin?",
  START_SYSTEM_GUIDE: "Start Onboarding",
  NO_PACKAGE_ALLOCATED: "You have not been assigned a plan in this clinic yet",
  PLEASE_CONTACT_YOUR_CLINIC_OWNER_TO_ASSIGN_THE_PACKAGE_TO_ACCESS_MORE_FEATURES_IN_HEALTHNEX:
    "Please contact your clinic owner to assign a plan to you so you can access complete Healthnex features.",
  SUBSCRIPTION: "Package Subscription",
  SELECT_A_SUITABLE_PACKAGE_FOR_YOUR_CLINIC_MEMBERS_TO_START_WORKING:
    "Select the appropriate plan for your clinic staff to begin their work.",
  ASSIGN_TO_CLINIC: "Assign to Clinic",
  SELECT_THE_CLINIC_THAT_U_WITH_TO_APPLY_THIS_PACKAGE_FOR:
    "Please select the clinic where you would like to apply this plan",
  ADJUST_NUMBER_USER_PACK_U_WISH_TO_PURCHASE:
    "Please adjust the number of user packs you would like to purchase (if this package is a combination pack you will not be able to customize the number of users)",
  USER_PACK_CAN_BE_ASSIGNED_TO_CLINIC_USER_TO_ALLOW_EXPERIENCE_THE_PACKAGE_FEATURE:
    "User packs can be assigned to clinic staff, allowing them to access and experience the plan’s features.",
  EG_PURCHASED_3_USER_PACKS_CAN_BE_APPLY_TO_3_USERS_IN_CLINIC_INCLUDE_OWNER:
    "For example, if you purchase 3 user plans, you can assign them to 3 clinic staff members, including the clinic owner.",
  ASSIGN_USER_PACK_TO_CLINIC_USER: "Assign user packs to clinic member",
  CLINIC_MEMBERS_WHO_DONT_HAVE_PACKAGE_WILL_BE_DISPLAYED_HERE_U_CAN_QUICK_ASSIGNED_PURCHASED_USER_PACK_TO_THEM:
    "Clinic staff who have not been assigned a plan will appear here. You can quickly assign your purchased user plans to them.",
  CARD_DETAIL: "Card Details",
  FILLING_UR_CARD_DETAIL_TO_PAY:
    "Filling in your card details to finish payment",
  PAY_NOW: "Pay Now",
  DONT_SHOW_AGAIN: "Don't show again",
  ORDER_NO: "Order",
  SELECTED_CLINIC: "Selected Clinic",
  CLINIC_LOGO: "Clinic Logo",
  EDIT_LOGO: "Edit Logo",
  ADD_LOGO: "Add Logo",
  REUPLOAD_LOGO: "Re-Upload Logo",
  UPLOAD_LOGO: "Upload Logo",
  CLINIC_LOGO_UPLOADED: "Clinic logo uploaded",
  NO_CLINICS_FOUND_IN_X: "🤔 No related clinics were found in {{X}}",
  U_CAN_CREATE_YOUR_OWN_CLINIC_OR_JOIN_AN_EXISTING_CLINIC_TO_WORK_LATER:
    "🎉 Don’t worry—you can create your own clinic now or join one later, whichever works best for you!",
  JOINED: "Joined",
  U_ARE_THE_OWNER_OF_BELOW_CLINICS:
    "You will become the owner of the following clinic",
  WE_WILL_CREATE_THE_CLINIC_FOR_YOU_ANY_NO_NAME_CLINIC_WILL_BE_RENAME_TO_YOUR_NAME:
    "We will create these clinics for you. Please note that any clinic without a name will be assigned one based on your name. Eg. John's Clinic",
  U_ARE_THE_MEMBER_OF_BELOW_CLINICS: "You are the member of the below clinics",
  U_WILL_BE_THE_MEMBER_OF_THE_BELOW_CLINICS:
    "You will join the following existing clinics in Healthnex as a member",
  THESE_CLINICS_HAS_NOT_BEEN_CREATED_BY_THEIR_OWNER_IN_SYSTEM_PLEASE_CONTACT_THEIR_OWNER_TO_CREATE_THE_CLINIC_AND_INVITE_YOU_IN:
    "These clinics have not been created in the Healthnex system by their owners. Please contact the clinic owners to create the clinics and invite you to join.",
  CLINIC_BELOWS_ARE_NOT_IN_THE_SYSTEM:
    "You are a member of the following clinics, but they have not yet been created in the Healthnex system.",
  CREATING_ACCOUNT:
    "Please wait for a moment, we are creating your Healthnex account",
  PLEASE_DONT_CLOSE_THIS_PAGE: "Please don't close this page",
  WELCOME_TO_HEALTHNEX: "Welcome to Healthnex!",
  GETTING_STARTED_SUB: "Complete a few quick steps to start using Healthnex.",
  GETTING_STARTED_PROGRESS: "{{count}} of 3 completed",
  GETTING_STARTED_CLINIC_TITLE: "Create or join a clinic",
  GETTING_STARTED_CLINIC_DONE: "Your clinic is connected.",
  GETTING_STARTED_CLINIC_SUB: "Connect a clinic to unlock appointments, prescriptions and records.",
  GETTING_STARTED_HOURS_TITLE: "Set your working hours",
  GETTING_STARTED_HOURS_LOCKED: "Create or join a clinic first.",
  GETTING_STARTED_HOURS_DONE: "Your working hours are set.",
  GETTING_STARTED_SET_HOURS: "Set working hours",
  GETTING_STARTED_RECORD_TITLE: "Create your first clinical record",
  GETTING_STARTED_RECORD_LOCKED: "Available after your clinic setup is complete.",
  GETTING_STARTED_RECORD_DONE: "You’ve created your first record.",
  GETTING_STARTED_CREATE_RECORD: "Create record",
  GETTING_STARTED_TEAM_TITLE: "Invite a team member",
  GETTING_STARTED_TEAM_SUB: "Add colleagues so they can help manage appointments and records.",
  GETTING_STARTED_INVITE_TEAM: "Invite a team member",
  GETTING_STARTED_PROFILE_TITLE: "Complete your clinic profile",
  GETTING_STARTED_PROFILE_SUB: "Add your address, services and details so patients can find you.",
  GETTING_STARTED_COMPLETE_PROFILE: "Complete clinic profile",
  VERIFYING_EXTERNAL_ACCOUNT: "Verifying external account creditials",
  PACKAGE_IS_SOOON_TO_EXPIRED: "The following packages are about to expire.",
  IF_NOT_RENEW_SERVICE_WILL_BE_STOPPED:
    "If you do not renew them in time, your current services will be suspended.",
  RENEW_UR_PACKAGE_BEFORE_LOSE_ACCESS_TO_UR_SERVICE:
    "To avoid any disruption to your daily operations, please renew your plan as soon as possible to ensure continuous service availability.",
  RENEW_NOW: "Renew Now",
  MY_PACKAGE: "My Package",
  THIS_FEATURE_REQUIRED_A_PACKAGE_SUBSCRIPTION:
    "This feature requires a package subscription",
  CURRENT_PACKAGE: "Current Package",
  NO_ADDRESS: "No Address",
  CURRENT_CLINIC_NOT_FOUND: "Current clinic not found",
  CURRENT_PACKAGE_OFFER: "Current Package Offer",
  FOR_USERS_PACK_AVAILABLE: " User Pack(s)",
  U_CAN_ENTER_MODIFY_UR_INSURANCE_NUMBER_HERE:
    "You can input or modify your insurance number here",
  INCLUDED_INSURANCES: "Included Insurances",
  NO_MODALITY_INSURANCE: "No Insurance Added",
  ADD_MODALITY_INSURANCE_NO: "Add Insurance",
  INSURANCE_PROVIDER: "Ins. Provider",
  INSURANCE_NUMBER: "Ins. Number",
  SWITCH_TO_ENABLED: "Enable",
  SWITCH_TO_NOT_ENABLED: "Not Enable This",
  INSURANCE_NOT_ENABLED: "Insurance Not Enabled",
  MODALITY_NOT_ENABLED: "Service Not Enabled",
  X_INSURANCES_CHANGE_UNSAVED_ARE_YOU_SURE_TO_CLOSE:
    "You have unsaved changes in {{X}} insurances. Are you sure to close this window?",
  CLINIC_MAXIMUM_BED_NUM: "Clinic Maximum Bed Capacity",
  CURRENT_MAXIMUM_BED_NUM_CONFIGURED_BY_CLINIC:
    "Current maximum bed capacity configured by the clinic",
  CONFIGURE_BED_NUM: "Configure Clinic Bed Capacity",
  BED: "Bed(s)",
  PRACTITIONER_CAPACITY: "Maximum Concurrent Patients per Service",
  PATIENT_AT_SAME_TIME: "Patients at same time",
  THIS_VALUE_CANNOT_EXCEED_THE_CLINIC_MAXIMUM_CAPACITY:
    "This value cannot exceed the clinic's maximum bed capacity.",
  X_BED_NUM: "{{X}} Bed(s)",
  U_CAN_CHANGE_THE_CLINIC_BED_NUM_HERE:
    "You can change the clinic bed capacity here",
  NOT_WORKING_DAY_IN_THIS_CLINIC: "Not working days",
  REST_DAY: "Rest",
  WORK_IN: "Work in",
  SELECT_ADDON: "Select Add-on",
  YOU_SUBSCRIBED_ALL_ADDONS_TO_THIS_PACKAGE: "You've subscribed all addons in package",
  EFFECTIVE_DATE: "Effective Time",
  NOT_YET_EFFECTIVE: "Not yet effective",
  CANCEL_SUBSCRIPTION: "Cancel Subscription",
  CANCEL_SUBSCRIPTION_CONFIRM: "Cancel this subscription?",
  CANCEL_SUBSCRIPTION_DESC: "Once cancelled, this package can no longer be renewed. You can continue using it normally until the subscription expires, after which the package will be deactivated.",
  SUBSCRIPTION_CANCELLED: "Subscription cancelled",
  E_DAYS_LEFT: " days left",
  E_DAYS_AGO: " days ago",
  FILTER_PRACTITIONER_BY: "Filter Practitioner by",
  ASSIGN_PRACTITIONER: "Assign Practitioner",
  CLINIC_PRACTITIONERS_NOT_VISIBLE_BELOW: "Practitioners not available for this working service",
  BELOW_PRACTITIONERS_NOT_PROVIDING_SERVICE: "The following practitioners do not provide this working service:",
  ENABLE_SERVICE: "Enable Service",
  ADDON: "Add-on",
  PACKAGE: "Package",
};

const clinicHerbs = {
  HERB_MANAGEMENT: "Clinic Resource Management",
  MANAGE_YOUR_CLINIC_HERBS_FORMULA:
    "Manage herbs and formulas information that is available in your current clinic only",
  CURRENT_CLINIC: "Current Clinic",
  CONFIGURE_CLINIC_HERBS: "Configure Clinic Herbs",
  CONFIGURE_CLINIC_FORMULA: "Configure Clinic Formulas",
  CLINIC_HERB: "Clinic Herb",
  CLINIC_FORMULA: "Clinic Formula",
  SEARCH_HERB_NAME: "Search Herb Name",
  SEARCH_FORMULA_NAME: "Search Formula Name",
  ADD_HERB: "Add Herb",
  ADD_FORMULA: "Add Formula",
  HERB_NAME: "Herb Name",
  HERB_NAME_IN_X: "Herb Name ({{X}})",
  PINYIN: "Pinyin",
  IS_TOXIC: "Is Toxic",
  IS_PREMIUM: "Is Premium",
  USED_BY_CREATER_ONLY: "Used by Creater Only",
  TOXIC: "Toxic",
  PREMIUM: "Premium",
  YES: "Yes",
  NO: "No",
  HERB_NAME_CN: "Herb Name (Chinese)",
  FORMULA_NAME_CN: "Formula Name (Chinese)",
  HERB_NAME_EN: "Herb Name (English)",
  FORMULA_NAME_EN: "Formula Name (English)",
  HERB_NAME_X: "Herb Name ({{X}})",
  FORMULA_NAME_X: "Formula Name ({{X}})",
  HERB_INFO: "Herb Info",
  FORMULA_INFO: "Formula Info",
  THIS_FORMULA_CAN_ONLY_BE_USED_EDITED_BY_YOURSELF:
    "This formula can only be used/edited by the creator (myself)",
  SEARCH_HERB_NAME_HERE: "Search herb name here",
  SEARCH_HERB_BY_HERB_NAME: "Search Herb by Herb Name",
  HERB_IN_THIS_FORMULA: "Herb in this Formula",
  NO_HERB_ADDED: "No Herb Added",
  FORMULA_NAME: "Formula Name",
  FORMULA_NAME_IN_X: "Formula Name ({{X}})",
  NUM_HERBS: "Number of Herbs",
  ADDED: "Added",
  FORMULA_CREATED: "Formula created",
  FORMULA_UPDATED: "Formula updated",
  POINT_GROUP_CREATED: "Point group created",
  HERB_CREATED: "Herb created",
  HERB_UPDATED: "Herb updated",
  UNDO: "Undo",
  REDO: "Redo",
  PLZ_INPUT_FORMULA_NAME_CN: "Please input the formula name in Chinese",
  PLZ_INPUT_FORMULA_NAME_EN: "Please input the formula name in English",
  PLZ_INPUT_PINYIN: "Please input the pinyin",
  PLZ_INPUT_HERB_NAME_CN: "Please input the herb name in Chinese",
  PLZ_INPUT_HERB_NAME_EN: "Please input the herb name in English",
  PLZ_INPUT_HERB_NAME_X: "Please input the herb name in {{X}}",
  PLZ_INPUT_FORMULA_NAME_X: "Please input the formula name in {{X}}",
};
const packagePages = {
  INCLUDES: "Includes",
  INCLUDES_ALL_LOWER_AND: "Includes all lower-level features and",
  PP_PER_YEAR: "Per User / Year",
  PP_PER_MONTH: "Per User / Month",
  PACKAGES: "Packages",
  EXPIRE_IN_X_DAYS: "Expire in {{X}} days",
  FOR_NEXT_X_DAYS: "For next {{X}} days",
  SELECT_CLINIC_FOR_APPLYING_PACKAGE:
    "Select the clinic for applying the package",
  NUMBER_OF_USER: "Number of Users",
  SELECTED_PACKAGE: "Selected Package",
  CURRENT_USER: "Current User",
  NEW_PACKAGE: "Subscribe New Package",
  NO_CLINIC_MEMBERS: "No clinic members without a package.",
  ASSIGN_PACKAGE_TO_USER: "Assign to Clinic Members",
  PER_EXIST_USER: "Per Existing User",
  PER_NEW_USER: "Per New User",
  NO_PACKAGES_FOUND: "No packages found",
  EXTEND: "Extend",
  UPGRADE: "Upgrade",
  RENEW: "Renew",
  PP: "Per User",
  SELECT_A_PACKAGE: "Select a Package",
  CHANGE: "Change",
  REASSIGN: "Re-Assign",
  ASSIGN: "Assign",
  PURCHASE_PACKAGES: "Purchase Packages",
  NO_PACKAGE: "No Packages",
  EXPIRE_DATE: "Expire Date",
  MAX_USERS: "Max Users",
  TIME: "Time",
  PRICE: "Price",
  PAYMENT_HISTORY: "Payment History",
  CHECK_YOUR_PAYMENT_HISTORY: "Check Your Payment History",
  THIS_PACKAGE_IS_ONLY_FOR_YOURSELF_NOT_FOR_YOUR_CLINIC_MEMBER:
    "This package is intended for individual use and will be applied directly to your account upon activation.",
  PURCHASE: "Purchase",
  RENEW: "Renew",
  UPGRADE: "Upgrade",
  SELECT_AVAILABLE_CLINIC_PACKAGE_FOR_YOUR_CLINIC:
    "Select your desire package for your clinic",
  EXTEND_SELECTED_PACKAGE: "Extend the selected package",
  UPGRADE_SELECTED_PACKAGE: "Upgrade the selected package",
  APPLY_THE_PACKAGE_TO_YOUR_CLINIC:
    "Apply / customise the package to your clinic",
  MAKE_PAYMENT: "Make payment",
  MY_CLINICS: "My Clinics",
  NOTE: "Note",
  ANY_CLINICS_MANAGED_BY_U_WILL_BE_AVAILABLE_BELOW:
    "Any clinics you managed will be available below",
  CURRENT_PURCHASED_USERS: "Current purchased users",
  USERS: " Users",
  FOR_USERS_PACK: " User Pack(s)",
  EXTEND_TO: "Extend to",
  EXTEND_USERS_NUMBER_CANNOT_BE_EQUAL_OR_LESS_THAN_CURRENT_USER_NUMBER:
    "Extended user number cannot be less than or equal to the current user count",
  PLZ_CHECK_THE_NUMBER_OF_USERS: "Please check the number of users",
  SYSTEM_WILL_DIRECT_U_BACK_PLS_WAIT: "System is redirecting, please wait...",
  PURCHASE_FOR: "Purchase for",
  IF_U_GOT_PROMOTION_CODE: "If you got a promotion code",
  CLICK_HERE: "Click here",
  IF_U_GOT_PROMOTION_CODE_INPUT_IT_HERE:
    "If you got a promotion code, please input it here",
  CURRENT_USERS_ASSIGNED_TO_THIS_PACKAGE:
    "Current users assigned to this package",
  PURCHASED_FOR: "Purchased for ",
  RENEW_SELECTED_PACKAGE: "Renew your selected package",
  EXTEND_PACKAGE_FOR_YOUR_CLINIC: "Extend the package for your clinic",
  UPGRADE_PACKAGE_FOR_YOUR_CLINIC: "Upgrade the package for your clinic",
  RENEW_PACKAGE_FOR_YOUR_CLINIC: "Renew the package for your clinic",
  EXTENDED_USER_PACK: "User Packs (After Extend)",
  CURRENT_USER_PACK: "User Packs (Current)",
  PAYMENT_UNAVAILABLE: "Payment Unavailable",
  PLS_OPEN_PAGE_OVER_HTTPS: "Please open this page over HTTPS to pay securely.",
  CREATE_UR_CLINIC_NOW: "Create Your Clinic",
  NO_PACKAGE_SUBSCRIBED: "No package subscribed",
  BELONGS_TO: "Belongs to",
  TO_ACCESS_FULL_HEALTHNEX_SERVICES_PLEASE_SELECT_A_PACKAGE_FOR_UR_CLINIC:
    "Select a feature package for your clinic to unlock full access to Healthnex.",
  RENEW_UR_CLINIC_PACKAGE: "Renew your clinic package",
  PACKAGE_ASSIGNED_BY_CLINIC_OWNER: "Package assigned by your clinic owner",
  RENEW_UR_PERSONAL_PACKAGE: "Renew your personal package",
  FOR_PERSONAL: "For Personal",
  FOR_CLINIC: "For Clinic",
  PURCHASE_FOR_MYSELF: "Purchase for Myself",
  PURCHASE_FOR_CLINIC: "Purchase for Clinic",
  HEALTHNEX_IS_GOING_TO_CREATE_U_OWNED_CLINIC_PLS_PROVIDE_THE_ADDRESS:
    "Healthnex is about to create your clinic. Please provide the clinic address to continue.",
  CLINIC_ADDRESS: "Clinic Address",
  SORRY: "Sorry",
  FIND_UR_SUITABLE_PACKAGES: "Find your suitable packages",
  ARE_U_LOOKING_TO_BUY_A_PERSONAL_PACKAGE_CLINIC_PACKAGE:
    "Are you looking to buy a personal package or a clinic package?",
  I_WANNA_BUY: "I want to buy",
  PERSONAL_WEBSITE_FOR_MYSELF: "Personal Website for Myself",
  CLINIC_PACKAGE_FOR_MY_CLINIC: "Clinic Service for My Clinic",
  HOW_MANY_USERS_PACK_U_WISH_TO_INCLUDE_IN_YOUR_PACKAGE:
    "How many users do you wish to include in your package?",
  CLINIC_MEMBERS_WHO_CAN_ACCESS_APPOINTMENT_AND_PRESCRIPTION_USING_AI_AND_ALSO_INCLUDES_PERSONAL_WEBSITE:
    "Clinic members who can access appointment and prescription using AI and also includes personal website",
  CLINIC_MEMBERS_WHO_CAN_ACCESS_APPOINTMENT_AND_PRESCRIPTION_USING_AI_AND_ALSO_WITHOUT_INCLUDES_PERSONAL_WEBSITE:
    "Clinic members who can access appointment and prescription using AI and also without includes personal website",
  WITHOUT_PERSONAL_WEBSITE: "Without personal website",
  INCLUDES_PERSONAL_WEBSITE: "Includes personal website",
  ALL_CLINIC_PACKAGES: "All clinic packages",
  WHAT_FEATURES_U_WISH_TO_INCLUDE:
    "What features do you wish to include in your clinic package?",
  INCLUDES_X_USERS: "Includes {{X}} users",
  CUSTOM_USER_PACKS: "Custom user packs",
  THIS_PACKAGE_REQUIRES_TO_PURCHASE_AT_LEAST_X_USER_PACKS:
    "This package requires to purchase at least {{X}} user packs",
  SHORT_APPOINTMENT: "Appoint.",
  SHORT_PRESCRIPTION: "Prescrpt.",
  SHORT_PACKAGE: " Pack",
  WEB: "Web",
  X_YEARS: "{{X}} years",
  ADDONS_SERVICE_INCLUDED: "Optional add-on services",
  ADDON_SERVICE_SELECTED: "Selected Add-on Services",
  PER_MESSAGE: "Per Message",
  ADD_ON_BILL_BASED_ON_UR_USAGE_CHARGE_WILL_BE_APPLIED_EVERY_X: "This add-on is billed based on your usage. You can use the service during each billing cycle ({{X}}), and charges will be applied at the start of the next cycle based on your usage in the previous period",
  CONTINUE_USE_BILL_CHARGED_EVERY_X: "You will be charged at the beginning of each cycle ({{X}}) based on your usage in the previous cycle",
  WEEKLY: "Weekly",
  FORTNIGHTLY: "Fortnightly",
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  BI_ANNUALLY: "Bi-annually",
  ANNUALLY: "Annually",
  ADDON_DETAIL: "Add-on Detail",
  NEXT_BILLING_DATE: "Next Billing Time",
  BILLING_CYCLE: "Billing Cycle",
  ADDON_PRICE: "Add-on Price",
  X_ADDONS_SERVICE_INCLUDED: "{{X}} Optional Add-on Services",
  SELECT_BILLING_METHOD: "Select Billing Method",
  BILLING_METHOD: "Billing Method",
  TEMPORARILY_FREE: "Currently Free",
  FIRST_YEAR_FREE: "First Year Free",
  ON_PROMOTION: "On Promotion",
  PROMOTION_END_DATE: "Promotion Ends",
  REGULAR_PRICE_RESUMES_ON_X: "Regular price resumes on {{X}}",
  SET_AS_DEFAULT: "Set as default",
  RECENTLY_USED: "Recently used",
  USE_DIFFERENT_CARD: "Use a different Card",
  PAY_WITH_SAVED_CARD: "Used Saved Card",
  CARD_HOLDER_NAME: "Cardholder Name",
  ENABLE_AUTO_RECHARGE: "Enable Auto-Renewal",
  CANCEL_AUTO_RECHARGE: "Cancel Auto-Renewal",
  AUTO_RECHARGE_WHEN_SUBCRPTION_EXPIRED: "Automatically renew using this card when your subscription expires",
  SAVE_BELOW_CARD_DETAILS: "Save this Card",
  STORE_CREDIT_CARD_SECURELY: "Your card details will be stored securely for faster checkout next time",
  ADDON_REQUIRES_SAVED_CARD: "You've selected an add-on, which requires recurring billing. Please save your card details so we can charge each billing cycle automatically.",
  DETECT_U_HAVE_A_SAVED_CARD_THIS_CARD_DETAIL_WILL_BE_SAVE_AND_REPLACE_THAT_CARD_DETAIL: "We found a saved card on file. This card will replace it after payment.",
  ARE_YOU_SURE_TO_CANCEL_AUTO_RECHARGE: "Are you sure to cancel auto-renewal?",
  U_CAN_ENABLE_AUTO_RECHARGE_LATER: "You can enable auto-renewal later",
  AUTO_RECHARGE_HAS_BEEN_ENABLED: "Auto-renewal has been enabled",
  AUTO_RECHARGE_HAS_BEEN_CANCELLED: "Auto-renewal has been cancelled",
  AUTO_RECHARGE: "Auto-Renewal",
  HAS_ENABLED: "Enabled",
  NOT_ENABLED: "Not Enabled",
};

const cmasaImport = {
  IMPORT_CLINICS: "Import Clinics",
  CLINICS_FOUND_IN_X: "Clinics found in {{X}}",
  NO_CLINIC_FOUND: "No clinic found",
  CLINICS_IMPORTED_FROM_X: "Clinics imported from {{X}}",
  NO_CLINIC_IMPORTED: "No clinic imported",
  DELETE: "Delete",
  CONFIRM: "Confirm",
  ARE_YOU_SURE_TO_DELETE_X: "Are you sure to delete {{X}}?",
  THIS_ACTION_CANNOT_BE_UNDONE: "This action cannot be undone",
  IMPORT_CLINIC: "Import Clinic",
  UPDATE_CLINIC: "Update Clinic",
  UPLOAD_AVATAR: "Upload Avatar",
  REUPLOAD_PROFILE_IMAGE: "Re-upload Profile Image",
  CLICK_TO_UPLOAD: "Click to upload",
  PLEASE_FILL_ALL_REQUIRED_FIELDS: "Please fill in all required fields",
  PLEASE_ENTER_VALID_EMAIL: "Please enter a valid email address",
  PLEASE_ENTER_SAME_PASSWORD: "Please enter the same password",
  SIGN_UP_SUCCESS: "Sign-up successful",
  CLINIC_EXISTS: "This clinic already exists",
  NEXT_STEP: "Next Step",
  SAME_WITH_ORG_PASSWORD: "Same as original password",
  PROFILE_IMG: "Profile Image",
  I_CHANGED_MY_MIND: "I changed my mind",
  ADDING: "Pending Create",
  JOINING: "Pending Join",
  OR: "or",
  SKIP: "Skip",
  JOIN: "Join",
  SAVE_CONFIRM: "Save Confirm",
  ARE_YOU_SURE_TO_SUBMIT_YOUR_CLINIC_INFO:
    "Are you sure to submit your clinic info and agree to create the clinic?",
  FOUND_RELEVANT_CLINICS:
    "We’ve found some clinics in the Healthnex system that may be relevant to this clinic.",

  JOIN_OR_SKIP_CLINIC_GUIDE:
    "You can click Join to request to join one of them. If you’re unsure or don’t see the right clinic, you can click Skip and choose to handle this later.",
  NEED_TO_ADD_CLINIC: "Do you need to add this clinic to our Healthnex system?",
  ADD_CLINIC_DESCRIPTION:
    "Click Add to proceed. You will become the owner of the clinic, with the ability to invite or remove members. You can also transfer ownership to another clinic member at a later time. If you’re unsure or don’t need to add it now, click Skip and come back to it later.",
  CLINIC_RESULT_TITLE: "Result for this clinic",
  CLINIC_SKIPPED_MSG:
    "This clinic has been skipped. You will neither join an existing clinic nor add it as a new one.",
  CLINIC_NOT_LISTED: "The clinic I want to join is not listed above.",
  I_DO_NOT_WANT_TO_USE_THE_CLINIC_INFO_ABOVE:
    "I do not want to use the clinic info above",
  PREVIOUS_CLINIC: "Previous Clinic",
  NEXT_CLINIC: "Next Clinic",
  ARE_YOU_SURE_TO_CHANGE_YOUR_MIND:
    "Are you sure you want to change your mind? This will reset the setup you’ve done for this clinic.",
};
const camera = {
  FOR_PATIENT: "For patient {{name}}",
  UPLOAD_PHOTO_LABEL: "Upload",
  TAKE_PHOTO: "Take photo",
  OR_CHOOSE_FROM_ALBUM: "Or choose from album",
  CHOOSE_PHOTO: "Choose photo",
  PREVIEW: "Preview",

  DISCONNECTED_TITLE: "Connection Lost / Link Expired",
  DISCONNECTED_BODY:
    "This photo upload link has expired, or been closed. Please generate a new QR code or link.",
  CLICK_AND_UPLOAD_WITH_YOUR_PHONE: "Click and upload with your phone",
  CLICK_AND_RECORD_WITH_YOUR_PHONE:
    "Click and connect with your phone to record",
  CLICK_AND_USE_YOUR_PHONE: "Click and use your phone to record",
  // SCAN_TO_CONNECT: "Scan to Connect / Reconnect",
  SCAN_TO_CONNECT: "",
  CAMERA_TOKEN_EXPIRED: "Camera token has expired",
  IF_YOU_ALREADY_CONNECTED_WITH_YOUR_PHONE:
    "Scan the QR code to connect. Once connected, your phone will stay connected across pages.",
};

const Library = {
  MEDICAL_PUBLICATIONS: "Medical Publications",
  SEARCH_MEDICAL_PUBLICATIONS: "Search Medical Publications",
  SEARCH_PUBLICATION_BY_NAME: "Search Publication by Name",
  RECENT: "Recent",
  LIBRARY: "Library",
  NO_PUBLICATIONS_FOUND: "No Publications Found",
  NO_RECENT_PUBLICATIONS: "No Recent Publications",
  NO_PUBLICATIONS_IN_LIBRARY: "No Publications in Library",
  SEARCH_FOR_THE_MEDICAL_PUBLICATIONS_IN_SEARCH_BAR_OR_VISIT_OUR_LIBRARY:
    "Search for the medical publications in search bar or visit our library",
  JUST_NOW: "Just now",
  RECENT_X_MINUTES: "Recent {{x}} minutes",
  RECENT_X_HOURS: "Recent {{x}} hours",
  RECENT_X_DAYS: "Recent {{x}} days",
  ADD_THIS_BOOK_TO_YOUR_FAVORITES: "Add this book to your favorites",
  CHAPTERS: "Chapters",
  BOOKMARK: "Bookmark",
  ADD_BOOKMARK: "Add Bookmark",
  FULL_SCREEN: "Full Screen",
  TEXT_SIZE: "Text Size",
  NEXT_PAGE: "Next Page",
  PREVIOUS_PAGE: "Previous Page",
  FONT_SIZE: "Font Size",
  SMALL: "Small",
  MEDIUM: "Medium",
  LARGE: "Large",
  BOOKS_MANAGEMENT: "Books Management",
  SAVE_BOOK: "Saved Book",
  READER: "Reader",
  REGULAR: "Regular",
  SEARCH_FOR_PUBLICATIONS: "Search by title or author",
  ERROR_BOOKINGS: "Error Appointments",
  TIP: "Tip",
  ERROR_BOOKINGS_USUALLY_BECUZ_THE_WORKING_DURATION_HAS_CHANGED_OVER_TIME_AFTER_THE_APPOINTMENT_HAS_BEEN_CREATED_EARLIER:
    "The invalid appointment is usually caused by a change in working hours before the appointment was created. You can still proceed with the consultation or reschedule a new time for the patient.",
};

const bookingPage = {
  BOOK_DOCTOR: "Book a Doctor",
  BOOKING_A_DOCTOR: "Booking a doctor",
  SEARCH_BY_PRACTITIONER_NAME_SERVICE_TYPE_OR_SUBURB:
    "Search by practitioner name, service type, or suburb postcode",
  BY: "By ",
  SERVICE_TYPE: "Service Type",
  PLEASE_SELECT_SERVICE_TYPE: "Please select at least one service type",
  SEARCH_BY_PRACTITIONER_NAME: "Search by practitioner name",
  SEARCHING_PRACTITIONERS: "Searching Practitioners",
  NO_SERVICE_LISTED: "No service listed",
  BOOK: "Book",
  WEBSITE: "Website",
  PUBLISH_WEBSITE: "Publish Website",
  JOIN: "Join",
  AND_X_PRACTITIONERS_MORE: "and {{X}} practitioner(s) more...",
  MEDICINE_TREATMENT: "Chinese Medicine Treatment",
  ACUPUNCTURE_TREATMENT: "Acupuncture Treatment",
  MASSAGE_TREATMENT: "Massage Treatment",
  REMEDIAL_MASSAGE_TREATMENT: "Remedial Massage Treatment",
  NO_RELEVANT_PRACTITIONERS_FOUND: "No relevant practitioners found",
  NO_SERVICES_LISTED: "No services listed",
  BOOK_THIS_PRACTITIONER: "Book this practitioner",
  THIS_PRACTITIONER_HAS_NOT_REGISTERED_YET:
    "This practitioner has not registered yet",
  PUBLISH_PRACTITIONER_PROFILE_WEBSITE: "Publish practitioner profile website",
  VIEW_PRACTITIONER_PROFILE_WEBSITE: "View practitioner profile website",
  NO_WORKING_CLINIC: "No working clinic",
  AND_X_MORE_CLINIC: "and {{X}} more clinic(s)",
  CHOOSE_CLINIC: "Choose Clinic",
  CHOOSE_CLINIC_DESCRIPTION: "Please choose the clinic you wish to attend",
  CHOOSE_SERVICE: "Choose Service",
  CHOOSE_SERVICE_DESCRIPTION:
    "Choose the services you want to book the appointment",
  PICK_APPOINTMENT_DATE: "Pick Appointment Date",
  PICK_APPOINTMENT_DATE_DESCRIPTION: "Pick your appointment date/time",
  MORNING: "Morning",
  AFTERNOON: "Afternoon",
  PATIENT_INFO_DESCRIPTION: "Please fill in the patient information",
  CONFIRM_DESCRIPTION: "Please confirm the appointment details",
  SUBMIT_APPOINTMENT: "Submit Appointment",
  PREV: "Prev",
  YOUR_APPOINTMENT_BOOKED_SUCCESSFULLY:
    "Your appointment has been created successfully",
  CREATE_BOOKING: "Create Booking",
  TOMORROW: "Tomorrow",
  TODAY: "Today",
  IS_ALREADY_BOOKED: "is already booked by someone else",
  TIME_ALREADY_BOOKED: "Time already booked",
  YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
    "This booking triggers overbooking, but since it was created by you (the practitioner), it will be automatically approved by the system.",
  ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME:
    "Are you sure you want to book this time?",
  BACK_TO_HOME: "Close Page",
  INVITATION_LINK_EXPIRED: "Invitation Link Expired",
  INVITATION_LINK_EXPIRED_DESC: "This invitation link is no longer valid. Please ask the clinic owner to send you a new invitation.",
  EXISTING_PATIENT: "Existing Patient",
  START_WITH_NEW_PATIENT: "Start with new patient",
  BACK_TO_EXISTING_PATIENT: "Back to existing patient",
  NEW_PATIENT: "New Patient",
  ARE_U_LOOKING_FOR: "👀 Are you looking for",
  SELECTED_PATIENT: "Selected Patient",
  ALL_GOOD: "All good",
  PLS_REFER_TO_THE_APPOINTMENT_DETAIL_BELOW:
    "Kindly refer to the appointment details provided below.",
  VIEW_DETAIL: "View Detail",
  SELECTED_FROM_OUTSIDE_TIMESLOT: "Chosen from Timetable",
  BOOK_TIMESLOT: "Book this Timeslot",
  INVALID_DOB: "Invalid birth date",
  AGREED_TO_SEND_APPOINTMENT_SMS_TO_PATIENT:
    "I agree to send appointment SMS /Email to notify patient",
  CONFIGURE_UR_PROVIDED_SERVICES: "Configure Your Provided Services",
  NOT_AVAILABLE_FOR_BOOKING: "Not available for booking",
  BOOKED_ENABLED_ONLY: "Booked Enabled Only",
  PLEASE_SELECT_EXISTING_PATIENT:
    "Please select an existing patient to proceed appointment",
  THIS_FEATURE_REQUIRED_PRESCRIPTION_PACKAGE:
    "Sorry, the Patient Records feature is not available in your current package.",
  PLEASE_CONSIDER_UPGRADE_YOUR_PACKAGE_OR_CONTINUE_WITH_NEW_PATIENT:
    "If you need access to this feature, please reach out to your clinic owner to upgrade your package, or proceed with booking a new patient.",
  U_SELECTED_A_PAST_TIMESLOT: "Past timeslot selected",
  U_SELECTED_A_PAST_TIMESLOT_NO_SMS_WILL_BE_SENT:
    "You've selected a past timeslot. No notification SMS will be sent.",
  ANY_RECOMMENDED_PATIENTS_FROM_EXISTING_WILL_BE_SHOWN_HERE:
    "Recommended patients based on those you have already saved in the system will be displayed here.",
  PICK_APPOINTMENT_PRACTITIONER: "Select Practitioner for",
  PICK_APPOINTMENT_PRACTITIONER_END: "",
  PICK_APPOINTMENT_PRACTITIONER_SINGLE_PATIENT: "Select Practitioner",
  RESELECT_APPOINTMENT_DATE: "Re-select Appointment Date",
  RESELECT_PRACTITIONER: "Re-select Practitioner",
  AVAILABLE_PRACTITIONERS: "Available Practitioners",
  DESELECT_CHINESE_MEDICINE_FIRST: "Please deselect Chinese Medicine first.",
  DESELECT_PRODUCTS_FIRST: "Please deselect the selected products first.",
  NUMBER_OF_PEOPLE: "Number of People",
  PERSON: "person",
  PEOPLE: "people",
  ENTER_PATIENT_INFORMATION: "Enter Patient Information",
  IS_THIS_PERSON_NEW_PATIENT: "Is this first visit to this clinic?",
  EXISTING_PATIENT: "Existing Patient",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "Tip: When the appointment time is approaching, a reminder SMS will be sent to you",
  NO_AVAILABLE_PRACTITIONERS: "No available practitioners found in this date",
  ORR: "OR",
  CONFIRM_APPOINTMENT_DESCRIPTION:
    "Please review the appointment details before confirming your booking.",
  PICK_APPOINTMENT_TIME: "Pick Appointment Time",
  PRODUCTS: "Service Products",
  I_AM_A_NEW_PATIENT: "I am a new patient",
  SEARCH_EXISTING_PATIENT: "Search existing patient",
  DESELECT_ALL: "Deselect",
  SERVICES_ITEM: "Service Items",
  X_BED_NUM: "{{X}} bed(s)",
  NEW_TO_THIS_CLINIC: "This is my first visit to this clinic",
  A_REMINDER_EMAIL_WILL_BE_SENT_TO_THE_PATIENT: "A Confirmation Email will be sent to the patient",
};

const guide = {
  WE_FIRST_GO_TO_CLINIC_MANAGEMENT_PAGE:
    "We first go to Clinic Member Management page",
  CLICK_ON_THIS: "Click on this button",
  CREATE_A_NEW_CLINIC_BY_COMPLETE_THE_ESSENTIAL_INFORMATION:
    "Completing the essential information of your clinic",
  SUBMIT_YOUR_CLINIC_INFORMATION:
    "Submit your clinic information, then your clinic will be created",
  IF_U_RECEIVE_CLINIC_INVITATION: "If you receive a clinic invitation",
  ANY_INVITATION_WILL_BE_SHOWN_HERE_U_CAN_ACCEPT_OR_REJECT_THE_INVITATION:
    "Any of clinic invitation will be shown here, you can decide to accept or reject the invitation",
  IF_U_WISH_TO_JOIN_A_CLINIC: "If you wish to join a clinic",
  SEARCH_THE_CLINIC_NAME_U_WISH_TO_JOIN:
    "Search the clinic name you wish to join",
  DONE: "Done",
  START_GUIDE: "Start Guide",
  USER_GUIDE: "Video Guide",
  GUIDE: "Guide",
  NEED_HELP: "Need Help?",
  CONTACT_SUPPORT: "Contact Support",
  VIEW_USER_GUIDE: "View Video Guide",
  CLINIC_MANAGEMENT_GUIDE: "Clinic Management Guide",
  CLINIC_MANAGEMENT_DESCRIPTION:
    "This guide will guide you through how and where to create and join a clinic.",
  PRESCRIPTION_MEDICAL_HISTORY_GUIDE: "Prescription & Medical Record Guide",
  PRESCRIPTION_MEDICAL_HISTORY_GUIDE_DESCRIPTION:
    "This guide will guide you through how and where to create patient and prescription.",
  APPOINTMENT_GUIDE: "Appointment Guide",
  MANAGE_UR_APPOINTMENTS_GUIDE_DESCRIPTION:
    "This guide will guide you through how and where to schedule your working time and make appointments.",
  MORE_GUIDES_ON_THE_WAY: "More guides are on the way",
};

const patientConsent = {
  PATIENT_CONSENT: "Patient Consent",
  CONSENT_TITLE_1: "Treatment",
  CONSENT_DESCRIPTION_1: "I understand that treatment at {{X}} may include:",
  CONSENT_ITEM_1: "Acupuncture using sterile, single-use needles ",
  CONSENT_ITEM_2: "Moxibustion, cupping, or gua sha ",
  CONSENT_ITEM_3:
    "Chinese herbal medicine (decoctions, powders, pills, or granules) ",
  CONSENT_ITEM_4:
    "Lifestyle and dietary advice based on Chinese medicine principles ",
  CONSENT_TITLE_2: "Risks and Side Effects ",
  CONSENT_DESCRIPTION_2:
    "I understand that while all reasonable care is taken, some minor side effects may occur, including: ",
  CONSENT_ITEM_5: "Slight bruising, bleeding, or soreness after needling ",
  CONSENT_ITEM_6: "Temporary dizziness or fatigue ",
  CONSENT_ITEM_7:
    "Mild digestive changes or allergic reactions from herbal medicine ",
  CONSENT_ITEM_8: "Temporary redness or marks from cupping or gua sha ",
  CONSENT_ITEM_9: "Serious adverse reactions are rare. ",
  CONSENT_TITLE_3: "Disclosure and Safety ",
  CONSENT_DESCRIPTION_3: "I have informed my practitioner of: ",
  CONSENT_ITEM_10: "Any current medical conditions or allergies ",
  CONSENT_ITEM_11: "Pregnancy status (if applicable) ",
  CONSENT_ITEM_12: "Any medication or supplements I am currently taking ",
  CONSENT_DESCRIPTION_4:
    "I understand that Chinese medicine treatment is not a substitute for emergency medical care. ",
  CONSENT_DESCRIPTION_5:
    "My personal and health information will be handled in accordance with Australian privacy laws.",
  CONSENT_TITLE_4: "Consent and Acknowledgement",
  CONSENT_ITEM_13:
    "I have read and understood the above information. I have had the opportunity to ask questions and all have been answered to my satisfaction. ",
  CONSENT_ITEM_14:
    "I voluntarily consent to receive Chinese medicine and/or acupuncture treatment from practitioners at {{X}}.",
  DRAW_YOUR_SIGNATURE: "Draw your signature",
  SIGNATURE_UPLOADED: "Signature uploaded",
  CONSENT_SIGN_SUCCESS:
    "You have successfully signed the treatment consent form. Please proceed with your consultation process!",
};

const agreements = {
  PRIVACY_POLICY_TITLE: "HEALTHNEX PRIVACY POLICY",
  PRIVACY_POLICY_EFFECTIVE_DATE:
    "Effective Date: This Privacy Policy is effective from the date the User first registers for and uses the Healthnex Platform.",
  PRIVACY_POLICY_SECTION_OVERVIEW_TITLE: "1. Overview",
  PRIVACY_POLICY_SECTION_OVERVIEW_CONTENT:
    "Healthnex values and is committed to protecting the privacy of Users and their patients. This Privacy Policy explains how we collect, use, store, and disclose personal information and health information in accordance with the Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).",
  PRIVACY_POLICY_SECTION_COLLECT_TITLE: "2. Information We Collect",
  PRIVACY_POLICY_COLLECT_USER_INFO:
    "User Information: name, contact details, professional registration information, clinic information, and account login details;",
  PRIVACY_POLICY_COLLECT_PATIENT_INFO:
    "Patient Information: medical records, appointment information, prescription information, and other health information;",
  PRIVACY_POLICY_COLLECT_TECH_INFO:
    "Technical Information: IP address, device information, and system logs.",
  PRIVACY_POLICY_SECTION_USAGE_TITLE: "3. Purpose of Collection",
  PRIVACY_POLICY_USAGE_PLATFORM:
    "Providing and maintaining the Healthnex Platform;",
  PRIVACY_POLICY_USAGE_ACCOUNT: "Managing user accounts and clinic operations;",
  PRIVACY_POLICY_USAGE_SECURITY:
    "Technical support, system security, and compliance;",
  PRIVACY_POLICY_USAGE_LEGAL:
    "Other purposes required by applicable laws and regulations.",
  PRIVACY_POLICY_SECTION_HEALTH_INFO_TITLE: "4. Health Information",
  PRIVACY_POLICY_HEALTH_INFO_DESCRIPTION:
    "Health information is classified as sensitive information. Healthnex acts solely as a data processor and processes patient health information only in accordance with the instructions of the User, who acts as the data controller.",
  PRIVACY_POLICY_SECTION_DISCLOSURE_TITLE: "5. Disclosure of Information",
  PRIVACY_POLICY_DISCLOSURE_DESCRIPTION:
    "We do not disclose personal or health information to third parties unless required by law or authorised by the User. Certain technical services (such as cloud services and email services) may involve controlled third-party processing.",
  PRIVACY_POLICY_SECTION_SECURITY_TITLE: "6. Data Security",
  PRIVACY_POLICY_SECURITY_DESCRIPTION:
    "We implement reasonable technical and organisational measures to protect information security, including access controls, encryption, and audit mechanisms.",
  PRIVACY_POLICY_SECTION_RETENTION_TITLE: "7. Data Retention",
  PRIVACY_POLICY_RETENTION_DESCRIPTION:
    "Information will be retained or deleted in accordance with legal requirements and business needs.",
  PRIVACY_POLICY_SECTION_RIGHTS_TITLE: "8. User Rights",
  PRIVACY_POLICY_RIGHTS_DESCRIPTION:
    "Users have the right to request access to, correction of, or deletion of their personal information, subject to legal limitations.",
  PRIVACY_POLICY_SECTION_BREACH_TITLE: "9. Data Breaches",
  PRIVACY_POLICY_BREACH_DESCRIPTION:
    "In the event of a notifiable data breach, we will comply with the Australian Notifiable Data Breaches (NDB) scheme.",
  PRIVACY_POLICY_SECTION_CONTACT_TITLE: "10. Contact Us",
  PRIVACY_POLICY_CONTACT_DESCRIPTION:
    "For privacy-related enquiries, please contact Healthnex through official support channels.",
  IF_ANY_SENSITIVE_RELATED_QUESTION_PLS_CONTACT_HEALTHNEX:
    "For privacy-related enquiries, please contact Healthnex through official support channels.",

  DATA_PROCESSING_ADDENDUM: "Data Processing Addendum",
  DPA_TITLE: "HEALTHNEX DATA PROCESSING ADDENDUM",
  DPA_SUB_TITLE: "(Data Processing Addendum, DPA)",
  DPA_INTRO:
    "This Data Processing Addendum forms part of the Healthnex Platform Terms of Use.",
  DPA_SECTION_ROLES_TITLE: "1. Roles",
  DPA_ROLE_USER: "User: Data Controller",
  DPA_ROLE_HEALTHNEX: "Healthnex: Data Processor",
  DPA_SECTION_SCOPE_TITLE: "2. Scope of Processing",
  DPA_SCOPE_DESCRIPTION:
    "Healthnex processes personal information and health information only to the extent necessary to provide the Platform services and strictly in accordance with the User’s instructions.",
  DPA_SECTION_DATA_TYPE_TITLE: "3. Data Types",
  DPA_DATA_TYPE_DESCRIPTION: "Data processed includes, but is not limited to:",
  DPA_DATA_TYPE_PATIENT_INFO: "Patient health information;",
  DPA_DATA_TYPE_APPOINTMENT_RECORD: "Appointment and medical record data;",
  DPA_DATA_TYPE_USER_ACCOUNT: "User account data.",
  DPA_SECTION_SECURITY_TITLE: "4. Data Security",
  DPA_SECURITY_DESCRIPTION:
    "Healthnex will implement reasonable technical and organisational security measures to protect data against unauthorised access, disclosure, or loss.",
  DPA_SECTION_SUBPROCESSORS_TITLE: "5. Sub-processing",
  DPA_SUBPROCESSORS_DESCRIPTION:
    "Healthnex may engage trusted third-party service providers (such as cloud infrastructure or AI service providers). All sub-processors are subject to confidentiality and data protection obligations.",
  DPA_SECTION_BREACH_RESPONSE_TITLE: "6. Data Breach Response",
  DPA_BREACH_RESPONSE_DESCRIPTION:
    "In the event of a data breach, Healthnex will notify the User within a reasonable timeframe and cooperate to fulfil applicable legal obligations.",
  DPA_SECTION_POST_TERMINATION_TITLE: "7. Data Handling After Termination",
  DPA_POST_TERMINATION_DESCRIPTION:
    "Upon termination of the agreement, Healthnex will delete or anonymise relevant data in accordance with the User’s instructions and applicable legal requirements, unless retention is required by law.",
  DPA_SECTION_PRECEDENCE_TITLE: "8. Precedence",
  DPA_PRECEDENCE_DESCRIPTION:
    "In the event of any inconsistency between this Addendum and the main agreement, this Addendum shall prevail in respect of data protection matters.",
};

const freeTrialTerms = {
  FREE_TRIAL_TERMS_PAGE_TITLE: "Terms",
  FREE_TRIAL_TERMS_TITLE:
    "HEALTHNEX PLATFORM THREE (3) MONTH FREE TRIAL TERMS OF USE\n(INCLUDING PRIVACY AND DATA PROCESSING TERMS)\n",
  FREE_TRIAL_TERMS_SUBTITLE:
    "These Terms govern your access to and use of the Healthnex Platform during the three-month free trial period.",
  FREE_TRIAL_TERMS_EFFECTIVE_DATE:
    "Effective Date: The date on which the User first registers for and accesses the Healthnex Platform.",
  FREE_TRIAL_TERMS_PARTIES:
    "This agreement (the “Agreement”) is entered into between: Healthnex (“Healthnex”, “we”, “us”, or “the Platform”); and any individual or entity registering for or using the Healthnex Platform, including but not limited to clinic owners, clinic operators, medical practitioners, or individuals acting in multiple capacities (the “User”, “you”).",

  FREE_TRIAL_TERMS_PURPOSE_TITLE: "1.	Purpose of the Agreement",
  FREE_TRIAL_TERMS_PURPOSE_DESC:
    "This Agreement sets out the terms under which Healthnex provides the User with access to the Platform for a three (3) month free trial period and clarifies the arrangements following the expiry of the trial.",

  FREE_TRIAL_TERMS_USER_DEF_TITLE: "2. Definition of User",
  FREE_TRIAL_TERMS_USER_DEF_DESC:
    "The User may access and use the Healthnex Platform in one or more of the following capacities, including but not limited to:",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_1: "• Clinic Owners / Administrators",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_2: "• 1) Clinic owner or operator ",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_3: "• 2) Clinic administrator ",
  FREE_TRIAL_TERMS_USER_DEF_MULTI_CAPACITY:
    "3) Medical practitioner or healthcare professional ",
  FREE_TRIAL_TERMS_USER_ACCOUNT_RESP:
    "Where the User acts in multiple capacities, all obligations and responsibilities under this Agreement apply cumulatively.\nThe User is responsible for all activities conducted under their account, including actions taken by associated practitioners or staff members.",

  FREE_TRIAL_TERMS_ACCESS_TITLE: "3. Free Trial Access",
  FREE_TRIAL_TERMS_ACCESS_P1:
    "During the trial period, Healthnex grants the User a limited, non-exclusive, non-transferable, and revocable licence to access and use the Healthnex Platform.",
  FREE_TRIAL_TERMS_ACCESS_P2:
    "The free trial period lasts for three (3) consecutive months from the Effective Date.",
  FREE_TRIAL_TERMS_ACCESS_P3:
    "The free trial is provided at no charge and does not automatically renew.",

  FREE_TRIAL_TERMS_FEATURES_TITLE: "4.	Platform Features During the Trial",
  FREE_TRIAL_TERMS_FEATURES_INTRO:
    "During the trial period, the User may access features including, without limitation:",
  FREE_TRIAL_TERMS_FEATURES_ITEM_1:
    "1)	Creation and customisation of personal or clinic professional webpages;",
  FREE_TRIAL_TERMS_FEATURES_ITEM_2: "2)	Appointment and schedule management;",
  FREE_TRIAL_TERMS_FEATURES_ITEM_3:
    "3)	Patient information and medical record management, including prescription-related functionality;",
  FREE_TRIAL_TERMS_FEATURES_ITEM_4:
    "4)	Use of AI-assisted features for administrative and workflow support (non-diagnostic);",
  FREE_TRIAL_TERMS_FEATURES_ITEM_5:
    "• Support services as offered during the trial period",
  FREE_TRIAL_TERMS_FEATURES_NOTE:
    "Healthnex reserves the right to modify, limit, or discontinue trial features at its discretion.",

  FREE_TRIAL_TERMS_EXPIRY_TITLE: "5.	Trial Expiry and Renewal (Important Terms)",
  FREE_TRIAL_TERMS_EXPIRY_P1:
    "1)	The User expressly acknowledges and agrees that if, at the end of the three (3) month free trial period, the User has not entered into a paid subscription or service agreement with Healthnex, access to the Healthnex Platform will cease.",
  FREE_TRIAL_TERMS_EXPIRY_P2:
    "2)	If the User does not complete a subscription upon expiry of the trial:",
  FREE_TRIAL_TERMS_EXPIRY_ITEM_1:
    "•	access to the Platform may be suspended or terminated; and",
  FREE_TRIAL_TERMS_EXPIRY_ITEM_2:
    "•	the User may no longer be able to use Platform features or access stored data.",
  FREE_TRIAL_TERMS_EXPIRY_P3:
    "Healthnex is under no obligation to extend the trial period or continue providing free access.",

  FREE_TRIAL_TERMS_DATA_PRIVACY_TITLE:
    "6.	Data, Privacy, and Health Information",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P1:
    "1)	The User acknowledges that in using the Healthnex Platform, Healthnex may collect, store, process, and transmit personal information and health information as defined under the Privacy Act 1988 (Cth).",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P2:
    "2)	The User acts as the Data Controller in respect of patient data, and Healthnex processes such data solely on the User’s instructions.",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P3:
    "3)	Healthnex will handle all personal and health information in accordance with:",
  FREE_TRIAL_TERMS_DATA_PRIVACY_ITEM_1: "Healthnex Privacy Policy; ",
  AND_D: "and",
  FREE_TRIAL_TERMS_DATA_PRIVACY_ITEM_2:
    "Healthnex Data Processing Addendum (DPA).",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P4:
    "4)	The Privacy Policy and DPA are incorporated into and form part of this Agreement by reference.",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P5:
    "5)	In the event of any inconsistency between this Agreement and the DPA, the DPA prevails to the extent of health data processing obligations.",

  FREE_TRIAL_TERMS_USER_RESP_TITLE: "7.	User Responsibilities and Compliance",
  FREE_TRIAL_TERMS_USER_RESP_INTRO: "The User represents and warrants that:",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_1:
    "1)	where the User is a medical practitioner, they are lawfully registered and authorised to practise in the relevant jurisdiction;",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_2:
    "2)	where the User is a clinic owner or operator, they ensure that all practitioners using the Platform are appropriately registered and authorised;",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_3:
    "3)	the use of the Healthnex Platform complies with all applicable laws, including privacy and health records legislation;",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_4:
    "4)	all clinical decisions, diagnoses, treatments, and prescriptions are the sole responsibility of the relevant practitioner, and not Healthnex.",

  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_TITLE: "8.	Disclaimer During Trial Period",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_P1:
    "1)	To the maximum extent permitted by law, the Healthnex Platform is provided during the trial period on an “as is” and “as available” basis.",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_P2:
    "2)	Healthnex does not warrant uninterrupted availability, error-free operation, or suitability for any particular purpose during the trial period.",

  FREE_TRIAL_TERMS_LIABILITY_TITLE: "9.	Limitation of Liability",
  FREE_TRIAL_TERMS_LIABILITY_P1:
    "1)	To the extent permitted by law, Healthnex excludes all liability for any indirect or consequential loss arising out of or in connection with the User’s use of the trial services.",
  FREE_TRIAL_TERMS_LIABILITY_P2:
    "2)	Nothing in this Agreement excludes rights that cannot be excluded under the Australian Consumer Law.",

  FREE_TRIAL_TERMS_AMENDMENTS_TITLE: "10. Amendments",
  FREE_TRIAL_TERMS_AMENDMENTS_P1:
    "Healthnex may amend this Agreement by providing reasonable notice through the Platform or electronic communication. Continued use after such amendments constitutes acceptance of the updated terms.",

  FREE_TRIAL_TERMS_GOVERNING_LAW_TITLE: "11. Governing Law",
  FREE_TRIAL_TERMS_GOVERNING_LAW_P1:
    "This Agreement is governed by the laws of New South Wales (NSW), Australia, and the parties submit to the exclusive jurisdiction of the courts of that State.",

  FREE_TRIAL_TERMS_ACK_TITLE: "12.	Acknowledgement and Acceptance",
  FREE_TRIAL_TERMS_ACK_INTRO:
    "By clicking “I Agree”, registering an account, or using the Healthnex Platform, the User confirms that:",
  FREE_TRIAL_TERMS_ACK_ITEM_1: "•	they have read and understood this Agreement;",
  FREE_TRIAL_TERMS_ACK_ITEM_2: "•	they agree to be bound by all its terms; and",
  FREE_TRIAL_TERMS_ACK_ITEM_3:
    "•	they clearly acknowledge that access to the Platform will end after the three (3) month trial period unless a paid subscription is entered into.",
  FREE_TRIAL_TERMS_ACK_CHECKBOX:
    "I have read and agree to the Healthnex Free Trial Terms of Use, Privacy Policy, and Data Processing Addendum, and I acknowledge that my access will end after the three-month trial unless I subscribe to a paid plan.",
};

const dashboard = {
  SEARCH_PATIENTS: "Search Patients",
  SEARCH_PATIENTS_THAT_U_WANT_TO_VIEW_THE_DETAIL_ABOUT:
    "Search and view patient details",
  VIEW_USER_GUIDE_AND_UNDERSTAND_THE_SYSTEM:
    "View user guide and understand the system",
  VIEW_APPOINTMENTS: "View Appointments",
  VIEW_CREATED_APPOINTMENTS_ON_TIME_SCHEDULE:
    "View all scheduled appointments in the timetable.",
  CREATE_APPOINTMENT_FOR_THE_SELECTED_PATIENT:
    "Create appointment for the selected patient",
  CREATE_MEIDICAL_HISTORY_FOR_THE_SELECTED_PATIENT:
    "Create medical record for the selected patient",
  VIEW_PATIENT_MEDICAL_HISTORY: "View Patient Medical Record",
  VIEW_MEDICAL_HISTORY_FOR_THE_SELECTED_PATIENT:
    "View medical records for the selected patient",
  ADD_NEW_PATIENT_TO_THE_SYSTEM: "Add new patient to the system",
  VIEW_PATIENT: "View Patients",
  VIEW_PATIENT_INFO: "View Patient Info",
  VALIDATE_PATIENT: "Validate New Patient",
  VALIDATION_REQUIRED: "Validation Required",
  RECOMMENDED_PATIENTS: "Recommended Patients",
  MERGE: "Merge",
  MERGE_TO_RECOMMENDED_PATIENTS: "Merge into one of the existing patients below",
  MERGE_TO_THIS_PATIENT: "Merge to This Patient",
  VIEW_MERGED_PATIENT: "View Merged Patient",
  CONFIRMED_AS_NEW_PATIENT: "Confirm as New Patient",
  PATIENT_CONFIRMED: "Patient confirmed as new patient",
  PATIENT_MERGED: "Patient merged successfully",
  DELETE_PATIENT: "Delete Patient",
  DELETE_PATIENT_CONFIRM: "Are you sure you want to delete this patient? This action cannot be undone.",
  DELETE_PATIENT_FAILED: "Failed to delete patient. The patient may have existing medical records.",
  NUMBER_OF_APPOINTMENTS: "Number of Appointments",
  TOTAL_EARNINGS: "Total Earnings",
  TOTAL_CHARGED: "Gross Earnings",
  INSURANCE_REBATE_TOTAL: "Insurance Rebate Total",
  TOTAL_DISCOUNT: "Discount Total",
  NO_PATIENTS_HAS_CREATED_PRESCRIPTION: "Num. of Patients with Prescriptions",
  NO_PRESCRIPTION_CONDUCTED: "Total Prescriptions Issued",
  YOUR_CLINIC_MEMBERS: "Your Clinic Members",
  MY_STATS: "My Statistics",
  VIEW_STATS: "View Statistics",
  VIEW_THIS_WEEK: "View This Week",
  VIEW_TODAY: "View Today",
  THIS_WEEK: "This Week",
  S_STATS: "'s Statistics",
  GOOD_MORNING: "Good Morning",
  GOOD_NOON: "Good Afternoon",
  GOOD_AFTERNOON: "Good Afternoon",
  GOOD_EVENING: "Good Evening",
  VIEW_CLINIC_STATS: "View Clinic Work Overview",
  GO_TO: "Go ",
  PAGE_BACK: " Page",
};

const patientList = {
  IMPORT_PATIENT_FROM_EXCEL: "Import Patient from Excel",
  IF_U_WANT_TO_IMPORT_PATIENTS_FROM_YOUR_EXCEL:
    "You can quickly import patient information by completing the Excel template and uploading it to Healthnex.",
  STEP_1_DOWNLOAD_THE_EXCEL_TEMPALTE_FILE_FROM_BELOW_AND_FILL_IN_ALL_THE_REQUIRED_COLUMNS:
    "Step 1: Download the Excel template below and complete all required fields for each patient.",
  STEP_2_COMPLETE_PATIENT_INFO_EXCEL_TEMPALTE_AND_UPLOAD_BELOW:
    "Step 2: After completing the patient information, click the button below to upload the Excel template to Healthnex.",
  DOWNLOAD_EXCEL_TEMPLATE: "Download Excel Template",
  UPLOAD_EXCEL: "Upload Excel (.xlsx) File",
  IMPORTED_PATIENTS: "Imported Patients",
  PATIENTS_IMPORTED_SUCCESSFULLY: "Patients imported successfully",
  IMPORT_ERRORS_FOUND: "Import Errors Found",
  NO_ERRORS_FOUND: "No errors found",
  RECORDS_REQUIRED_UR_ACTION_DUE_TO_SIMILAR_PATIENTS_FOUND_IN_THE_SYSTEM:
    "Records may already exist in the system and requires manual review.",
  IMPORT_STATUS: "Import Status",
  IMPORT_PAUSED: "Import Paused",
  X_SIMILAR_PATIENTS_FOUND_IN_THE_SYSTEM:
    "{{X}} patient(s) with similar information were found.",
  OVERWRITE_EXCEL_TO_THIS: "Overwrite with Imported Data",
  HERE_IS_THE_DIFFERENCE_BETWEEN_TWO_RECORDS:
    "You can review the differences between the existing patient information and the imported data below",
  CURRENT_IN_SYSTEM: "Curent Patient Info (System)",
  EXCEL_INFO_TO_UPDATE: "Imported Patient Info (Excel)",
  THERE_ARE_STILL_SOME_IMPORTED_PATIENTS_INFO_NEED_UR_ACTION:
    "There are patient records that were not imported and need your manual review.",
  ARE_U_SURE_TO_COMPLETE_THE_IMPORT_NOW:
    "Are you sure you have completed the import and want to close this window?",
  DOWNLOADING: "Downloading",
  PATIENTS_IMPORTED_FROM_EXCEL: "Patient(s) imported from Excel",
  RE_UPLOAD_THE_EXCEL: "Re-Upload Excel",
  COMPLETE_IMPORT: "Complete Import",
  PREFER_NOT_TO_SAY: "Prefer not to say",
  ADDED_PATIENTS: "Added Patients",
  DUPLICATED_PATIENTS: "Existed Patients in System",
  EXCEL_FILE_UPLOAD_FAILED_PLEASE_MAKE_SURE_YOU_ARE_USING_OUR_TEMPLATE_FILE_U_CAN_DOWNLOAD_THE_FILE_HERE:
    "Excel upload failed. Please make sure you are using the provided template file. You may download the template via the button below.",
  EXPORT_MEDICAL_HISTORY: "Export Medical Records",
  EXPORT_X_MEDICAL_HISTORY: "Export {{X}}'s Medical Records",
  STEP_1_SELECT_DATE_RANGE_MEDICAL_INSURANCES_TO_FILTER_MEDICAL_HISTORY_THAT_U_LIKE_TO_EXPORT:
    "Step 1: Select the consultation date range and filter by the patient's insurance to determine the medical history records you want to export.",
  OPTIONAL: "Optional",
  IF_U_WANT_TO_EXPORT_PATIENT_HISTORY_CREATED_FROM_SPECIFIC_CLINIC:
    "If you want to export medical records created by a specific clinic, please select the clinic below to filter the results.",
  STEP_2_EXPORT_RELATED_PATIENT_HISTORY_TO_EXCEL:
    "Step 2: Export the filtered medical history records as an Excel file.",
  TOTAL_MEDICAL_RECORDS_FOUND: "Total Medical Record(s) Found",
  MULTI_SELECTION: "Multiple selection allowed",
  EXPORT_TO_EXCEL: "Export to Excel",
  UPDATED_BY: "Updated By",
  UPLOAD_ATTACHMENT: "Upload Attachment",
  MAX_X_ATTACHMENTS_ALLOWED: "You can upload up to {{X}} attachments only",
  DELETING: "Deleting",
  OCCUPATION: "Occupation",
  NOTES: "Notes",
  ADDRESS_INFO: "Address Info",
  POSTAL_ADDRESS: "Postal Address",
  SAME_AS_HOME_ADDRESS: "Same as Home Address",
  OTHER_INFO: "Other Info",
  PLEASE_CHECK_THE_INFORMATION_THAT_U_WISH_TO_UPDATE: "Please select the information you would like to update or keep.",
  NEW_INFO: "New Information",
};

const templateEditor = {
  CLINIC_DOC_TEMPLATE: "Document & SMS Templates",
  DOCUMENT_TEMPLATES: "Document & SMS Templates",
  YOU_CAN_CREATE_EDIT_CLINIC_TEMPLATES_HERE: "Create and manage the certificates, letters and SMS messages your clinic uses.",
  NEW_CLINIC_TEMPLATE: "New Clinic Template",
  TEMPLATE_NAME: "Template Name",
  TEMPLATE_CATEGORY: "Template Category",
  TEMPLATE_SOURCE: "Template Source",
  SYSTEM_TEMPLATE: "System Template",
  CLINIC_TEMPLATE: "Clinic Template",
  CLINIC_TEMPLATES: "Clinic Templates",
  CLINIC_TEMPLATES_HINT: "Templates customised by your clinic.",
  SYSTEM_TEMPLATES: "System Templates",
  SYSTEM_TEMPLATES_HINT: "Default templates provided by Healthnex. Editing one creates a clinic copy.",
  NO_CLINIC_TEMPLATE_YET: "No clinic templates yet. Edit a system template below to create your own.",
  USER_DEFINED: "User Defined",
  SICK_CERT: "Sickness Certificate",
  REFERRAL: "Referral",
  ALL: "All",
  SEARCH_TEMPLATES: "Search templates",
  CLEAR_FILTERS: "Clear Filters",
  CLEAR_SEARCH: "Clear Search",
  NO_TEMPLATE_FOUND: "No templates found",
  TRY_ANOTHER_SEARCH_TERM: "Try another search term or clear the filters.",
  LOADING_TEMPLATES: "Loading templates...",
  CREATE_SUCCESS: "Template created successfully.",
  TEMPLATE_SAVE_SUCCESS: "Template saved successfully.",
  TEMPLATE_DELETE_SUCCESS: "Template deleted successfully.",
  DELETE_TEMPLATE: "Delete Template",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEMPLATE: "Are you sure you want to delete this template",
  TEMPLATE_WILL_BE_RESET_TO_SYSTEM_TEMPLATE: "The active template will revert to the system template.",
  NOTE: "Note",
  CREATED_IN: "Created in",
  LAST_EDITED_AT: "Last edited",
  EDIT: "Edit",
  DELETE: "Delete",

  TEMPLATE_ACTIVATED: "Template activated successfully.",
  TEMPLATE_DEACTIVATED: "Template deactivated successfully.",
  STATUS: "Status",
  IN_USE: "In Use",
  NOT_USED: "Not in Use",
  UPDATING: "Updating",
  DUPLICATE: "Duplicate",
  DUPLICATE_TEMPLATE: "Duplicate Template",
  SAVE: "Save",
  SAVING: "Saving",
  SAVE_AS_CLINIC_TEMPLATE: "Save as Clinic Template",
  LOADING_TEMPLATE: "Loading template",
  CREATING_TEMPLATE: "Creating template",
  SAVING_TEMPLATE: "Saving template",

  SMS_CREATE_BOOKING: "SMS - Booking Confirmation",
  SMS_RESCHEDULE_BOOKING: "SMS - Booking Reschedule",
  EDIT_SMS_TEMPLATE: "Edit SMS Template",
  MESSAGE_CONTENT: "Message Content",
  VARIABLES: "Variables",
  INSERT_VARIABLE_HINT: "Click or drag a variable to insert it at the cursor, or type {{ in the message to search.",
  CHARACTERS: "characters",
  SMS_CHAR_LIMIT_HINT: "The count is based on the message with example patient and clinic details filled in. The real details may make it slightly longer or shorter.",
  SMS_CHAR_LIMIT_EXCEEDED: "The message is over the 300 character limit. Please shorten it before saving.",
  SMS_TODAY: "Today",
  SMS_TEXT_MESSAGE: "Text Message",
  SMS_PREVIEW_EMPTY: "Start typing to preview the message",

  DRAG_ELEMENTS_AND_DROP_ON_PAGE: "Drag the content modules below onto the page to edit them.",
  PREVIEW: "Preview",
  SCALE: "Scale",
  ZOOM_OUT: "Zoom Out",
  ZOOM_IN: "Zoom In",
  RESET_SCALE: "Reset Scale",

  CONTENT: "Content",
  TEXT: "Text",
  LAYOUT: "Layout",
  COLUMNS: "Columns",
  LINE_DIVIDER: "Line Divider",
  MEDIA: "Media",
  IMAGE: "Image",
  SIGNATURE: "Signature",
  PAGE_SIZE: "Page Size",
  PAGE_MARGIN: "Page Margin",
  PAGE_SETTINGS: "Page Settings",
  SELECT_ELEMENT_TO_EDIT_HINT: "Click an element on the page to edit its settings here.",

  TEXT_PARAGRAPH: "Text Paragraph",
  ENTER_CONTENT_HERE: "Enter content here",
  FONT_SIZE: "Font Size",
  BOLD: "Bold",
  ITALIC: "Italic",
  UNDERLINE: "Underline",
  ALIGNMENT: "Alignment",
  TEXT_COLOUR: "Text Colour",
  BOTTOM_MARGIN: "Bottom Margin",

  DYNAMIC_FIELD: "Label and Preset Content",
  LABEL: "Label",
  LABEL_FONT_SIZE: "Label Font Size",
  VALUE_FONT_SIZE: "Value Font Size",
  VALUE_COLOUR: "Value Colour",
  LABEL_COLOUR: "Label Colour",

  TWO_COLUMNS: "Two Columns",
  COLUMN_GAP: "Column Gap",
  LEFT_WIDTH_RATIO: "Left Column Width",
  RIGHT_WIDTH_RATIO: "Right Column Width",
  HORIZONTAL_LINE: "Horizontal Line",
  LINE_WIDTH: "Line Width",
  COLOUR: "Colour",
  SPACING: "Spacing",
  HEIGHT: "Height",
  MINIMUM_HEIGHT: "Minimum Height",
  PRACTITIONER_SIGNATURE: "Practitioner Signature",
  CLINIC_LOGO: "Clinic Logo",

  CLEAR: "Clear",
  LEFT: "Left",
  CENTER: "Center",
  RIGHT: "Right",
  JUSTIFY: "Justify",
  MANUAL_INPUT: "Manual Input",
  AUTOMATIC_FIELDS: "Preset Fields",
  USER_INPUT_FIELDS: "Fields Requiring User Input",
  USER_INPUT: "Requires User Input",
  USER_INPUT_FIELD_HINT: "The user must fill in this content before generating the document.",
  DRAG_OR_CLICK_VARIABLE_HINT: "Drag or click to insert",
  VARIABLE_PALETTE_TITLE: "Insert Variables",
  VARIABLE_PALETTE_PANEL_HINT: "Drag a variable onto the text box, or click it to insert at the cursor.",
  INSERT_PRESET_VARIABLES: "Insert Preset Content",
  SELECT_PRESET_OPTIONS: "Select Preset Content",
  SHOW_PREVIEW: "Show Preview",
  TOOLBAR_SIZE: "Size",
  TOOLBAR_COLOUR: "Colour",
  TOOLBAR_THICKNESS: "Thickness",

  PRACTITIONER_NAME: "Practitioner Name",
  CMBA_NUMBER: "CMBA Number",
  CLINIC_NAME: "Clinic Name",
  CLINIC_ADDRESS: "Clinic Address",
  PATIENT_NAME: "Patient Name",
  PATIENT_DOB: "Patient Date of Birth",
  BOOKING: "Booking",
  BOOKING_CODE: "Booking Code",
  BOOKING_START_DATE: "Booking Start Date",
  BOOKING_START_TIME: "Booking Start Time",
  BOOKING_PATIENT_NAME: "Booking Patient Name",
  PRACTITIONER_PHONE: "Practitioner Phone",
  TODAY_DATE: "Today's Date",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  FREE_TEXT: "Free Text",
  CONSULTED_DATE: "Consultation Date",
  UNFIT_UNTIL_DATE: "Unfit for Work Until",

  PERMISSION_ROLES: "Permission Roles",
  PERMISSION_ROLES_HINT: "Create custom roles for your clinic, built from a shared set of permissions.",
  CLINIC_ROLES: "Clinic Roles",
  CLINIC_ROLES_SECTION_HINT: "Roles created by your clinic — fully editable.",
  NO_CLINIC_ROLE_YET: "No clinic roles yet. Create one to get started.",
  SYSTEM_ROLES: "System Roles",
  SYSTEM_ROLES_HINT: "Default roles provided by Healthnex — read-only.",
  SYSTEM: "System",
  NEW_CLINIC_ROLE: "New Clinic Role",
  EDIT_CLINIC_ROLE: "Edit Clinic Role",
  SEARCH_ROLES: "Search roles",
  ROLE_NAME_EN: "Role Name (English)",
  ROLE_NAME_CN: "Role Name (Chinese)",
  ROLE_NAME_TH: "Role Name (Thai)",
  ROLE_NAME_VN: "Role Name (Vietnamese)",
  ROLE_NAME_IS_REQUIRED: "Role name (English) is required.",
  TRANSLATING: "Translating",
  PERMISSIONS: "Permissions",
  SELECTED: "selected",
  CLEAR_ALL: "Clear All",
  SEARCH_PERMISSIONS: "Search permissions",
  NO_PERMISSIONS_FOUND: "No permissions found",
  X_PERMISSIONS_ASSIGNED: "{{X}} permissions assigned",
  X_PERMISSIONS_ADDED: "{{X}} added",
  X_PERMISSIONS_REMOVED: "{{X}} removed",
  REMOVED: "Removed",
  PERMISSION_DIFF_VS_CURRENT_HINT: "Showing how this role's permissions differ from the practitioner's current role.",
  NO_PERMISSIONS_ADDED_VS_CURRENT: "No permissions are added compared to the current role.",
  NO_PERMISSIONS_REMOVED_VS_CURRENT: "No permissions are removed compared to the current role.",
  DELETE_ROLE: "Delete Role",
  ROLE_NAME: "Role Name",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ROLE: "Are you sure you want to delete this role",
  NO_DATA: "No data",
  ROLE_CREATE_SUCCESS: "Role created successfully.",

  PERMISSION_ASSIGNMENT: "Permission Assignment",
  CURRENT_ROLE: "Current Role",
  CURRENT_PERMISSIONS: "Current Permissions",
  VIEW_PERMISSIONS: "View Permissions",
  RESET_TO_CURRENT_ROLE: "Reset to current role",
  SWITCH_TO_THIS_ROLE: "Switch to this role's permissions",
  NO_PERMISSIONS_ASSIGNED: "No permissions assigned.",
  REASSIGN_ROLE: "Reassign Role",
  SELECT_ROLE_TO_ASSIGN: "Select Role",
  PREVIEW_ROLE_PERMISSIONS: "Preview of this role's permissions",
}

export default {
  translation: {
    ...signUp,
    ...navigation,
    ...prescription,
    ...search,
    ...info,
    ...notification,
    ...appointment,
    ...clinicManagement,
    ...clinicHerbs,
    ...Library,
    ...packagePages,
    ...cmasaImport,
    ...camera,
    ...bookingPage,
    ...guide,
    ...patientConsent,
    ...agreements,
    ...freeTrialTerms,
    ...dashboard,
    ...patientList,
    ...templateEditor,
    // ---- New onboarding flow ----
    ABN: "ABN",
    RETRY: "Retry",
    ONBOARDING_STEP_X_OF_Y: "Step {{current}} of {{total}}",
    ONBOARDING_SHOW_MORE: "Show more ({{count}})",
    ONBOARDING_SHOW_FEWER: "Show fewer",
    ONBOARDING_USERNAME_CHECKING: "Checking availability…",
    ONBOARDING_USERNAME_HINT: "You’ll use this username to sign in to Healthnex.",
    ONBOARDING_ABOUT_TITLE: "Tell us about yourself",
    ONBOARDING_ABOUT_SUB: "Just a few quick details to get you started — this only takes a moment.",
    ONBOARDING_INVITE_EMAIL_LOCKED: "This is the email your invitation was sent to.",
    ONBOARDING_ACCOUNT_TITLE: "Create your account",
    ONBOARDING_ACCOUNT_SUB: "Nice to meet you{{greeting}}. Set up your sign-in.",
    ONBOARDING_PASSWORDS_MATCH: "Passwords match.",
    ONBOARDING_PASSWORDS_MUST_MATCH: "Passwords must match.",
    ONBOARDING_PASSWORD_HINT: "Enter the same password twice to confirm it. No special format is required.",
    ONBOARDING_CLINIC_DECISION_TITLE: "Would you like to create your first clinic?",
    ONBOARDING_CLINIC_DECISION_SUB: "You can set this up now, or explore Healthnex and do it later.",
    ONBOARDING_CLINIC_YES: "Yes, create my clinic",
    ONBOARDING_CLINIC_YES_DESC: "Set up your clinic, services and working hours now.",
    ONBOARDING_CLINIC_NOTNOW: "No, I’ll create my clinic later",
    ONBOARDING_CLINIC_NOTNOW_DESC: "Explore first — you can create or join a clinic anytime.",
    ONBOARDING_GETSTARTED_TITLE: "How would you like to get started?",
    ONBOARDING_GETSTARTED_SUB: "Choose the option that best matches your situation.",
    ONBOARDING_CREATE_CLINIC: "Create my clinic",
    ONBOARDING_CREATE_CLINIC_DESC: "Set up a new clinic and add its services, opening hours and your working details.",
    ONBOARDING_JOIN_CLINIC: "Join an existing clinic",
    ONBOARDING_JOIN_CLINIC_DESC: "Find an existing clinic, send a request to join, and add your practitioner details.",
    ONBOARDING_RECOMMENDED: "Recommended",
    ONBOARDING_YOUR_DETAILS_AT: "Your details at {{clinic}}",
    ONBOARDING_YOUR_DETAILS_SUB: "Select the services or therapies you provide and set your usual working hours at this clinic.",
    ONBOARDING_YOUR_THERAPIES: "Your services or therapies",
    ONBOARDING_PROPOSED_HOURS: "Your proposed working hours",
    ONBOARDING_JOIN_TITLE: "Find your clinic",
    ONBOARDING_JOIN_SUB: "Search for the clinic you’d like to join and send a request.",
    ONBOARDING_JOIN_SEARCH_LABEL: "Clinic name",
    ONBOARDING_JOIN_PENDING: "Pending approval",
    ONBOARDING_JOIN_CONFIRM_BODY: "Your request to join {{clinic}} will be sent when you finish. You can keep setting up your account while the clinic reviews it.",
    ONBOARDING_JOIN_CHANGE: "Choose a different clinic",
    ONBOARDING_JOIN_REQUEST: "Clinic Join Request",
    ONBOARDING_JOIN_STATUS: "Request status",
    ONBOARDING_SUBMIT_JOIN: "Send your join request",
    ONBOARDING_ERR_SELECT_CLINIC: "Search for and select a clinic to join.",
    ONBOARDING_LABEL_JOIN: "Join a clinic",
    ONBOARDING_CLINIC_DETAILS_TITLE: "Set up your clinic",
    ONBOARDING_CLINIC_DETAILS_SUB: "Just the essentials for now — you can fill in the rest anytime.",
    ONBOARDING_CREATE_CLINIC_PROMO: "Limited-time offer! New clinics get 3 months free trial! (First 3 clinics only)",
    ONBOARDING_CAPACITY: "Beds / rooms",
    ONBOARDING_CAPACITY_HINT: "The number of treatment beds or rooms at your clinic.",
    ONBOARDING_OPENING_HOURS: "Clinic opening hours",
    ONBOARDING_OPENING_HOURS_HINT: "The hours your clinic is open to patients.",
    ONBOARDING_OPENING_FROM: "Opens at",
    ONBOARDING_OPENING_TO: "Closes at",
    ONBOARDING_WORK_AT_CLINIC: "When do you work at {{clinic}}?",
    ONBOARDING_PRACTITIONER_TITLE: "Your services & working hours",
    ONBOARDING_PRACTITIONER_SUB: "Set the services you offer and the hours you work at this clinic. You can change these anytime.",
    ONBOARDING_PRACTITIONER_CLINIC_NOTE: "These settings will apply when you work at {{clinic}}.",
    ONBOARDING_PRACTITIONER_AT: "Practitioner at {{clinic}}",
    ONBOARDING_YOUR_MODALITIES: "Your services or modalities",
    ONBOARDING_SELECT_ALL_APPLY: "Select all that apply.",
    ONBOARDING_N_SELECTED: "{{count}} selected",
    ONBOARDING_WORKING_HOURS: "Working hours",
    ONBOARDING_WORKING_HOURS_HINT: "Weekdays are selected by default. Uncheck a day off, or adjust the times.",
    ONBOARDING_START_TIME: "start time",
    ONBOARDING_END_TIME: "end time",
    ONBOARDING_PRODUCTS_TITLE: "What services and products does your clinic offer?",
    ONBOARDING_PRODUCTS_SUB: "Add the service products your clinic offers. You can update them any time later.",
    ONBOARDING_PRODUCTS_OPTIONAL: "You can skip this for now and add your services later.",
    ONBOARDING_CLINIC_SERVICES: "Clinic Services",
    ONBOARDING_WELCOME_TITLE: "You're all set!",
    ONBOARDING_WELCOME_BODY: "Your account is ready to go. Explore your dashboard to manage appointments, patients, and more.",
    ONBOARDING_YOUR_WORKING_HOURS: "Your Working Hours",
    ONBOARDING_STANDARD_OPENING_HOURS: "Standard opening hours",
    ONBOARDING_PRICE_LIST: "Price list",
    ONBOARDING_SELECTED_MODALITIES: "Your selected modalities",
    ONBOARDING_OTHER_MODALITIES: "Other modalities",
    ONBOARDING_ADD_ANOTHER_MODALITY: "Add another modality",
    ONBOARDING_ADD_SERVICE: "Add service",
    ONBOARDING_REMOVE_SERVICE: "Remove service",
    ONBOARDING_ERR_PRODUCT_NAME: "Enter a product name.",
    ONBOARDING_INVITE_CHECKING: "Checking your invitation…",
    ONBOARDING_INVITE_VALID: "Invitation confirmed. You’ll join this clinic after registering.",
    ONBOARDING_INVITE_VALID_NAMED: "You’ve been invited to join {{clinic}}. You’ll join after registering.",
    ONBOARDING_INVITE_INVALID: "We couldn’t verify this invitation. Please check the link and try again.",
    ONBOARDING_INVITE_EXPIRED: "This invitation has expired. Ask your clinic to send a fresh one.",
    ONBOARDING_SUMMARY_TITLE: "Review & finish{{greeting}}",
    ONBOARDING_SUMMARY_SUB: "Check everything looks right, then finish to create your account.",
    ONBOARDING_SUBMITTING_SUB: "Setting up your account…",
    ONBOARDING_PERSONAL_INFO: "Personal information",
    ONBOARDING_CLINIC_CREATED_TITLE: "New Clinic",
    ONBOARDING_NAME: "Name",
    ONBOARDING_ACCOUNT: "Account",
    ONBOARDING_HOURS: "Hours",
    ONBOARDING_NONE: "None",
    ONBOARDING_NO_PRODUCTS: "No services added.",
    ONBOARDING_SUBMIT_ACCOUNT: "Create your account",
    ONBOARDING_SUBMIT_AUTH: "Sign you in",
    ONBOARDING_SUBMIT_CLINIC: "Create your clinic",
    ONBOARDING_SUBMIT_PRODUCTS: "Add your services",
    ONBOARDING_SUBMIT_MEMBER: "Set your capacity",
    ONBOARDING_SUBMIT_SETTINGS: "Save your services & hours",
    ONBOARDING_SUBMIT_FAILED: "Something went wrong. Your details are saved — you can retry.",
    ONBOARDING_FINISH: "Finish setup",
    ONBOARDING_BACK_TO_SIGNIN: "Back to sign in",
    ONBOARDING_LABEL_ABOUT: "About you",
    ONBOARDING_LABEL_ACCOUNT: "Your account",
    ONBOARDING_LABEL_CLINIC_Q: "Your clinic",
    ONBOARDING_LABEL_CLINIC: "Clinic details",
    ONBOARDING_LABEL_PRACTITIONER: "Services & hours",
    ONBOARDING_LABEL_PRODUCTS: "Price list",
    ONBOARDING_LABEL_SUMMARY: "Review",
    ONBOARDING_ERR_FIRST_NAME: "Enter your first name.",
    ONBOARDING_ERR_LAST_NAME: "Enter your last name.",
    ONBOARDING_ERR_EMAIL: "Enter your email.",
    ONBOARDING_ERR_EMAIL_INVALID: "Enter a valid email address.",
    ONBOARDING_ERR_PHONE: "Enter your phone number.",
    ONBOARDING_ERR_PHONE_MOBILE: "Enter your mobile number.",
    ONBOARDING_ERR_PHONE_INVALID: "Enter a valid Australian mobile number, e.g. 0412345678.",
    ONBOARDING_ERR_GENDER: "Select a gender.",
    ONBOARDING_ERR_USERNAME: "Choose a username.",
    ONBOARDING_ERR_USERNAME_CHECK: "Please wait for the username check to finish.",
    ONBOARDING_ERR_PASSWORD: "Choose a password.",
    ONBOARDING_ERR_CONFIRM: "Re-enter your password.",
    ONBOARDING_ERR_MISMATCH: "Passwords don’t match.",
    ONBOARDING_ERR_CLINIC_NAME: "Enter a clinic name.",
    ONBOARDING_ERR_ADDRESS: "Enter the clinic address (street, suburb, state and postcode).",
    ONBOARDING_ERR_CLINIC_CREATE_FAILED: "We couldn't create your clinic. Please try again.",
    ONBOARDING_ERR_CHOOSE: "Choose an option to continue.",
    ONBOARDING_ERR_MODALITY: "Select at least one service or modality.",
    ONBOARDING_ERR_WORKING_DAY: "Select at least one working day.",
    ONBOARDING_ERR_PRODUCT_ROW: "Complete or remove the highlighted service (type, item name and a valid price).",
    ONBOARDING_CONTACT_TITLE: "How can we contact you?",
    ONBOARDING_CONTACT_SUB: "We’ll use these details to reach you about your account and bookings.",
    ONBOARDING_CLINIC_LOCATION_TITLE: "Where is your clinic?",
    ONBOARDING_CLINIC_LOCATION_SUB: "Add your clinic’s address so patients can find you.",
    ONBOARDING_CLINIC_HOURS_TITLE: "Clinic opening hours",
    ONBOARDING_CLINIC_HOURS_SUB: "Set the hours your clinic is open. These are separate from your own working hours.",
    ONBOARDING_CLINIC_CAPACITY_TITLE: "Capacity & opening hours",
    ONBOARDING_CLINIC_CAPACITY_SUB: "How many people your clinic and you can see, and when you're open.",
    ONBOARDING_MODALITIES_TITLE: "Your services or modalities",
    ONBOARDING_MODALITIES_TITLE_AT: "Your modalities at {{clinic}}",
    ONBOARDING_MODALITIES_SUB: "Select the services or therapies you provide here. You can change these anytime.",
    ONBOARDING_WORKING_TITLE: "Your working hours",
    ONBOARDING_WORKING_TITLE_AT: "Your working hours at {{clinic}}",
    ONBOARDING_PROPOSED_WORKING_TITLE_AT: "Your proposed working hours at {{clinic}}",
    ONBOARDING_WORKING_SUB: "Set the days and times you usually work. You can change this anytime.",
    ONBOARDING_PROPOSED_WORKING_SUB: "Propose the days and times you’d like to work. These aren’t active until the clinic approves your request.",
    ONBOARDING_PRACTITIONER_CAPACITY: "Max clients served simultaneously",
    ONBOARDING_PRACTITIONER_CAPACITY_HINT: "How many clients you can see at the same time. This cannot exceed the clinic's bed capacity.",
    ONBOARDING_PRACTITIONER_CAPACITY_HINT_WITH_MAX: "How many clients you can see at the same time (this clinic has {{max}} beds/rooms, so it can't exceed that).",
    ONBOARDING_WORKING_OPTIONAL_NOTE: "This step is optional — set your working hours now, or later in Clinic Settings.",
    ONBOARDING_WORKING_NOT_SET: "Not set",
    ONBOARDING_WORKING_LATER: "You can configure your working hours later in Clinic Settings.",
    ONBOARDING_SET_UP: "Set up",
    ONBOARDING_JOIN_REVIEW_TITLE: "Confirm your clinic",
    ONBOARDING_JOIN_REVIEW_SUB: "Check this is the right clinic before sending your request.",
    ONBOARDING_JOIN_SELECTED: "Selected: {{clinic}}",
    ONBOARDING_SKIP_WORKING_HOURS: "Skip working hours for now",
    ONBOARDING_SKIP_SERVICES: "I’ll add these later",
    ONBOARDING_LABEL_CONTACT: "Contact",
    ONBOARDING_LABEL_LOCATION: "Location",
    ONBOARDING_LABEL_HOURS: "Capacity & hours",
    ONBOARDING_LABEL_MODALITIES: "Modalities",
    ONBOARDING_LABEL_WORKING: "Working hours",
    ONBOARDING_LABEL_JOIN_SEARCH: "Find a clinic",
    ONBOARDING_LABEL_JOIN_REVIEW: "Confirm clinic",
    ONBOARDING_JOIN_NORESULT_TITLE: "We couldn’t find that clinic",
    ONBOARDING_JOIN_NORESULT_BODY: "Check the clinic name and try again. You can also skip this step and create or join a clinic later.",
    ONBOARDING_JOIN_TRY_ANOTHER: "Try another search",
    ONBOARDING_JOIN_ERROR_TITLE: "Something went wrong while searching",
    ONBOARDING_SKIP_CLINIC_SETUP: "Skip clinic setup for now",
    ONBOARDING_NO_CLINIC_NOTE: "Your account is ready. You can explore Healthnex, but clinical features become available after you create or join a clinic.",
    ONBOARDING_ERR_SERVICE_NAME: "Enter a service name.",
    ONBOARDING_ERR_SERVICE_PRICE: "Enter a valid price.",
    BACK: "Back",
    CLOSE: "Close",
    ONLINE_ZOOM_MEETING: "Online Zoom Meeting",
    KEY_MEMBERS: "Key Members",
    INTRODUCTION: " Brief Introduction",
    LOAD_MORE: "Load More",
    CURRENT: "Current",
    HISTORY_EVENT: "History Events",
    HISTORY_CPD: "History CPD",
    HISTORY: "In the Past",
    EXPIRED: "Expired",
    MONTH_FORMAT: "MMMM",
    EDIT: "Edit",
    FROM: "From",
    TO: "To",
    TOTAL_X: "Total {{X}} Records",
    OTHER_LANGUAGE_VERSION: "中文版",
    CLINIC: "Clinic",
    HRS: "hrs",
    VIEW: "View",
    LOADING: "Loading",
    VIEW_ALL: "View All",
    NO_INPUT_YET: "[No Info Provided]",
    U_ARE_EDITING: "You are editing the",
    X_WEBSITE: "{{X}} Ver. of the Website",
    SWITCH_TEMPLATE: "Switch Template",
    TERMS_AND_CONDITIONS: "Terms and Conditions",
    PRIVACY_POLICY: "Privacy Policy",
    INITIATING: "Initiating",
    FAILED_TO_ACCESS_MICROPHONE: "Failed to access microphone",
    LISTENING: "Listening",
    TRANSCRIBING: "Transcribing",
    SPEECH_TO_TEXT: "Speech to Text",
    STOP_RECORDING: "Stop Recording",
    DISPLAYED: "Displayed",
    RECORDS: "Records",
    X_RECORDS: "{{X}} Records",
    WITH_TOTAL_X_RECORDS: "with Total {{X}} Records",
    ALL_X_RECORDS_LOADED: "All {{X}} Records Loaded",
    AI_AUTO_TRANSLATE: "AI Translate",
    ADD_TO_CLINIC_FORMULA: "Add to Clinic Formula",
    NON_PREMIUM: "Non Premium",
    NON_TOXIC: "Non Toxic",
    APPOINTMENT_HISTORY: "Appointment History",
    ADJUST_APPOINTMENT_TIME: "Adjust Appointment Time",
    ADJUST_NOW: "Adjust Now",
    I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_PROCEED:
      "I understand the action and agree to proceed",
    PLEASE_NOTE_CHANGING_APPOINTMENT_DURATION_MIGHT_CAUSE_OVERBOOKING_TO_OTHER_EXISTING_APPOINTMENT:
      "Please note changing appointment duration may cause overbooking to other existing appointment",
    NEXT_WEEK: "Next Week",
    JUMP_TO_TODAY: "Jump to Today",
    APPOINTMENTS_PENDING_FOR_SCHEDULE: "Appointments Pending for Schedule",
    X_APPOINTMENTS_PENDING_FOR_YOUR_SCHEDULE:
      "{{X}} overbooking pending for your schedule",
    RELOAD: "Reload",
    CANNOT_RESCHEDULE_WITHIN_24_HOURS: "Cannot reschedule within 24 hours",
    PREV_WEEK: "Prev Week",
    PENDING_APPROVAL: "Pending Approval",
    SUBSCRIBE: "Subscribe",
    THIS_ITEM_WILL_NOT_LONGER_BE_ABLE_TO_BE_USED_IN_THIS_CLINIC:
      "This item will not longer be able to be used in this clinic",

    PLEASE_SELECT_A_VIDEO: "Please select a video",
    PLEASE_SELECT_A_COVER_IMAGE: "Please select a cover image",
    RESCHEDULE: "Reschedule",
    RESCHEDULE_APPOINTMENT: "Reschedule Appointment",
    CURRENT_APPOINTMENT_TIME: "Current appointment time",
    NEW_APPOINTMENT_TIME: "New appointment time",
    NOT_SELECTED: "Not selected",
    LINK_APPOINTMENT_TO_PATIENT_SUCCESS:
      "Appointment successfully linked to the patient",
    LINK_APPOINTMENT_TO_PATIENT: "Link appointment to patient",
    ACCEPT_APPOINTMENT: "Accept appointment",
    PROCEED_TO_PATIENT_INFO: "Proceed to patient info",
    CONFIRM_RESCHEDULE: "Confirm reschedule",
    APPOINTMENT_DATE: "Appointment date",
    PENDING_APPOINTMENT: "Pending appointment",
    PENDING_APPOINTMENTS: "Pending appointments",
    PENDING_SCHEDULE: "Pending schedule",
    LINK_TO_PATIENT: "Link to patient",
    LINK_TO_ANOTHER_PATIENT: "Link to another patient",
    LINK_ANOTHER_PATIENT_FROM_CLINIC_TO_THIS_APPOINTMENT:
      "Link another patient from your clinic to this appointment",
    THIS_PACKAGE_IS_ONLY_FOR_YOUR_CLINIC_PLZ_CREATE_ONE:
      "This package is applicable to your clinic, please create one first",
    CLEAR: "Clear",
    YOUR_WORKING_CLINICS: "Your working clinics",
    ALL: "All",
    SEARCH_PACKAGE: "Search package",
    SEARCH_TREATMENT: "Search treatment",
    X_APPOINTMENTS_PENDING: "{{X}} appointments pending",
    X_MODALITIES_INCLUDES: "{{X}} modalities included",
    ARE_U_SURE_TO_ACCEPT_THIS_APPOINTMENT_SCHEDULE:
      "Are you sure you want to accept this appointment schedule?",
    OVERBOOKING_ACCEPTED: "Overbooking accepted",
    RESCHEDULE_SUCCESS: "Reschedule successful",
    AN_CONFIRMATION_SMS_WILL_SEND_TO_PATIENT_TO_CONFIRM_THE_RESCHEDULE:
      "An confirmation SMS will send to the patient again",
    CONTINUE: "Continue",
    VIEW_THIS_DATE_SCHEDULE: "View this date’s schedule",
    PLS_NOTE_THIS_CLINIC_INFO_WILL_BE_SUBMITTED_FOR_APPROVAL:
      "Please note this clinic information will be submitted for approval",
    YOU_WILL_BE_NOTIFIED_WHEN_APPROVAL_IS_DONE:
      "You will be notified when approval is completed",
    SUBMIT_CONFIRM: "Submit confirmation",
    PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: "Please fill in all required fields",
    CLINIC_CREATE_REQUEST_SENT: "Clinic creation request sent",
    UPDATE_CONFIRM: "Update confirmation",
    ARE_YOU_SURE_TO_UPDATE_YOUR_CLINIC_INFO:
      "Are you sure you want to update your clinic information?",
    CLINIC_UPDATED: "Clinic information updated",
    CLOSED_CLINIC_SUCCESS: "Clinic closed successfully",
    PROTECTED_PAGE: "This Page Requires Clinic Access",
    PROTECTED_PAGE_WARNING: "You need proper access to view this page.",
    TO_START_YOUR_WORK_PLS_IDENTIFY_YOUR_ROLE:
      "To provide you with accurate guidance, please select your role (Clinic Owner or Practitioner).",
    IF_UR_CLINIC_OWNER: "If you are a clinic owner / individual practice",
    IF_UR_CLINIC_OWNER_CREATE_UR_CLINIC:
      "If you are a clinic owner / individual practice, please create your clinic and its related information. Later on you can invite other clinic members to join your clinic.",
    IF_UR_CLINIC_PRACTITIONER: "If you are a clinic member",
    IF_UR_CLINIC_PRACTITIONER_SEARCH_FOR_THE_CLINIC_YOU_WISH_TO_JOIN_AND_SUBMIT_A_JOIN_REQUEST:
      "If you are a clinic member, please search for the clinic you wish to join and submit a join request.",
    SKIP_USER_GUIDE: "Skip System Guide",
    USER_GUIDE_WILL_GUIDE_THROUGH_HOW_AND_WHERE_TO_CREATE_JOIN_A_CLINIC:
      "The user guide will guide you through how and where to create and join a clinic.",
    START_NOW: "Start Now",
    ACCEPT_INVITE: "Accept Invite",
    ARE_YOU_SURE_TO_ACCEPT_INVITE:
      "Are you sure you want to accept the invitation from this clinic?",
    REJECT_INVITE: "Reject Invite",
    ARE_YOU_SURE_TO_REJECT_INVITE:
      "Are you sure you want to reject the invitation from this clinic?",
    RESPONSE_SUCCESS: "Response successful",
    JOIN_REQUEST_SENT: "Join request sent",
    SEND_JOIN_REQUEST: "Send Join Request",
    JOIN_REQUEST_SENT_SHORT: "Join Request Sent",
    REQUEST_ACCEPTED: "Request accepted",
    INVITATION_SENT: "Invitation sent",
    NO_PACKAGES: "No packages",
    X_PRACTITIONERS_ARE_NOW_INACTIVE: "{{X}} practitioners are now inactive",
    ACTIVE_CONFIRM: "Active Confirm",
    ACTIVATE: "Activate",
    INACTIVE_CONFIRM: "Inactive Confirm",
    ARE_YOU_SURE_TO_INACTIVE: "Are you sure you want to set as inactive?",
    INACTIVE_PRACTITIONERS_ARE_NOT_ALLOWED_TO_BE_BOOKED_BY_PATIENT:
      "Inactive practitioners cannot be booked by patients",
    REJECTED: "Rejected",
    RESUBMIT: "Resubmit",
    DELETE_APPLICATION: "Delete Application",
    ARE_YOU_SURE_TO_DELETE_THIS_APPLICATION:
      "Are you sure you want to delete this application",
    REBUILD_CLINIC: "Resubmit Clinic",
    DELETE_APPLICATION_SUCCESS: "Application deleted successfully",
    SEARCH_CLINIC_BY_NAME: "Search clinic by name",
    OTHER_PRACTITIONERS_ARE_NO_VISIBLE:
      "Other practitioners are not visible to non-clinic workers",
    DECLINE_JOIN_INVITATION_CONFIRM: "Decline join invitation confirm",
    ARE_YOU_SURE_TO_CANCEL_QUIT_FROM_CLINIC:
      "Are you sure you want to cancel quitting from the clinic?",
    SECTION_UNPUBLISHED: "Section Unpublished",
    SECTION_PUBLISHED: "Section Published",
    REFRESH: "Refresh",
    CHANGE_THIS_BOOKING_DURATION: "Change this booking duration",
    ARE_YOU_SURE_TO_CHANGE_THIS_APPOINTMENT_DURATION_FOR_X:
      "Are you sure you want to change this appointment duration for {{X}}?",
    BOOKING_DURATION_ADJUST_SUCCESS: "Booking duration adjusted successfully",
    NO_PENDING_APPOINTMENTS: "No pending appointments",
    ASSIGN_OWNERSHIP: "Make this User a Co-owner of the Clinic",
    STOP_BEING_CLINIC_OWNER: "Stop Being a Clinic Owner",
    CONFIRM_TO_ADD_CLINIC_CO_OWNER: "Are you sure you want to make {{name}} a co-owner of the clinic?",
    CLINIC_CO_OWNER_ADDED_SUCCESS: "Clinic co-owner added successfully",
    TRANSFER_OWNERSHIP: "Transfer Ownership",
    CONFIRM_TO_TRANSFER_CLINIC_OWNERSHIP: "Are you sure you want to transfer clinic ownership to {{name}}?",
    CLINIC_OWNERSHIP_TRANSFERRED_SUCCESS: "Clinic ownership transferred successfully",
    TRANSFER_OWNERSHIP_AND_QUIT_CLINIC: "Transfer Ownership & Quit Clinic",
    SELECT_A_SUCCESSOR_TO_TRANSFER_OWNERSHIP_AND_QUIT_HINT: "Select a practitioner to transfer clinic ownership to. Once transferred, you will quit this clinic.",
    CLINIC_OWNERSHIP_TRANSFERRED_AND_QUIT_SUCCESS: "Ownership transferred and you have quit the clinic",
    CONFIRM_TO_EXIT_CLINIC_OWNERSHIP: "Are you sure you want to give up ownership of {{name}}?",
    EXIT_CLINIC_OWNERSHIP_SUCCESS: "You are no longer an owner of this clinic",
    CANNOT_EXIT_OWNERSHIP_NO_OTHER_OWNER:
      "You are currently the only owner of this clinic, so you can't step down. If you want to stop operating this clinic, please use \"Close Clinic\" instead.",
    ARE_YOU_SURE_TO_ASSIGN_OWNERSHIP_TO:
      "Are you sure you want to assign ownership to",
    YOU_WILL_BE_LOST_ALL_OWNER_PERMISSIONS_IN_THIS_CLINIC:
      "You will lose all owner permissions in this clinic",
    ACTIONS_REQUIRED_OWNER_PERMISSION: "This action requires owner permission",
    SUBSCRIBE_PACKAGE_TO_UNLOCK_FEATURE:
      "Please upgrade or subscribe to unlock access",
    FEATURE_LOCKED: "Service Currently Locked",
    PAY_SUCCESSFUL: "Payment successful",
    OWNER_CHANGED: "Ownership changed",
    VIEW_PATIENT_INFO: "View Patient Info",
    VIEW_PATIENT_INFO: "View Patient Info",
    CLINIC_QR_CODE: "Clinic QR Code",
    APPOINTMENT_QR_CODE: "Appointment QR Code",
    DOWNLOAD: "Download",
    SIGNATURE: "Signature",
    MANAGE_YOUR_SIGNATURE: "Manage your Signature",
    UPLOAD_SIGNATURE_FROM_DEVICE: "Upload Signature File from Device",
    VIEW_SIGNATURE: "Download signature",
    SIGNATURE_USAGE_MSG:
      "Your signature will be used for automatic signing when issuing prescriptions.",
    UPLOAD_SIGNATURE_CONSENT:
      "By uploading your signature, you consent to its use within the Healthnex system where applicable.",
    ARE_YOU_SURE_TO_CLEAR_ALL_SELECTED_ITEMS:
      "Are you sure you want to clear all selected items?",
    RECORD_VIDEO: "Record Video",
    NO_RESULTS_FOUND: "No results found",
    PRESS_ENTER_TO_CREATE: "Press Enter to create",
    CREATING: "Creating",
    CREATE_CLINIC_ITEM: "Create clinic item",
    NAME_CN: "Name (Chinese)",
    NAME_EN: "Name (English)",
    CREATE: "Create",
    YOU_CAN_EDIT_THIS_LATER:
      "You only need to provide a name for now. You can complete the details of this clinic item later in the Clinic Resource Management section.",
    OPTION: "Option",
    CONFIGURE_CLINIC_OPTION: "Configure clinic option",
    CLINIC_OPTIONS: "Clinic options",
    OPTION_ITEM_INFO: "Option item information",
    ADD_ITEM: "Add item",
    PLZ_INPUT_ITEM_NAME_CN: "Please enter the item name in Chinese",
    PLZ_INPUT_ITEM_NAME_EN: "Please enter the item name in English",
    PLZ_INPUT_ITEM_NAME_X: "Please enter the item name in {{X}}",
    SEARCH_OPTION_ITEM_NAME: "Search option item name",
    SIGN_AND_UPLOAD: "Sign and Upload",
    DRAW_YOUR_SIGNATURE: "Draw your signature",
    SIGNATURE_UPLOADED: "Signature uploaded",
    SIGNATURE_DELETED: "Signature deleted",
    NO_RECORDS_FOUND: "No records found",
    CLINIC_POINT_GROUPS: "Clinic point groups",
    CONFIGURE_CLINIC_POINT_GROUPS: "Configure clinic point groups",
    ADD_POINT_GROUP: "Add Pt. Group",
    ALL_POINTS_IN_X_HAS_ADDED: "All points in {{X}} has been added",
    POINT_GROUPS_NAME: "Point group name",
    POINT_GROUPS_NAME_IN_X: "Point group name({{X}})",
    POINT_GROUP_INFO: "Point group information",
    PLZ_INPUT_POINT_GROUP_NAME_CN:
      "Please enter the point group name in Chinese",
    PLZ_INPUT_POINT_GROUP_NAME_EN:
      "Please enter the point group name in English",
    PLZ_INPUT_POINT_GROUP_NAME_X: "Please enter the point group name in {{X}}",
    SEARCH_POINT_NAME_HERE: "Search point name here",
    POINTS_IN_THIS_GROUP: "Points in this group",
    ADD_TO_CLINIC_POINT_GROUPS: "Add to clinic point groups",
    NO_POINT_ADDED: "No point added",
    CONTINUE: "Continue",
    REMOVE_PRACTITIONER_SUCCESS: "Practitioner removed successfully",
    SEARCHING_CLINICS: "Searching clinics...",
    INVITE_SUCCESS: "Invitation sent successfully",
    ITEM_CREATED: "Item created successfully",
    PRACTITIONER_QUIT_REJECTED: "Practitioner resignation rejected",
    PRACTITIONER_QUIT_ACCEPTED: "Practitioner resignation accepted",
    PLEASE_ADD_AT_LEAST_ONE_HERB: "Please add at least one herb",
    PLEASE_ADD_AT_LEAST_ONE_POINT: "Please add at least one point",
    INSURANCE_INFO_UPDATED: "Insurance information updated",
    REPORTING: "Reporting",
    CHECK_YOUR_REPORTING: "Check your reporting",
    CLINIC_REPORTING: "Clinic reporting",
    CHECK_YOUR_CLINIC_REPORTING: "Check your clinic reporting",
    SELECT_DEFAULT_DATE_UNIT: "Select default date unit",
    DAY: "Day",
    MONTH: "Month",
    YEAR: "Year",
    PATIENTS_AND_REVENUE: "Patients & Revenue",
    PATIENTS: "Patients",
    REVENUE: "Revenue",
    PEOPLE_UNIT: "people",
    AVERAGE_REVENUE: "Average revenue",
    PLEASE_SELECT_VALID_DATE_RANGE_90_DAYS:
      "Please select a valid date range within 90 days",
    PLEASE_SELECT_VALID_DATE_RANGE_36_MONTHS:
      "Please select a valid date range within 36 months",
    PLEASE_SELECT_VALID_DATE_RANGE_10_YEARS:
      "Please select a valid date range within 10 years",
    PRINT_INSTRUCTION: "Download Prescript.",
    PRINT_TCM_INSTRUCTION: "Download TCM Prescript.",
    PRINT_MASSAGE_INSTRUCTION: "Download Point Instruct.",
    MAXIMUM_NUMBER_OF_USERS: "Maximum number of users reached",
    HERB_WITH_ZERO_RAW_EXISTS_PLS_CHECK:
      "Dosage cannot be zero. Please check your prescription.",
    NO_GST: " (excludes GST)",
    INC_GST: " (includes GST)",
    PRESCRIPTION_RECORDS: "Prescription Records",
    CLINIC_SERVICES: "Clinic Services",
    LOADING_SERVICES: "Loading Services",
    AND_OTHER_COUNT: " and other {{count}}",
    WHO_IS_THIS_APPOINTMENT_FOR: "Who is this appointment for?",
    MYSELF: "Myself",
    SOMEONE_ELSE: "Someone else",
    ABOUT_YOU: "About You",
    ABOUT_THE_PATIENT: "About the Patient",

    PREVIOUS: "Previous",
    APPROVED: "Approved",
    I_AGREE_TO_RECEIVE_SMS: "I agree to receive SMS notifications about updates to this appointment.",
    I_AGREE_TO_RECEIVE_SMS_EMAIL: "I agree to receive SMS / email notifications about updates to this appointment.",
    SELECT_PRACTITIONER: "Select Practitioner",
    CREATE_APPOINTMENT: "Appointment",
    ADD_APPOINTMENT: "Create Appointment",
    NO_AVAILABLE_CLINIC: "No available clinic",
    NO_SERVICES_AVAILABLE: "No services available",
    IS_ALREADY_BOOKED: "is already booked by someone else",
    TIME_ALREADY_BOOKED: "Time already booked",
    YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
      "This booking triggers overbooking, but since it was created by you (the practitioner), it will be automatically approved by the system.",
    ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME:
      "Are you sure you want to book this time?",
    PLEASE_SELECT_AT_LEAST_ONE_SERVICE: "Please select at least one service",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    Mon: "Mon",
    Tue: "Tue",
    Wed: "Wed",
    Thu: "Thu",
    Fri: "Fri",
    Sat: "Sat",
    Sun: "Sun",
    Jan: "Jan",
    Feb: "Feb",
    Mar: "Mar",
    Apr: "Apr",
    Jun: "Jun",
    Jul: "Jul",
    Aug: "Aug",
    Sep: "Sep",
    Oct: "Oct",
    Nov: "Nov",
    Dec: "Dec",
    REMEDIAL_MASSAGE: "Remedial Massage",
    REMEDIAL_MASSAGE_OPTION: "Remedial Massage",
    DEEP_TISSUE_MASSAGE: "Deep Tissue Massage",
    SPORTS_MASSAGE: "Sports Massage",
    DRY_NEEDLING: "Dry Needling",
    CUPPING: "Cupping",
    PREGNANCY_MASSAGE: "Pregnancy Massage",
    MYOTHERAPY: "Myotherapy",
    ASSISTED_STRETCHING: "Assisted Stretching",
    TRIGGER_PT_THERAPY: "Trigger Point Therapy",
    MYOFASCIAL_RELEASE: "Myofascial Release",
    JOINT_MOBILISATION: "Joint Mobilisation",
    PHYSIO: "Physiotherapy",
    CHIRO: "Chiropractic",
    BEAUTY: "Beauty",
    COSMETIC_MEDICINE: "Cosmetic Medicine",

    SELECT_SERVICE: "Select {{service}} Service",
    MAXIMUM_NUMBER_OF_FILES: "Maximum number of files reached ({{X}})",
    MULTIPLE_SELECT: "Multiple Select",
    CANCEL_MULTIPLE_SELECT: "Cancel Multiple Select",
    ARE_YOU_SURE_TO_DELETE_THIS_APPOINTMENT_FOR_X:
      "Are you sure you want to delete this appointment for {{X}}? A cancellation notification will be sent to the patient.",
    DELETE_APPOINTMENT: "Delete Appointment",
    REJECT_APPOINTMENT: "Reject Appointment",
    SYSTEM_OPTIMIZED_FOR_DESKTOP: "This system is optimized for desktop usage.",
    RECOMMEND_DESKTOP_FOR_BEST_EXPERIENCE:
      "For the best experience, we recommend accessing the website through a desktop portal.",
    PROMOTION_CODE: "Promotion Code",
    PLEASE_SELECT_VALID_DATE_RANGE: "Please select a valid date range.",
    PLEASE_CHECK_THE_FORM: "Please check the form.",
    TIMESLOT_HAS_BOOKED_BY_OTHER_PATIENT:
      "This time slot has already been booked by another patient.",
    NO_AVAILABLE_TIMESLOT_FOUND_IN_THIS_DATE:
      "No available time slots for this date",
    APPOINTMENT_SCHEDULE_APPROVED: "The appointment has been approved",
    FORGOT_PASSWORD: "Forgot password",
    WE_SENT_VERIFY_CODE_PLEASE_CHECK_YOUR_SMS:
      "We have sent a verification code. Please check your SMS.",
    SEND_VERIFY_CODE: "Send verification code",
    RESEND_VERIFY_CODE: "Resend verification code",
    PLEASE_ENTER_YOUR_VERIFICATION_CODE: "Please enter your verification code",
    VERIFICATION_CODE: "Verification code",
    PLEASE_ENTER_YOUR_NEW_PASSWORD: "Please enter your new password",
    PLEASE_ENTER_YOUR_NEW_PASSWORD_AGAIN: "Please re-enter your new password",
    NEW_PASSWORD: "New password",
    SEND_TO: "Send to",
    OR: "OR",
    WE_WILL_SEND_VERIFY_CODE_PLEASE_CHECK_YOUR_SMS:
      "We will send a verification code. Please check your SMS.",
    WRONG_VERIFY_CODE: "The verification code is incorrect.",
    SMS_SEND_TOO_FREQUENT_WAIT_3_MIN_RETRY:
      "SMS sent too frequently. Please wait 3 minutes before retrying.",
    USERNAME_NOT_FOUND: "User information not found. Please check your input.",
    CHANGE_PASSWORD_SUCCESS: "Password changed successfully",
    SMS_SENT: "SMS Sent",
    REQUEST_REJECTED: "Request rejected",
    INVITED_SUCCESS: "Invitation sent successfully",
    CONTINUE: "Continue",
    VIP_PACKAGE_EXPIRED:
      "Your VIP subscription has expired or has been disabled. You no longer have permission to access this page.",
    RECORDING_TOO_SHORT: "Recording too short, unable to retrieve information!",
    TRANSCRIPT_EMPTY_TRY_AGAIN: "The content is empty. Please try again.",
    MORNING: "Morning",
    AFTERNOON: "Afternoon",
    DOWNLOAD_INVOICE: "Download Invoice",
    OTHER_PHOTO: "Other Photo",
    DIAGNOSIS_DESCRIPTION: "Description",
    SET_AS_HOME: "Set as Entry Page",
    APPOINTMENT_DETAILS: "Appointment Details",
    SEARCH_AND_USE_EXISTING_PATIENT_INFO:
      "Search and use existing patient information",
    OP_TYPE: "Option Type",
    CANCEL_INVITATION: "Cancel Invitation",
    ARE_U_SURE_TO_CANCEL_THIS_INVITATION:
      "Are you sure you want to cancel this invitation?",
    ARE_YOU_SURE_TO_DELETE_X_ITEMS:
      "Are you sure you want to delete {{X}} items?",
    PROFILE: "Profile",
    UPDATE: "Update",
    PROFILE_UPDATED: "Profile updated",
    INVITE_PRACTITIONER_TO_JOIN_CLINIC:
      "The practitioner you searched for may not be our user yet. Click the button below to invite them to create an account and join your clinic.",
    PRACTITIONER_U_SEARCHED_MAY_NOT_BE_USER_YET:
      "The practitioner you searched for may not be our system user yet.",
    CLICK_BUTTON_BELOW_TO_INVITE:
      "Click the button below to invite them to create an account and join your clinic!",
    INVITE_NEW_USER: "Invite New User",
    NEW_REQUESTS: "Pending Requests",
    PLZ_SIGN_IN: "Please sign in first",
    SELECT_YOUR_SPECIALTY: "Please select your service type",
    EXPIRED_AT: "Expired at",
    PENDING_USER_SIGNUP: "Pending User Signup",
    RESEND_EMAIL: "Resend Email",
    RESEND_EMAIL_SUCCESS: "Email sent successfully",
    DAYS_LEFT_X: "Expired in {{X}} days",
    ASSIGN_A_PACKAGE: "Assign a Package for this practitioner",
    ASSIGN_A_ROLE: "Assign a Role",
    PATIENT_CONSENT: "Patient Consent",
    PLEASE_SELECT_A_PACKAGE: "Please select a package",
    REJECT_SUCCESS: "Request rejected",
    ACCEPT_SUCCESS: "Request accepted",
    ARE_YOU_SURE_TO_DELETE_THIS_TEST: "Are you sure to delete this test?",
    FILE_TOO_LARGE_MAX_100MB:
      "File is too large. Maximum allowed size is 100MB.",
    BEST_UPLOAD_PRACTICE:
      "For the best experience, please keep each file under 100MB and ensure that recorded videos are ideally within 30 seconds.",
    REVIEW_REVIEW: "Review",
    CAN_NOT_START_WITH_NUMBER: "Can not start with number",
    PACKAGE_NAME: "Package Name",
    OG_PRICE: "Original Price",
    INSURANCE_NAME: "Insurance Name",
    USER_ALREADY_BEEN_TAKEN:
      "Username already been taken, please try another one.",
    INVALID_FORMAT:
      "Username might be invalid (eg. username can't start with number or contains spaces)",
    LOGIN_USERNAME: "Login Username",
    CONNECT_FAILED: "Unable to connect to the AI service",
    CONNECTING_AI: "Connecting to AI",
    U_CAN_NOW_START_SPEAKING: "You can now start speaking",
    UNIT_NO_SHOP_NO: "Unit No./Shop No.",
    STREET_NO: "Street No.",
    STREET_NAME: "Street Name",
    CLINIC_NAME_IS_REQUIRED: "Clinic name is required",
    CLINIC_CREATED: "Clinic created",
    PERSONAL_WEB: "My Site",
    SLUG_CHAR_TYPE_LIMIT: "Only letters, numbers, and ‘-’ are allowed.",
    CHECK_THIS_CLINIC_PACKAGES: "Check this clinic current packages",
    TYPE_TO_SEARCH: "Type to search",
    PLEASE_ENTER_VALID_PHONE_NUMBER: "Please enter a valid phone number",
    NO_AVAILABLE_PACKAGES: "No available packages found",
    PLEASE_PURCHASE_PACKAGE_FIRST:
      "Please purchase a VIP package before inviting users",
    PLEASE_PURCHASE_PACKAGE_FIRST_TO_APPROVE_PRACTITIONER_TO_JOIN:
      "Please purchase a package before approving this practitioner to join",
    ASSIGNED_TO: "Assigned To",
    PERSONAL: "Personal User (Myself)",
    RECEIPT_GENERATING: "Generating receipt",
    RECEIPT_GENERATING_PLZ_WAIT: "Generating receipt, please wait.",
    INSTRUCTION_GENERATING: "Generating instruction",
    STREET_TYPE: "Street Type",
    SUMMARY: "Review & Summary",
    FEATURE_PREVIEW_VIDEO_NOTE:
      "This video is a feature preview. Purchase the corresponding VIP plan to unlock this function.",
    FEATURE_PURCHASE_HINT_FOR_CLINIC_OWNER:
      "If you are the clinic owner, please click the button below to purchase.",
    TODAY: "Today",
    CLOSED_TODAY: "Not Working Here Today",
    GENERATING_NEW_WINDOW_MSG:
      "The file will open in a new window. Please check your browser settings and allow pop-ups.",
    DISCONNECTED_SUCCESSFULLY: "Disconnected successfully",
    PATIENT_VISIT_FLOW: "Patient Visit Guide Tutorial",
    PATIENT_CHECKIN_AND_VISIT:
      "An overview of the complete patient visit workflow, including both appointment and walk-in scenarios, patient check-in, record creation, and consultation entry.",
    SYSTEM_SETTING_SUMMARY: "System Settings Overview Tutorial",
    SYSTEM_SETTING_OVERVIEW:
      "A quick overview of the main configuration features and entry points in Healthnex.",
    SYSTEM_SETTING_WORK_TIME_SETTING:
      "System Settings - Work Time Settings Tutorial",
    SYSTEM_SETTING_WORKTIME:
      "A step-by-step guide on how to set up and manage practitioner work time schedules within the system.",
    APPOINTMENT_SUMMARY: "Appointment Overview Tutorial",
    APPOINTMENT_SUMMARY_DESCRIPTION:
      "An overview of how appointments work in Healthnex and the different ways they can be created.",
    APPOINTMENT_CREATE: "Appointment - Creating Appointments Tutorial",
    HOW_TO_CREATE_APPOINTMENT:
      "A step-by-step guide on how to create appointments for patients, including selecting services, practitioners, and time slots. Learn how to create appointments via the practitioner portal, personal website, or Healthnex homepage.",
    APPOINTMENT_MANAGE: "Appointment - Managing Appointments Tutorial",
    VIEW_EDIT_CANCEL_APPOINTMENT:
      "Learn how to view, edit, reschedule, and cancel appointments within the Healthnex system.",
    PRESCRIPTION_SUMMARY: "Prescription Overview Tutorial",
    PRESCRIPTION_SUMMARY_DESCRIPTION:
      "An overview of the intelligent consultation and prescription workflow and its five main steps.",
    PRESCRIPTION_SYMPTOM: "Prescription - Symptom Tutorial",
    PRESCRIPTION_SYMPTOM_DESCRIPTION:
      "Quickly record patient symptoms using voice or text, with AI-assisted structuring and translation.",
    PRESCRIPTION_DIAGNOSIS: "Prescription - Diagnosis Tutorial",
    PRESCRIPTION_DIAGNOSIS_DESCRIPTION:
      "Record clinical assessments, select treatment principles, and generate standardized diagnosis content.",
    PRESCRIPTION_TREATMENT: "Prescription - Treatment Tutorial",
    PRESCRIPTION_TREATMENT_DESCRIPTION:
      "Select treatment methods such as herbal medicine or acupuncture, complete prescriptions, and save reusable clinic templates.",
    PRESCRIPTION_PAYMENT: "Prescription - Payment Tutorial",
    PRESCRIPTION_PAYMENT_DESCRIPTION:
      "Review fees, apply insurance if applicable, and complete payment for the visit.",
    PRESCRIPTION_CONCLUSION: "Prescription - Conclusion Tutorial",
    PRESCRIPTION_CONCLUSION_DESCRIPTION:
      "Review the complete medical record, print prescriptions and receipts, and finalize the visit.",
    PERSONAL_WEBSITE_SUMMARY: "Personal Website Overview Tutorial",
    PERSONAL_WEBSITE_OVERVIEW:
      "An overview of the practitioner’s personal website, including profile sections and booking features.",
    EDIT_AND_PUBLISH: "Personal Website - Edit and Publish Tutorial",
    EDIT_AND_PUBLISH_WEBSITE:
      "A step-by-step guide on how to edit your personal website content, preview the layout, and publish it for patient booking.",
    PATIENT_VISIT_FLOW: "Patient Visit Guide Tutorial",
    PATIENT_CHECKIN_AND_VISIT:
      "An overview of the complete patient visit workflow, including both appointment and walk-in scenarios, patient check-in, record creation, and consultation entry.",
    SYSTEM_SETTING_SUMMARY: "System Settings Overview Tutorial",
    SYSTEM_SETTING_OVERVIEW:
      "A quick overview of the main configuration features and entry points in Healthnex.",
    SYSTEM_SETTING_WORK_TIME_SETTING:
      "System Settings - Work Time Settings Tutorial",
    SYSTEM_SETTING_WORKTIME:
      "A step-by-step guide on how to set up and manage practitioner work time schedules within the system.",
    APPOINTMENT_SUMMARY: "Appointment Overview Tutorial",
    APPOINTMENT_SUMMARY_DESCRIPTION:
      "An overview of how appointments work in Healthnex and the different ways they can be created.",
    APPOINTMENT_CREATE: "Appointment - Creating Appointments Tutorial",
    HOW_TO_CREATE_APPOINTMENT:
      "A step-by-step guide on how to create appointments for patients, including selecting services, practitioners, and time slots. Learn how to create appointments via the practitioner portal, personal website, or Healthnex homepage.",
    APPOINTMENT_MANAGE: "Appointment - Managing Appointments Tutorial",
    VIEW_EDIT_CANCEL_APPOINTMENT:
      "Learn how to view, edit, reschedule, and cancel appointments within the Healthnex system.",
    PRESCRIPTION_SUMMARY: "Prescription Overview Tutorial",
    PRESCRIPTION_SUMMARY_DESCRIPTION:
      "An overview of the intelligent consultation and prescription workflow and its five main steps.",
    PRESCRIPTION_SYMPTOM: "Prescription - Symptom Tutorial",
    PRESCRIPTION_SYMPTOM_DESCRIPTION:
      "Quickly record patient symptoms using voice or text, with AI-assisted structuring and translation.",
    PRESCRIPTION_DIAGNOSIS: "Prescription - Diagnosis Tutorial",
    PRESCRIPTION_DIAGNOSIS_DESCRIPTION:
      "Record clinical assessments, select treatment principles, and generate standardized diagnosis content.",
    PRESCRIPTION_TREATMENT: "Prescription - Treatment Tutorial",
    PRESCRIPTION_TREATMENT_DESCRIPTION:
      "Select treatment methods such as herbal medicine or acupuncture, complete prescriptions, and save reusable clinic templates.",
    PRESCRIPTION_PAYMENT: "Prescription - Payment Tutorial",
    PRESCRIPTION_PAYMENT_DESCRIPTION:
      "Review fees, apply insurance if applicable, and complete payment for the visit.",
    PRESCRIPTION_CONCLUSION: "Prescription - Conclusion Tutorial",
    PRESCRIPTION_CONCLUSION_DESCRIPTION:
      "Review the complete medical record, print prescriptions and receipts, and finalize the visit.",
    PERSONAL_WEBSITE_SUMMARY: "Personal Website Overview Tutorial",
    PERSONAL_WEBSITE_OVERVIEW:
      "An overview of the practitioner’s personal website, including profile sections and booking features.",
    EDIT_AND_PUBLISH: "Personal Website - Edit and Publish Tutorial",
    EDIT_AND_PUBLISH_WEBSITE:
      "A step-by-step guide on how to edit your personal website content, preview the layout, and publish it for patient booking.",
    RESET_PASSWORD: "Reset Password",
    PLEASE_ENTER_YOUR_CURRENT_PASSWORD: "Please enter your current password",
    PLEASE_ENTER_DIFFERENT_PASSWORD:
      "Please enter a different password from the current one",
    CONFIG_PRINT_UNIT_IN_EACH_CMT:
      "Note: The dosage unit printed will follow the settings within each individual Chinese medicine prescription.",

    AT_LEAST_ONE_PRINT_OPTION_REQUIRED:
      "Please select at least one unit to display.",

    CHECKBOX_SHOW_RAW_UNIT_IN_PRINT:
      "Tick to display raw herb dosage when printing.",

    CHECKBOX_SHOW_GRAN_UNIT_IN_PRINT:
      "Tick to display granule dosage when printing.",
    SHOW_RAW_UNIT_IN_PRINT: "Show raw herb unit in print",
    HIDE_RAW_UNIT_IN_PRINT: "Hide raw herb unit in print",

    SHOW_GRAN_UNIT_IN_PRINT: "Show granule unit in print",
    HIDE_GRAN_UNIT_IN_PRINT: "Hide granule unit in print",

    CONNECTION_FAILED: "Connection Failed",
    PURCHASED_AT: "Purchased At",
    SELECTED: "Selected",
    PERSONALIZATION: "Personalisation",
    PERSONALIZE_YOUR_SYSTEM: "Personalise your system",
    APPOINTMENT_TIMESLOT_STYLE: "Appointment Timeslot Style",
    DROPDOWN_STYLE: "Dropdown Style",
    SLIDE_STYLE: "Button Style",
    PERSONALIZE_YOUR_TIMESLOT_STYLE: "Personalise your timeslot style",
    FORM_HAS_NOT_BEEN_SAVED_U_SURE_LEAVE_NOW:
      "This form has not been saved, are you sure to leave now?",
    PAGE_NOT_FOUND: "Page Not Found",
    THE_REQUESTED_PAGE_COULD_NOT_BE_LOCATED:
      "The requested page could not be located",
    WE_COULDNT_FIND_THE_PAGE_YOU_ARE_LOOKING_FOR_IT_MAY_HAVE_BEEN_MOVED_DELETED_OR_THE_URL_MIGHT_BE_INCORRECT:
      "We couldn't find the page you're looking for. It may have been moved, deleted, or the URL might be incorrect.",
    WHAT_YOU_CAN_DO: "What you can do",
    CHECK_THE_URL_FOR_TYPOS_AND_TRY_AGAIN:
      "Check the URL for typos and try again",
    USE_THE_NAVIGATION_MENU_TO_FIND_WHAT_YOU_NEED:
      "Use the navigation menu to find what you need",
    CONTACT_SUPPORT_IF_THE_PROBLEM_PERSISTS:
      "Contact support if the problem persists",
    NEED_ASSISTANCE_CONTACT_SYSTEM_SUPPORT:
      "Need assistance? Contact us through Healthnex offical website",
    GO_TO_LOGIN: "Go to Login",
    CUSTOMER_SERVICE: "Customer Service",
    TECHNICAL_SUPPORT: "Technical Support",
    PATIENT_LIST: "Patient List",
    CREATED_AT: "Created At",
    FILTER_BY_LAST_NAME: "Filter by Last Name",
    VIEW_PATIENT_INFO: "View Patient Information",
    TOTAL_PATIENTS: "Total Patients",
    THIS_IS_A_X_USER_PACKAGE: "{{X}}-user package",
    THIS_IS_A_X_USER_PACKAGE_MSG:
      "This package is priced for {{X}} users and already includes a bundled discount.",
    X_USERS_PER_YEAR: "{{X}} users / year",
    X_USERS_PER_Y_YEAR: "{{X}} users / {{Y}} years",
    X_USERS_PER_MONTH: "{{X}} users / month",
    SECTION_CHANGED_TO: "Section changed to",
    OTHER_NON_ENGLISH_PATIENT_FIRST_NAME: "Other non-English First Name",
    WELCOME_TO_HEATHNEX: "Welcome to Healthnex!",
    THIS_PLATFORM_IS_DESIGNED_TO_PROVIDE_A_MODERN_AND_EFFICIENT_WAY_TO_MANAGE_YOUR_CLINIC_PRESCRIPTION:
      "Healthnex is a modern clinical management platform designed to streamline prescription workflows and improve daily practice efficiency.",
    ALSO_AIMS_TO_BUILD_ALL_IN_ONE_PLATFORM_FOR_MODERN_TCM_PRACTICES:
      "Built specifically for Traditional Chinese Medicine (TCM) practitioners, Healthnex brings together prescription management, treatment planning, and clinical records into one integrated system.",
    TO_START_LET_US_QUICK_INTRODUCE_WUT_WE_HAVE_IN_THIS_SYSTEM:
      "Let’s take a quick tour to help you get started.",
    SYSTEM_NOTICE: "System Notice",
    THIS_REQUIRED_U_TO_HAVE_CLINIC_PACKAGE_SUBSCRIPTION:
      "Access to this feature requires a Clinic Package subscription.",
    CURRENT_WORKING_CLINIC: "Current Working Clinic",
    IF_U_WORKING_IN_MULTIPLE_CLINICS_YOU_CAN_SELECT_THE_CURRENT_WORKING_CLINIC_HERE:
      "If you work with multiple clinics, you can select the clinic you are currently working in here.",
    UR_CURRENT_PACKAGE: "Current Subscription Package",
    PACKAGE_SUBSCRIPTION_ALLOW_YOU_TO_ACCESS_PREMIUM_SERVICE:
      "Subscription Packages grant access to premium features. For example, the Clinic Package enables prescription management and patient management, while the Personal Website Package allows you to publish a publicly accessible personal website.",
    CHANGE_UR_SYSTEM_LANGUAGE_HERE: "Change UR System Language here",
    ACCOUNT_MENU: "Account Menu",
    U_CAN_VIEW_UPDATE_UR_ACCOUNT_DETAIL_HERE_LIKE_PASSWORD:
      "View and update your account information, including password and security settings.",
    VIEW_ALL_UR_PATIENTS_HERE:
      "View and manage all patients associated with your clinic.",
    CREATE_JOIN_MANAGE_UR_CLINIC_HERE:
      "Create, join, or manage your clinics from here.",
    CONFIGURE_WORKING_TIME_IN_CLINIC_FOR_PATIENT_TO_SCHEDULE_APPOINTMENT:
      "Configure clinic working hours to allow patients to schedule appointments.",
    THIS_REQUIRED_U_TO_HAVE_PERSOANL_WEBSITE_PACKAGE_SUBSCRIPTION_TO_PUBLISH:
      "Publishing requires an active Personal Website Package subscription.",
    MORE_TUTORIALS_TO_FOLLOW: "More Tutorials to Follow",
    ALTERNATIVELY_HERE_YOU_CAN_FIND_MORE_TUTORIALS_TO_FOLLOW_ABOUT_HOW_TO_USE_THIS_PLATFORM_IN_DETAIL:
      "Explore step-by-step tutorials to help you better understand and use the platform.",
    VER: "Ver. ",
    URL_NOT_SET: "URL not set",
    TCM_MODE: "Detailed Diagnosis Mode",
    ACUPUNCTURE_MASSAGE_MEDICINE_MODE: "Acupuncture & Massage Mode",
    THIS_PACKAGE_IS_NOT_LONGER_PROVIDED_PLS_CHOOSE_ANOTHER_PACKAGE:
      "This package is no longer available for renewal",
    LOADING_PACKAGES: "Loading Packages",
    OWNER_BUSINESS_SIGNUP: "Business Owner",
    CMBA_INFO: "CMBA Info",
    CMBA_NUMBER: "CMBA Number",
    PLEASE_ENTER_YOUR_CMBA_NUMBER_HERE: "Please enter your CMBA number here",
    NOTE_YOUR_CMBA_NUMBER_WILL_BE_SHOWN_ON_THE_MEDICAL_INVOICE:
      "Note: The CMBA number you entered will be shown on the prescription receipt.",
    UPDATING_CMBA_INFO: "Updating CMBA Info",
    CMBA_INFO_UPDATED: "CMBA Info Updated",
    PLEASE_ENTER_YOUR_CMBA_NUMBER: "Please enter your CMBA number",
    U_CAN_ENTER_MODIFY_UR_CMBA_NUMBER_HERE:
      "You can input or modify your CMBA number here",
    VIEW_EDIT_INSURANCE: "View / Edit Insurance",
    IF_U_NEED_TO_RENEW_PLS_CONTACT_CLINIC_OWNER:
      "If you need to renew or subscribe a new package, please contact the clinic owner.",
    INVITE_U_TO_JOIN_THE_CLINIC: "Invite you to join the clinic",
    U_HAD_LEFT_FROM_BELOW_CLINICS: "You have left from the following clinics",
    GO_CLINIC: "View in Clinic",
    FROM_X_CLINIC: "From {{X}}",
    CREATED_IN_CLINIC: "Created in Clinic",
    PLEASE_SELECT_A_PACKAGE_FOR_THIS_PRACTITIONER:
      "Please select a package for this new practitioner:",
    NEW_DURATION: "Duration",
    OTHER_PHONE: "Other Phone",
    GST_INCLUDED: "GST Included",
    SHOW_GST_DETAIL: "Show GST Detail",
    COLLAPSE: "Collapse",
    THIS_PRICE_INCLUDES_GST: "This price includes GST",
    FILTER_BY_INSURANCE_PROVIDER: "Filter by Medical Fund",
    FILTER_BY_COMPLETION_STATUS: "Filter by Completion Status",
    PATIENT_INSURANCES: "Patient Insurances",
    OTHER_PROVIDERS: "Other Providers",
    WELCOME_BACK: "Welcome back",
    CREATED_IN: "Created In",
    COLLAPSE_NAVIGATION: "Collapse Navigation",
    EXPAND_NAVIGATION: "Expand Nav",
    PRESCRIPTION_HISTORY: "Prescription History",
    SEARCH_HISTORY_BY_ID_OR_PATIENT_NAME:
      "Search Records by ID or Patient Name",
    VIEW_ALL_PRESCRIPTION_HISTORIES: "View Today / All Prescription Records",
    SEARCH_PACKAGE_BY_ORDER_ID_PACKAGE_NAME:
      "Search Package by Order ID / Package Name",
    ORDER_NUMBER: "Order Number",
    FILL_IN_DETAILS: "Fill in Details",
    NOT_SCHEDULED: "Not Scheduled",
    NO_CLINICS_TO_CREATE_OR_JOIN: "No clinics to create or join",
    ACU_POINT_INFO: "Acupuncture Point Info",
    ACU_POINT_CN: "Acupuncture Point Name (Chinese)",
    ACU_POINT_EN: "Acupuncture Point Name (English)",
    PLZ_INPUT_ACU_POINT_CN: "Please input acupuncture point name in Chinese",
    PLZ_INPUT_ACU_POINT_EN: "Please input acupuncture point name in English",
    PLZ_INPUT_ACU_POINT_X: "Please input acupuncture point name in {{X}}",
    ADD_ACU_POINT: "Add Acupuncture Point",
    POINT_CREATED: "Acupuncture point created",
    ONLY_PAID_HISTORY_WILL_BE_SHOWN_BELOW:
      "Note: Only paid records will be shown below",
    ME_ONLY: "Me Only",
    PREFERRED_NAME: "Preferred Name",
    SELECT_PAIN_CONDITION: "Select Pain Condition",
    CLICK_TO_ADD_CONDITION: "Click to add pain condition",
    SELECT_CATEGORY_BELOW_TO_ADD_CONDITION: "Select a category below to add a condition",
    PAIN_CONDITIONS: "Pain Conditions",
    SELECT_POINTS_FOR_THIS_TREATMENT: "Select points for this treatment",
    THIS_IS_OPTIONAL:
      "This is optional, you can click button to skip this step.",
    COMMON_ACU_GROUP_TITLE: "Common Acupuncture Point Groups",
    SEARCH_ACU_GROUP_PLACEHOLDER: "Search acupuncture point group name",
    NO_ACU_GROUP_FOUND: "No acupuncture point group found",
    NO_TREATMENT_ADDED: "No treatment added",
    TREATMENT_AMOUNT: "Number of Treatments",
    ENTER_TREATMENT: "Enter treatment",
    CLINIC_GROUP: "Clinic Group",
    FROM_RECORD: "From record",
    X_RELATED_RECORDS: "{{X}} related records",
    RELATED_RECORDS: "Related Record(s)",
    REFRESHING: "Refreshing",
    CONFIGURE_PRODUCTS: "Configure Service Items & Products",
    SYSTEM_ACU_GROUP: "System Acupuncture Point Groups",
    COMPLETED: "Completed",
    IS_RECORD_COMPLETED: "Record Completed",
    RECORD_INCOMPLETE: "Incomplete",
    HIDE_INSTRUCTION: "Hide Instruction",
    VIEW_INSTRUCTION: "View Instruction",
    HIDE_DETAIL: "Hide Detail",
    PRICE_REQUIRED: "Current price is 0",
    PLEASE_FILL_IN_TREATMENT_PRICE: "Please fill in the price",
    TREATMENT_SUBTOTAL: "Treatment Subtotal",
    OTHER_FEE_SUBTOTAL: "Other Fee Subtotal",
    POINTS: "Points",
    TREATMENT_INSTRUCTION: "Treatment Instruction",
    CONFIGURE_CLINIC_POINTS: "Configure Clinic Points",
    CLINIC_POINTS: "Clinic Points",
    POINTS_NAME: "Point Name",
    POINTS_NAME_IN_X: "Point Name ({{X}})",
    QUICK_PAY: "Quick Create Case",
    TREATMENT_FEE: "Treatment Fee",
    UPLOAD_PHOTOS: "Upload Photos",
    CLICK_TO_EXPAND: "Click to Expand",
    CLICK_TO_COLLAPSE: "Click to Collapse",
    SELECT_TREATMENT_TYPE: "Select Treatment Type",
    QUICK_CREATE_TREATMENT: "Quick Create Treatment",
    SELECT_ACU_GROUP: "Select Acupuncture Point Group",
    SELECT_TREATMENT: "Select Treatment",
    NO_AVAILABLE_TREATMENT:
      "No massage or acupuncture service categories configured yet. Please configure via Healthnex Desktop → Clinic & Staff Management",
    NO_AVAILABLE_TREATMENTS:
      "No available treatment, please add working services in clinic settings first",
    FREQUENTLY_USED_ACU_GROUP: "Frequently Used Acupuncture Point Groups",
    USED: "Used Times",
    MOST_USED: "Most Used",
    EXPAND: "Expand",
    FILTERED_BY_PAID_AT: "Filtered by Paid At",
    FILTERED_BY_CREATED_AT: "Filtered by Created Time",
    NO_NEW_PATIENT_CREATED_WITHIN_X:
      "No new patient records were created during {{X}}",
    NO_NEW_PRESCRIPTION_PAID_WITHIN_X:
      "No new prescription records were paid during {{X}}",
    HEAD_FACE: "Head/Face",
    SHOULDER_NECK_BACK: "Shoulder/Neck/Back",
    ABDOMEN: "Abdomen",
    HAND: "Hand",
    LEG: "Leg",
    FOOT: "Foot",
    WAIST: "Waist",
    SHOULDER_NECK: "Shoulder/Neck",
    NECK_BACK: "Neck/Back",
    ARM: "Arm",
    YOU_HAVE_EXCEEDED_THE_MAXIMUM_NUMBER_OF_RETRIES:
      "You have exceeded the maximum number of retries, please try again later.",
    PRESCRIPTION_NOT_READY:
      "The prescription is not ready yet, please try again later.",
    PRODUCT_MANAGEMENT: "Product & Service Management",
    SERVICE: "Service",
    PRODUCT: "Product",
    NO_SERVICE_FOUND: "No service added",
    NO_PRODUCT_FOUND: "No product added",
    CREATE_SERVICE_AND_PRODUCT: "Add Service Item and Service Product",
    CREATE_SERVICE: "Add Service Item",
    CREATE_PRODUCT: "Add Service Product",
    EDIT_SERVICE: "Edit Service Item",
    EDIT_PRODUCT: "Edit Service Product",
    NO_SERVICE_OR_PRODUCT_FOUND:
      "Please select an existing service item on the left to view, or click the button below to create a new service item or service product.",
    SERVICE_BASIC_INFO: "Service Item Basic Info",
    SERVICE_DESCRIPTION: "Service Item Description",
    NAME_ENGLISH: "Name (English)",
    NAME_CHINESE: "Name (Chinese)",
    DESCRIPTION_CHINESE: "Description (Chinese)",
    DESCRIPTION_ENGLISH: "Description (English)",
    DETAILS: "Details",
    PRACTITIONERS_PRODUCT_SETTING: "Practitioner Assignment",
    CONFIGURE_PRACTITIONERS_FOR_THIS_PRODUCT:
      "Configure Practitioners for this Service Product",
    DEFAULT_PRICE: "Default Price",
    ENABLED: "Is Enabled",
    ENABLE: "Is Enabled",
    CUSTOM_PRICE: "Custom Price",
    NEW_PRACTITIONERS_ARE_ABLED_BY_DEFAULT:
      "New Practitioners are Enabled by Default",
    CUSTOM_PRICE_OVERRIDES_DEFAULT_PRICE:
      "Custom Price Overrides Default Price",
    LEAVE_CUSTOM_PRICE_EMPTY_TO_USE_DEFAULT_PRICE:
      "Leave Custom Price Empty to Use Default Price",
    PRODUCT_DESCRIPTION: "Service Product Description",
    NO_MODALITY_SELECTED: "No Service Type Selected",
    PRODUCTS: "Service Products",
    SERVICE_INFO: "Service Item Info",
    FIELDS_MARKED_WITH_ASTERISK_ARE_REQUIRED:
      "Fields Marked with * are Required",
    SELECT_MODALITY: "Select Service Type",
    PLEASE_ENTER_NAME_ENGLISH: "Please Enter Name (English)",
    PLEASE_ENTER_NAME_CHINESE: "Please Enter Name (Chinese)",
    PLEASE_ENTER_DESCRIPTION_ENGLISH: "Please Enter Description (English)",
    PLEASE_ENTER_DESCRIPTION_CHINESE: "Please Enter Description (Chinese)",
    PRODUCT_INFO: "Service Product Info",
    SELECT_SERVICE_TYPE: "Select Service Type",
    PRODUCT_NAME: "Service Product Name",
    THIS_ITEM: "this item",
    ASSIGN_PRACTITIONERS: "Practitioner Assignment",
    BED_NUM_IF_APPLIED: "Bed Capacity for MAS / ACU (If Applicable)",
    BED_NUM_IF_APPLIED_DESCRIPTION:
      "Only applies when assigning bookable products to clinic members and the clinic needs to limit concurrent capacity by bed or room availability. If the clinic only provides TCM services, this setting is usually not needed—leave it as 1 by default. The minimum value is 1 bed.",
    WORK_CAPACITY: "Max number of clients served simultaneously (MAS / ACU)",
    WORK_CAPACITY_DES:
      "Set the maximum number of clients this staff member can serve at the same time. Minimum is 1, and it cannot exceed the clinic’s bed capacity.",
    CLINIC_FORM_STEP_BASIC_SUB: "Your clinic's name and how patients can reach you.",
    CLINIC_FORM_STEP_ADDRESS_SUB: "Where is your clinic located?",
    CLINIC_FORM_STEP_CAPACITY_TITLE: "Capacity & opening hours",
    CLINIC_FORM_STEP_CAPACITY_SUB: "How many people your clinic can see, and when you're open.",
    CLINIC_FORM_STEP_FEES_SUB: "Optional — set prices for the services you offer. You can add these later too.",
    CASE_CREATED: "Medical record created",
    NO_AVAILABLE_TREATMENT_TYPE:
      "No other modalities configured. Using TCM massage by default.",
    PATIENTS_CREATED_BY: "Patients Created By",
    PRESCRIPTION_PAID_AT: "Record Diagnosis Time",
    LEFT_ARM: "Left Arm",
    RIGHT_ARM: "Right Arm",
    LEFT_LEG: "Left Leg",
    RIGHT_LEG: "Right Leg",
    LEFT_HAND: "Left Hand",
    RIGHT_HAND: "Right Hand",
    LEFT_FOOT: "Left Foot",
    RIGHT_FOOT: "Right Foot",
    LEFT_WAIST: "Left Waist",
    RIGHT_WAIST: "Right Waist",
    SERVICE_PRODUCT_LIST: "Service Product List Of This Service Item",
    ASSIGNED_PRACTITIONERS: "Number Of Assigned Practitioners",
    PRODUCT_SERVICE: "Belongs to Service",
    ASSIGNED: "Assigned",
    UNASSIGNED: "Unassigned",
    ASSIGN_OR_NOT: "Assign or Not",
    PLEASE_ENTER_NAME: "Please Enter Name",
    PLEASE_ENTER_DESCRIPTION: "Please Enter Description",
    SERVICE_NAME: "Service Item Name",
    PRODUCT_INCLUDED: "Service Product Number",
    EDIT_PRODUCT_INFO: "Edit Service Product Info",
    EDIT_PRACTITIONERS_PRODUCT_SETTING:
      "Edit Practitioners Service Product Assignment",
    SERVICE_PROJECT: "Service Item",
    SELECT_WORKING_SERVICES: "Select Service Type for this Service Item",
    SELECT_SERVICE_PROJECT: "Select Service Item for this Service Product",
    SERVICE_EXPLANATION:
      "Service items are used to define a type of service, such as head massage, back massage, etc. Subsequent service products will be based on this service item to set prices and durations.",
    NO_PRACTITIONERS_FOR_THIS_SERVICE:
      "There are no practitioners available for this service type. Please go to configure the service type, or contact the relevant practitioners to complete the configuration.",
    PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION_FOR_TCM:
      "You can manage your clinic’s patient information and medical records, and create prescriptions for patients in TCM mode",
    PRESCRIPTION_MEDICAL_HISTORY_FOR_TCM:
      "Prescription and Medical History Guide - TCM Mode",
    PRESCRIPTION_MEDICAL_HISTORY_FOR_MASSAGE:
      "Prescription and Medical History Guide - Massage Mode",
    PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION_FOR_MASSAGE:
      "You can manage your clinic’s patient information and medical records, and create prescriptions for patients in Massage mode",
    NAME_IS_REQUIRED: "Please enter a name",
    INVALID_PRICE: "Please enter a valid price",
    INVALID_DURATION: "Please enter a valid duration",
    NO_PRODUCTS_AVAILABLE_FOR_THIS_PRACTITIONER:
      "No service products available for this practitioner",
    ADD_CUSTOMISED_SERVICE: "Add Custom Service",
    CUSTOM_SERVICE_CREATEDED: "Custom service created",
    U_CAN_ADD_UR_CUSTOMISED_SERVICE_TO_WORK_WITH: "You can create a custom service type to use when creating medical records.",
    INPUT_UR_SERVICE_TYPE_NAME_HERE: "Enter your service type name",
    PLEASE_NOTE_ONLY_YOU_WILL_BE_ABLE_USE_THIS_CUSTOMISED_SERVICE: "Please note that only you will be able to use this custom service.",
    PLEASE_NOTE_ONLY_THIS_CLINIC_WILL_BE_ABLE_USE_THIS_CUSTOMISED_SERVICE: "Please note: this customised service can only be used in clinics where you are the Business Owner.",
    TREATMENT_INSTRUCTIONS: "Treatment Instructions",
    DEFAULT_DOB_WARNING: "No date of birth was provided. A default date (01/01/1990) has been used.",
    RESIGN_CONSENT_FORM: "Re-sign Consent Form",
    CONSENT_FORM_DOES_NOT_COVER_DATE_X: "The selected diagnosis date is earlier than the patient's consent form coverage start date ({{X}}). Please have the patient re-sign a consent form before making this change.",
    SAVE_APPOINTMENT_INFO_LOCALLY: "Save Appoint. Details to Device",
    TRANSLATING: "Translating",
    PROCESSING: "Processing",
    OTHER_LANG_CONTENT_GOES_HERE: "Enter content in another language here",
    PLEASE_SELECT_DOWNLOAD_FORMAT: "Please select a download format",
    PDF_FILE: "PDF File",
    WORD_DOC: "Word Document",
    NEXT_MONTH: "Next month",
    PREV_MONTH: "Previous month",
    ALL_TIME: "All Time",
    TCM_MODE_SERVICE_DESC: "Selecting the following service categories will use Detailed Diagnosis Mode when creating a medical record. This mode provides more comprehensive options and allows for more detailed clinical information entry.",
    ACUPUNCTURE_MASSAGE_MEDICINE_MODE_SERVICE_DESC: "Selecting the following service categories will use Acupuncture / Massage Quick Mode when creating a medical record. This mode is designed for massage and manual therapy services, with a simplified prescribing workflow compared with Detailed Diagnosis Mode, making treatment entry faster and easier.",
    MASSAGE_QUICK_MODE: "ACU / MAS Quick Mode",
    TRY_NEW_UI: "Try New Record Form",
    TRY_NEW_UI_INTRO: "This new record form is currently only an interface improvement for Acupuncture / Massage records. It automatically reminds you which required fields are still missing. Everything you fill in is exactly the same as before — only the look has changed. This is a trial feature, so please let us know if you run into any issues, and you can turn it off any time if you don't like it.",
    TRY_NEW_UI_STEP_BY_STEP: "Guided step-by-step prescribing",
    GUIDED_UI_TOGGLE_OLD: "Old UI",
    GUIDED_UI_TOGGLE_NEW: "New UI",
    I_AGREE_AND_SIGN: "I agree and sign",
    PATIENT_SIGN_IN_PERSON: "Patient sign in person",
    AND_X_MORE: "and {{X}} more",
    CLICK_TO_ADD_CONTENT: "Click to add content",
    NO_CONTENT_FILLED: "No content filled",
    CONTENT_FILLED: "Content filled",
    TREATMENT_OUTCOME: "Treatment Outcome",
    TREATMENT_RECOMMENDATION: "Treatment Recommendation",
    SHOW_ALL_SERVICES: "Show All Services",
    SHOW_SERVICE_HAS_PRODUCT: "Show Services with Products",
    UP_TO_X_USERS_INCLUDED: "Up to {{X}} users included",
    PHONE_CONSULTATION: "Phone Consultation",
    PLEASE_CONTACT_US_FOR_THIS_PACKAGE: "Please contact us to create a custom package for your clinic",
    LEFT_CALF: "Left Calf",
    RIGHT_CALF: "Right Calf",
    SHOWING: "Showing",
    SWIPE_OR_USE_ARROWS_TO_VIEW_MORE_PACKAGES: "Swipe or use the arrows to view more packages",
    DOWNLOAD_SICK_CERTIFICATE: "Download Sick Certificate",
    ISSUE_SICK_CERTIFICATE: "Issue Sick Certificate",
    DAY: "Day",
    DAY_VIEW: "Day View",
    PREV_DAY: "Previous Day",
    NEXT_DAY: "Next Day",
    SCROLL_TO_NEXT_BOOKING: "Scroll to next appointments",
    X_BOOKINGS: "Total of {{X}} appointment(s)",
    CREATE_APPOINTMENT_FOR_THIS_DAY: "Create Appointment for this Day",
    PLEASE_SELECT_SERVICE_TYPE_FROM_LEFT_FIRST: "Please select a service type from the left first.",
    UNSELECT_THIS_BODY_PART: "Unselect this body part",
    UNSAVED_BODY_PART_METHOD_CHANGES_DESC: "You have unsaved changes to the selected body parts or techniques. If you close now, these changes will be discarded.",
    CONTINUE_EDITING: "Continue Editing",
    DISCARD_AND_CLOSE: "Discard and Close",

    EDIT_CUSTOMISED_SERVICE: "Edit Customised Service",
    PRIMARY_LANGUAGE: "Primary Language",
    OTHER_LANGUAGES: "Other Languages",
    REQUIRED: "Required",
    OPTIONAL: "Optional",
    TRANSLATE: "Translate",
    TRANSLATE_TO_OTHER_LANGUAGES: "Translate to Other Languages",
    PLEASE_ENTER_ENGLISH_NAME_FIRST: "Please enter the English name first.",
    ENGLISH_NAME_IS_REQUIRED_AND_USED_AS_DEFAULT: "The English name is required and will be used as the default display name.",
    OTHER_LANGUAGE_FIELDS_ARE_OPTIONAL: "Translations are optional. You may edit them manually or generate them automatically.",
    NAME_MODALITY_IN_ENGLISH: "Service English Name",
    NAME_MODALITY_IN_CHINESE: "Service Chinese Name",
    NAME_MODALITY_IN_THAI: "Service Thai Name",
    NAME_MODALITY_IN_VIETNAMESE: "Service Vietnamese Name",
    MODALITY_UPDATED: "Service updated successfully",
    CLICK_TO_EDIT: "Click to edit",
    PRODUCT_DURATION_CANNOT_EXCEED_5_HOURS: "Product duration cannot exceed 5 hours.",
    UNSAVED_CHANGES_WARNING: "Any unsaved changes will be lost. Are you sure you want to continue?",

    // ---- Xero integration ----
    XERO_SETTINGS: "Xero Settings",
    XERO_SETTINGS_HINT: "Connect your clinic's Xero account to push paid visits as invoices for your accountant to review.",
    XERO_CONNECT: "Connect to Xero",
    XERO_RETRY_CONNECT: "Try Again",
    XERO_NOT_CONNECTED_TITLE: "Not connected to Xero",
    XERO_NOT_CONNECTED_DESCRIPTION: "Connect this clinic's Xero organisation to start pushing paid visits as invoices.",
    XERO_CONNECT_SUCCESS: "Connected to Xero",
    XERO_CONNECT_SUCCESS_WITH_ORG: 'Connected to Xero organisation "{{org}}"',
    XERO_CONNECT_FAILED_ACCESS_DENIED: "You cancelled the authorisation on the Xero page.",
    XERO_CONNECT_FAILED_EXCHANGE: "Authorisation failed. Please connect again.",
    XERO_ORGANISATION: "Xero Organisation",
    XERO_CONNECTED_SINCE: "Connected since",
    XERO_DISCONNECT: "Disconnect",
    XERO_DISCONNECT_SUCCESS: "Disconnected from Xero",
    XERO_DISCONNECT_CONFIRM_1: "Once disconnected, you will no longer be able to push visits to Xero.",
    XERO_DISCONNECT_CONFIRM_2: "Invoices already in Xero will not be affected.",
    XERO_DISCONNECT_CONFIRM_3: "You can reconnect at any time.",
    XERO_ACCOUNT_MAPPING: "Revenue Account Mapping",
    XERO_ACCOUNT_MAPPING_HINT: "Choose which Xero account treatment fees and other fees are recorded against.",
    XERO_ACCOUNT_CODES_INCOMPLETE_WARNING: "Account mapping isn't complete yet — pushing invoices to Xero is disabled until both accounts are selected.",
    XERO_TREATMENT_ACCOUNT_CODE: "Treatment Income Account",
    XERO_OTHER_FEE_ACCOUNT_CODE: "Other Fee Account",
    XERO_NO_ACCOUNTS_AVAILABLE: "No revenue accounts are available in this Xero organisation. Please set one up in Xero first.",
    XERO_ACCOUNT_CODES_REQUIRED: "Please select both accounts before saving.",
    XERO_ACCOUNT_CODES_SAVED: "Account mapping saved",
    XERO_AUTOMATION_SETTINGS: "Automation Settings",
    XERO_AUTOMATION_SETTINGS_HINT: "Optional. By default invoices enter Xero as drafts for your accountant to approve manually.",
    XERO_AUTO_SYNC_TOGGLE: "Auto-approve & Apply Payment",
    XERO_AUTO_SYNC_TOGGLE_HINT: "When on, paid visits pushed to Xero are automatically approved and reconciled — no manual step needed in Xero.",
    XERO_AUTO_SYNC_OFF_LABEL: "Off",
    XERO_AUTO_SYNC_OFF_DESCRIPTION: "Invoices stay as drafts in Xero for your accountant to approve manually.",
    XERO_AUTO_SYNC_ON_LABEL: "On",
    XERO_AUTO_SYNC_ON_DESCRIPTION: "Invoices are automatically approved and marked as paid in Xero — no draft step.",
    XERO_PAYMENT_ACCOUNT_CODE: "Bank Account for Payments",
    XERO_NO_BANK_ACCOUNTS_HINT: 'This Xero organisation has no bank accounts yet. Add one in Xero ("Add Bank Account") before turning on auto-apply payment.',
    XERO_BANK_ACCOUNT_NOT_PAYABLE: "does not accept payments",
    XERO_AUTO_SYNC_PAYMENT_ACCOUNT_REQUIRED: "Please select a bank account before turning on auto-apply payment.",
    XERO_AUTO_SYNC_SAVED: "Automation settings saved",
    XERO_INVOICE_SEARCH: "Xero Invoices",
    XERO_PUSH_INVOICE: "Push to Xero",
    XERO_PUSH_NOW: "Push Now",
    XERO_NEVER_PUSHED_HINT: "This visit has never been pushed to Xero. Push it now to create an invoice.",
    XERO_PUSH_SUCCESS: "Pushed to Xero",
    XERO_PUSH_ALREADY_SYNCED: "This visit was already pushed to Xero — showing the existing invoice.",
    XERO_PUSH_DISABLED_NOT_PAID: "Only paid visits can be pushed to Xero.",
    XERO_PUSH_DISABLED_NOT_CONNECTED: "This clinic isn't connected to Xero yet.",
    XERO_INVOICE_NUMBER: "Invoice Number",
    XERO_INVOICE_STATUS: "Xero Invoice Status",
    XERO_INVOICE_STATUS_DRAFT: "Draft",
    XERO_INVOICE_STATUS_SUBMITTED: "Submitted",
    XERO_INVOICE_STATUS_DELETED: "Deleted",
    XERO_INVOICE_STATUS_AUTHORISED: "Approved",
    XERO_INVOICE_STATUS_PAID: "Paid",
    XERO_INVOICE_STATUS_VOIDED: "Voided",
    XERO_SYNCED_AT: "Synced At",
    XERO_SYNC_STATUS_SYNCED: "Synced",
    XERO_SYNC_STATUS_PENDING: "Processing",
    XERO_SYNC_STATUS_FAILED: "Failed",
    XERO_SYNC_STATUS_NEVER_PUSHED: "Never Pushed",
    XERO_ERROR_CLINIC_NOT_SELECTED: "Please select a clinic first.",
    XERO_ERROR_INVALID_TOKEN: "Your session has expired. Please sign in again.",
    XERO_UNKNOWN_ERROR: "Something went wrong. Please try again.",
    XERO_SELECT_ORGANISATION: "Select Xero Organisation",
    XERO_SELECT_ORGANISATION_HINT: "This Xero connection covers more than one organisation. Choose which one this clinic pushes invoices to.",
    XERO_SWITCH_ORGANISATION: "Switch Organisation",
    XERO_CURRENT_ORGANISATION: "Current",
    XERO_SWITCH_ORGANISATION_TO: "Switching to",
    XERO_ORG_SWITCH_SUCCESS: 'Switched to Xero organisation "{{org}}"',
    XERO_SWITCH_ORGANISATION_CONFIRM_INTRO: 'Switch to "{{org}}"? This will clear the following, since they\'re specific to the current organisation:',
    XERO_SWITCH_ORGANISATION_WIPE_ACCOUNTS: "Treatment and other-fee account mapping",
    XERO_SWITCH_ORGANISATION_WIPE_AUTOMATION: "Bank account and automation settings (turned off)",
    XERO_SWITCH_ORGANISATION_CONFIRM_OUTRO: "You'll need to set up account mapping again for the new organisation before you can push invoices.",
  },
};
